import type { Dictionary } from "./types";

export const sv: Dictionary = {
	price_openShopping: "Öppna inköpslistan",
	price_priceBasis: "Prisunderlag",
	price_liveUnavailable: "Butikens priser kunde inte hämtas. Den beräknade materiallistan visas nedan.",
	price_budgetTitle: "Din beräknade byggbudget",
	price_budgetBreakdown: "Så är budgeten beräknad",
	price_budgetRounding: "Avrundning av budget",
	price_missingPrice: "Pris saknas",
	price_missingCount: "{count} materialrader saknar pris och ingår inte i materialbeloppet.",
	price_shopQuote: "Butikens prisförslag",
	price_shopQuoteNote: "Jämför butikens innehåll med materiallistan nedan innan du beställer.",
	price_materialDetails: "Material och beräknade priser",
	instr_phaseSupplies: "Material och kapning i arbetsfasen",
	instr_supplyCounts: "{materials} materialrader · {cuts} kaprader",
	instr_phaseSuppliesNote: "Detta är hela arbetsfasens underlag. Samma fas kan användas i flera byggsteg. Följ stegets instruktioner för vad som ska monteras nu.",
	instr_openCutlist: "Öppna hela kapnotan",
	mat_search: "Sök material eller mått",
	mat_searchResults: "{visible} av {total} materialrader",
	mat_searchBudgetNote: "Budget och transportvikt gäller hela projektet.",
	mat_noResults: "Inga material matchar din sökning.",
	cut_openBuild: "Öppna byggguiden",
	cut_localPreferences: "Handelslängder sparas för detta projekt på den här enheten",
	cut_savedTooShort: "{dimension} mm: sparad handelslängd {length} mm är för kort för de nya kapmåtten. Auto används tills du väljer en längre längd.",
	cut_search: "Sök del eller mått",
	cut_noResults: "Inga delar matchar din sökning.",
	cut_purchaseOverview: "{count} handelslängder · {dimensions} dimensioner",
	cut_purchaseSummary: "Inköp enligt kapplanen",
	cut_purchaseNote: "Översikten gäller hela kapplanen. Delar som kräver separat planering visas nedan.",
	cut_purchaseBoards: "{count} st × {length} mm",
	cut_stockTooShort: "För kort för längsta delen",
	cut_clearSearch: "Rensa sökning",

	/* ── App-wide ────────────────────────────────────────── */
	app_name: "Bygg en bastu",

	/* ── Navigation ──────────────────────────────────────── */
	nav_home: "Hem",
	nav_dashboard: "Mina Projekt",
	nav_signIn: "Logga in",
	nav_signOut: "Logga ut",

	/* ── Landing page ────────────────────────────────────── */
	landing_title: "Bygg bastun i skogen innan du bygger den på riktigt.",
	landing_subtitle:
		"Rita din utomhusbastu i 3D, se den i kvällsljus och ta med dig materiallistan till bygghandeln.",
	landing_feature3d: "3D-modell i realtid",
	landing_featureMaterials: "Automatisk materiallista",
	landing_featureCutlist: "Kapnota med exakta mått",
	landing_featureRules: "Enligt BBR & brandkrav",
	landing_primaryCta: "Börja designa",
	landing_goToProjects: "Gå till mina projekt →",
	landing_typeSquare: "Fyrkantig",
	landing_typeBarrel: "Bastutunna",
	landing_typeTwoRoom: "Med relaxdel",
	landing_ctaNote: "Gratis. Du behöver inget konto för att börja.",
	landing_typesTitle: "Välj en grundform",
	landing_typeSquareDesc: "Ett rum",
	landing_typeTwoRoomDesc: "Basturum och relaxdel under samma tak",
	landing_filmPlanTitle: "{size} mm. Bastu, relaxdel och utsikt mot sjön.",
	landing_filmPlanBody: "Det här är {preset}, en av tre planlösningar för tvårumsbastun. Alla mått, dörrar och fönster går att ändra.",
	landing_filmListsTitle: "{rows} rader att köpa. {cuts} rader i kapnotan.",
	landing_filmListsBody: "Varje regel, bräda och skruvpaket i modellen hamnar i listorna, med längd och antal.",
	landing_filmPriceTitle: "Ungefär {price} i material.",
	landing_filmPriceBody: "Priset räknas om när du ändrar mått, panel eller aggregat.",
	landing_filmPriceCta: "Rita din egen bastu",
	landing_stepsTitle: "Så går det till",
	landing_step1Title: "Välj en form",
	landing_step1Body: "Ett rum, eller två rum med relaxdel. Allt går att ändra efteråt.",
	landing_step2Title: "Dra i väggarna",
	landing_step2Body: "Mått, dörrar, fönster och lavar ändras direkt i 3D-modellen.",
	landing_step3Title: "Ta med listorna",
	landing_step3Body: "Inköpslista, kapnota och bygganvisning, med aggregat, ventilation och avstånd kontrollerade.",
	landing_outputsTitle: "Det här får du ut",
	landing_output3dDesc: "Vrid och klipp i modellen och se stommen, panelen och laven innan något är köpt.",
	landing_outputMaterialsDesc: "Virke, isolering, panel, skruv och beslag i mängder du kan handla efter, med pris.",
	landing_outputCutlistDesc: "Längd för varje bit, optimerad mot standardlängder så att spillet blir litet.",
	landing_outputRulesDesc: "Aggregatstorlek, säkring, ventilation och skyddsavstånd kontrolleras mot BBR och tillverkarnas krav.",
	landing_referenceDesignsTitle: "Fyra ritningar att börja från",
	landing_referenceDesignsIntro:
		"Jämför en liten vedeldad modell, en elektrisk bastu för fyra och två större tvårumslösningar. Varje förslag har egen plan, materialmängd och budget.",

	/* ── Auth page ───────────────────────────────────────── */
	auth_title: "Välkommen tillbaka",
	auth_subtitle: "Logga in för att hantera dina bastuprojekt",
	auth_emailLabel: "E-post",
	auth_emailPlaceholder: "din@email.se",
	auth_passwordLabel: "Lösenord",
	auth_passwordPlaceholder: "Ange lösenord",
	auth_signInButton: "Logga in",
	auth_signUpButton: "Skapa konto",
	auth_switchToSignUp: "Har du inget konto? Skapa ett",
	auth_switchToSignIn: "Har du redan konto? Logga in",
	auth_forgotPassword: "Glömt lösenordet?",
	auth_errorGeneric: "Något gick fel. Försök igen.",
	auth_titleRegister: "Skapa konto",
	auth_subtitleRegister: "Skapa ett gratis konto för att börja designa.",
	auth_registerSuccess:
		"Konto skapat! Kolla din e-post för att bekräfta, eller logga in direkt.",
	auth_submitting: "Vänta...",
	auth_switchToSignUpLink: "Skapa konto",
	auth_switchToSignInLink: "Logga in",
	auth_passwordShow: "Visa lösenord",
	auth_passwordHide: "Dölj lösenord",

	/* ── Dashboard ───────────────────────────────────────── */
	dashboard_title: "Mina Projekt",
	dashboard_empty: "Du har inga sparade projekt ännu.",
	dashboard_newDesign: "Ny design",
	dashboard_compare: "Jämför",
	dashboard_delete: "Radera",
	dashboard_deleteConfirm: "Är du säker på att du vill radera detta projekt?",
	dashboard_deleteCancel: "Avbryt",
	dashboard_loadError: "Kunde inte ladda dina projekt.",
	admin_deniedTitle: "Åtkomst nekad",
	admin_deniedBody: "Endast superanvändare har tillgång till administrationspanelen.",
	dashboard_welcome: "Här hittar du dina sparade basturitningar.",
	dashboard_newProject: "+ Nytt Projekt",
	dashboard_loading: "Laddar projekt…",
	dashboard_emptyTitle: "Inga projekt ännu",
	dashboard_emptyBody:
		"Skapa ditt första projekt och börja designa din dröm-bastu med 3D-visualisering och exakta materiallistor.",
	dashboard_emptyAction: "Skapa ditt första projekt →",
	dashboard_compareEyebrow: "Jämförelserådgivare",
	dashboard_compareTitle: "Jämför upp till fyra projekt innan du bestämmer dig",
	dashboard_compareSelected: "valda",
	dashboard_compareAction: "Jämför valda",
	dashboard_compareHelper0:
		"Skapa ditt första projekt först. När du har minst två sparade projekt kan rådgivaren jämföra dem.",
	dashboard_compareHelper1:
		"Skapa eller duplicera minst ett till projekt för att låta rådgivaren jämföra alternativen.",
	dashboard_compareHelperNone:
		"Välj 2–4 projekt för att få en rekommendation om vilket som är smartast att bygga.",
	dashboard_compareHelperOne:
		"Välj minst ett projekt till så att rådgivaren kan väga alternativen mot varandra.",
	dashboard_compareHelperMax:
		"Välj högst fyra projekt i taget för att hålla jämförelsen tydlig.",
	dashboard_compareHelperReady:
		"Redo att jämföra. Rådgivaren väger kostnad, drift, byggbarhet och regelrisk.",
	dashboard_typeSquare: "Fyrkantig",
	dashboard_typeBarrel: "Bastutunna",
	dashboard_typeTwoRoom: "Med relaxdel",
	dashboard_typeIndoor: "Inomhus",
	dashboard_ariaCompare: "Jämför",
	dashboard_ariaConfirmDelete: "Bekräfta: ta bort",
	dashboard_cardDelete: "Ta bort",
	dashboard_cardCancel: "Avbryt",
	dashboard_cardLastModified: "Senast ändrad:",
	dashboard_cardOpen: "Öppna →",
	dashboard_defaultName: "Ny Bastu",

	/* ── Wizard ──────────────────────────────────────────── */
	wizard_stepName: "Ge ditt projekt ett namn",
	wizard_stepShape: "Välj form",
	wizard_stepSize: "Ange mått",
	wizard_stepLocation: "Plats & klimat",
	wizard_next: "Nästa",
	wizard_back: "Tillbaka",
	wizard_start: "Börja designa",
	wizard_stepOf: "Steg {step} av {total}",
	wizard_step1Title: "Vilken typ av bastu vill du bygga?",
	wizard_step1Desc: "Välj den form som passar din tomt och stil bäst.",
	wizard_step1Aria: "Välj bastutyp",
	wizard_step2Title: "Hur många ska basta samtidigt?",
	wizard_step2Desc:
		"Vi föreslår en storlek utifrån kapaciteten. Du kan justera exakta mått i nästa steg.",
	wizard_step2Aria: "Välj kapacitet",
	wizard_step2SuggestedSize: "Föreslagen storlek",
	wizard_step3Title: "Hur vill du värma bastun?",
	wizard_step3Desc:
		"Valet påverkar installation, driftskostnad och upplevelse.",
	wizard_step3Aria: "Välj uppvärmning",
	wizard_step4Title: "Var ska bastun stå?",
	wizard_step4Desc:
		"Postnumret ger oss din snözon — det påverkar takbjälkarnas dimension. Du kan hoppa över detta och ange det senare.",
	wizard_step4Hint:
		"Valfritt — utan postnummer används snözon 2.0 som standard.",
	wizard_step4Placeholder: "t.ex. 981 34",
	wizard_step4EstimatedTime: "Uppskattad byggtid:",
	wizard_step4About: "ca",
	wizard_step4Hours: "timmar",
	wizard_step4Weekends: "helger",
	wizard_launchCta: "Börja bygga",
	wizard_typeSquare: "Fyrkantig",
	wizard_typeSquareDesc: "Klassisk bastustuga med raka väggar",
	wizard_typeIndoorDesc: "Bastu i befintligt rum – källare, badrum eller förråd",
	wizard_typeIndoor: "Inomhus",
	wizard_typeBarrel: "Bastutunna",
	wizard_typeBarrelDesc: "Rund och kompakt tunnform",
	wizard_typeTwoRoom: "Med relaxdel",
	wizard_typeTwoRoomDesc: "Bastu + omklädning i ett",
	wizard_capacity2: "2 personer",
	wizard_capacity2Desc: "Kompakt och snabbvärmd",
	wizard_capacity4: "4 personer",
	wizard_capacity4Desc: "Populärast — perfekt för familjen",
	wizard_capacity6: "6 personer",
	wizard_capacity6Desc: "Rymlig — för gänget",
	wizard_heaterWood: "Vedeldad kamin",
	wizard_heaterWoodDesc:
		"Autentisk upplevelse. Kräver skorsten och sotarbesiktning.",
	wizard_heaterElectric: "Elaggregat",
	wizard_heaterElectricDesc:
		"Enklare installation. Kräver 3-fas el (vid >4.5 kW).",
	wizard_permitOk: "Inget bygglov krävs",
	wizard_permitWarning: "Bygglov krävs inom detaljplan",
	wizard_permitError: "Fullt bygglov krävs",

	/* ── Builder tabs ────────────────────────────────────── */
	builder_tabStructure: "Stomme",
	builder_tabMaterials: "Material",
	builder_tabRules: "Regler",
	builder_tabExport: "Export",
	builder_tabBuild: "Byggplan",

	/* ── Rules / safety ──────────────────────────────────── */
	rules_tabLabel: "Regler",
	rules_disclaimerTitle: "Svenska regler och standardkrav",
	rules_disclaimerBody:
		"Reglerna i denna applikation är anpassade efter svenska Boverkets Byggregler (BBR) och räddningstjänstens/sotarens standardkrav. Verktyget ger endast vägledning. Allt byggande sker på egen risk.",
	build_disclaimerTitle: "Byggplan för svensk referens",
	build_disclaimerBody:
		"Kontrollera alltid lokala förutsättningar, men checklistan är skriven för svensk bastubyggnadskontext.",

	/* ── Location / climate ──────────────────────────────── */
	location_inputLabel: "Postnummer",
	location_inputHint:
		"Valfritt — utan postnummer används snözon 2.0 som standard.",
	location_inputPlaceholder: "t.ex. 981 34",
	climate_inputLabel: "Klimatzon",
	climate_inputHint: "Välj närmaste snölastklass för din tomt.",
	location_summaryLabel: "Postnr / zon",
	location_summaryFallback: "Standardzon",

	/* ── Export / PDF ─────────────────────────────────────── */
	export_title: "Materiallista & Prisuppskattning",
	export_disclaimerTitle: "Svensk referens",
	export_disclaimers: [
		"Regler, priser och byggrekommendationer i detta dokument utgår från svensk bastubyggnadskontext.",
		"Kontrollera alltid mått, brandkrav, el och myndighetskrav innan byggstart.",
	],
	export_footer: "Genererad av Bygg en bastu — byggenbastu.se",
	export_downloadPdf: "Ladda ner PDF",
	export_downloadCsv: "Ladda ner CSV",

	/* ── Share ────────────────────────────────────────────── */
	share_title: "Dela din design",
	share_subtitle: "Skicka länken till någon för att visa din bastudesign.",
	share_copyLink: "Kopiera länk",
	share_copied: "Kopierat!",
	share_openBuilder: "Öppna i byggaren",
	share_invalidLink: "Ogiltig delningslänk",
	share_invalidLinkDesc: "Länken verkar vara skadad eller ofullständig.",
	share_backToHome: "Tillbaka till startsidan →",
	share_typeSquare: "Fyrkantig bastu",
	share_typeBarrel: "Bastutunna",
	share_typeTwoRoom: "Bastu med relaxdel",
	share_typeIndoor: "Inomhusbastu",
	share_materialCost: "Materialkostnad",
	share_diyBudget: "Självbyggarbudget",
	share_marketPackage: "Marknadsjämförelse",
	share_estimatedInclVat: "uppskattat inkl. moms",
	share_sessionCost: "Kostnad per session",
	share_heatUpTime: "min uppvärmning",
	share_buildTime: "Byggtid",
	share_permitStatus: "Bygglov",
	share_permitOk: "Krävs ej ✅",
	share_permitWarning: "Anmälan ⚠️",
	share_permitRequired: "Bygglov 🚫",
	share_heatingLabel: "Uppvärmning",
	share_heaterWood: "🔥 Vedeldad kamin",
	share_heaterElectric: "⚡ Elaggregat",
	share_openingsLabel: "Öppningar",
	share_openingsNone: "Inga",
	share_doors: "dörr",
	share_windows: "fönster",
	share_postalCode: "Postnummer",
	share_climateZone: "Klimatzon",
	share_monthlyRunningCost: "Driftskostnad / månad",
	share_roofLabel: "Tak",
	share_foundationLabel: "Grund",
	share_flatTerrain: "plan mark",
	share_createOwn: "Skapa en egen bastu",
	share_generatedBy: "Genererad av",
	share_weekends: "helger",
	share_viewOnly: "Skrivskyddad förhandsgranskning",

	/* ── Shared design page (/d/:id SSR) ──────────────────── */
	design_openInBuilder: "Öppna i byggaren",
	design_viewOnly: "Delad förhandsgranskning",
	design_createOwn: "Skapa en egen bastu",
	design_heaterLabel: "Aggregat",
	design_foundationLabel: "Grund",
	design_buildTimeLabel: "Byggtid",
	design_permitLabel: "Bygglov",
	design_piers: "plintar",
	design_beams: "bärlinor",
	design_hours: "h",
	design_notFoundTitle: "Designen kunde inte hittas",
	design_notFoundBody:
		"Den här bastun finns inte eller är inte delad offentligt.",
	design_backToHome: "Till startsidan",

	/* ── Comparison ──────────────────────────────────────── */
	comparison_title: "Jämför designer",
	comparison_empty: "Välj minst två designer att jämföra.",
	comparison_selectPrompt: "Välj designer att jämföra",
	comparison_loading: "Laddar jämförelsen…",
	comparison_emptyTitle: "Jämförelsen behöver minst två sparade projekt",
	comparison_emptyMissing:
		"valt projekt kunde inte hittas i dina sparade ritningar.",
	comparison_emptyBody:
		"Välj minst två sparade projekt i dashboarden för att få en rekommendation.",
	comparison_backToDashboard: "Tillbaka till mina projekt",
	comparison_eyebrow: "Jämförelserådgivare",
	comparison_recommendedSuffix: "är det tryggaste valet just nu",
	comparison_advisorBody:
		"Rådgivaren väger materialkostnad, drift, regelrisk, bygginsats och praktisk logistik i samma beslutslager.",
	comparison_back: "Tillbaka",
	comparison_recommended: "Rekommenderad lösning",
	comparison_overallScore: "Samlad poäng",
	comparison_overallScoreBody:
		"Högst total balans mellan ekonomi, risk och byggbarhet.",
	comparison_permitStatus: "Bygglovsläge",
	comparison_permitOk: "Lägst myndighetsfriktion i urvalet.",
	comparison_permitWarning:
		"Kräver mer förarbete än ett rent bygglovsbefriat läge.",
	comparison_whyWins: "Varför den här vinner",
	comparison_watchOut: "Att hålla koll på innan beslut",
	comparison_sideBySide: "Jämför sida vid sida",
	comparison_measure: "Mått",
	comparison_best: "Bäst",
	comparison_totalEconomy: "Totalekonomi",
	comparison_approvalRisk: "Godkännanderisk",
	comparison_buildComplexity: "Byggbarhet",
	comparison_practicality: "Praktik",
	comparison_type: "Typ",
	comparison_size: "Storlek",
	comparison_heating: "Uppvärmning",
	comparison_materialCost: "Materialkostnad",
	comparison_diyBudget: "Självbyggarbudget",
	comparison_marketPackage: "Marknadsjämförelse",
	comparison_monthlyCost: "Drift / månad",
	comparison_permit: "Bygglovsläge",
	comparison_buildTimeline: "Byggtid",
	comparison_proSteps: "Fackmannasteg",
	comparison_transport: "Transport",
	comparison_transportNotCalc: "Ej beräknad",

	/* ── Builder Tabs ─────────────────────────────────────── */
	builder_tabMaterialLabel: "Material",
	builder_tabCutlistLabel: "Kapnota",
	builder_tabPriceLabel: "Pris",
	builder_tabFoundationLabel: "Grund",
	builder_tabInstructionsLabel: "Instruktioner",
	builder_tabBBRLabel: "BBR / Sotare",
	builder_fabDownloadPdf: "Ladda ner PDF",
	builder_fabRenderPhoto: "Offertbild",
	builder_fabRendering: "⏳ Renderar...",
	builder_renderTitle: "Fotorealistisk rendering",
	builder_renderAlt: "Renderad bastu",
	builder_renderDownload: "Ladda ner",
	builder_barrel_deprecated_title:
		"Bastutunna är inte längre aktiv för nya designer",
	builder_barrel_deprecated_body:
		"Du kan fortsätta redigera den här sparade tunnan, men motorn underhålls inte längre. Vi rekommenderar att migrera nya projekt till TwoRoom Panorama.",
	builder_barrel_deprecated_cta: "Migrera till Sjöstuga",
	builder_barrel_saveDeprecatedTitle: "Spara bastutunna?",
	builder_barrel_saveDeprecatedBody:
		"Barrel är inte längre aktiv — fortsätt på egen risk eller migrera till TwoRoom Panorama.",
	builder_barrel_saveContinue: "Fortsätt spara",
	builder_barrel_saveMigrate: "Migrera till Sjöstuga",

	/* ── Step Bar ─────────────────────────────────────────── */
	step_designLabel: "Designa",
	step_designSummary: "Mått, öppningar och värme",
	step_materialLabel: "Material",
	step_materialSummary: "Mängder, kaplista och pris",
	step_buildLabel: "Bygg",
	step_buildSummary: "Instruktioner, regler och PDF",
	step_statusDone: "Klar",
	step_statusActive: "Pågår",
	step_statusNext: "Nästa",

	/* ── Dimension Panel ──────────────────────────────────── */
	dim_panelLabel: "Designpanel",
	dim_groupSauna: "Bastu",
	dim_groupAppearance: "Utseende",
	dim_groupConditions: "Förutsättningar",
	vis_layers: "Lager",
	vis_presetsLabel: "Vyer",
	vis_presetFinished: "Färdig",
	vis_presetFraming: "Stomme",
	vis_presetSafety: "Säkerhetszoner",
	camera_exterior: "Exteriör",
	instr_assemblyPiers: "1 · Plintar",
	instr_assemblyBrackets: "2 · Beslag",
	instr_assemblyBeams: "3 · Bärlinor",
	instr_assemblyComplete: "Plintar och bärlinor på plats",
	instr_assemblyPlay: "Visa monteringen",
	instr_assemblyPause: "Pausa",
	instr_assemblyReplay: "Spela igen",
	instr_assemblyProgress: "Monteringens förlopp",
	instr_assemblyHint: "Principskiss: plintar, beslag och bärlinor. Följ mått och infästningar i stegets instruktioner.",
	film_title: "Bygganimation",
	film_play: "Spela",
	film_pause: "Pausa",
	film_prevStep: "Föregående steg",
	film_nextStep: "Nästa steg",
	film_stepOf: "Scen {current} av {total}",
	film_stepProgress: "Stegets förlopp",
	film_kitLabel: "Delar och verktyg i steget",
	film_planLabel: "Plan",
	film_scopeGuideStep: "Det här momentet",
	film_scopeWholeBuild: "Hela bygget",
	film_hint: "Orange delar monteras i det här steget, grått är redan byggt. Antalen räknas ur din ritning.",
	film_stepPlinths: "Sätt och vattenpassa plintarna",
	film_stepPostShoes: "Montera stolpskorna",
	film_stepBeams: "Lägg bärlinorna",
	film_stepFloorJoists: "Lägg golvbjälkarna",
	film_stepFloorInsulation: "Trossbotten och golvisolering",
	film_stepWallBack: "Res bakväggen",
	film_stepWallSides: "Res sidoväggarna",
	film_stepWallFront: "Res framväggen",
	film_stepRoofJoists: "Lägg takbjälkarna",
	film_stepRoofDeck: "Råspont och taktäckning",
	film_stepWindBarrier: "Sätt upp vindskyddet",
	film_stepFurring: "Spika läkt för luftspalten",
	film_stepCladding: "Panela fasaden",
	film_stepDoorsWindows: "Sätt in dörr och fönster",
	film_stepWallInsulation: "Isolera väggar och tak",
	film_stepVaporBarrier: "Bastufolie och spikläkt",
	film_stepInnerPanel: "Panela invändigt",
	film_stepBenches: "Bygg lavarna",
	film_stepHeater: "Aggregat, strålskydd och ventiler",
	film_stepChimney: "Dra upp skorstenen",
	film_stepPartition: "Res mellanväggen",
	film_stepPartitionPanel: "Panela mellanväggen och sätt mellandörren",
	film_stepFinish: "Trappsteg och sista detaljerna",
	film_partPlinth: "Betongplint",
	film_partPostShoe: "Stolpsko",
	film_partBeam: "Bärlina",
	film_partFloorJoist: "Golvbjälke",
	film_partSubfloorLedger: "Trossbottenläkt",
	film_partSubfloor: "Trossbotten",
	film_partInsulation: "Isolering",
	film_partStud: "Regel",
	film_partPlate: "Syll och hammarband",
	film_partRoofJoist: "Takbjälke",
	film_partRoofDeck: "Råspont",
	film_partRoofCovering: "Taktäckning",
	film_partWindBarrier: "Vindskydd",
	film_partFurring: "Läkt",
	film_partCladding: "Ytterpanel",
	film_partCornerBoard: "Knutbräda",
	film_partDoor: "Dörr",
	film_partVaporBarrier: "Bastufolie",
	film_partBatten: "Spikläkt",
	film_partSaunaPanel: "Bastupanel",
	film_partBenchFrame: "Lavstomme",
	film_partBenchSlat: "Lavbräda",
	film_partHeater: "Aggregat",
	film_partHeatShield: "Strålskydd",
	film_partChimney: "Skorsten",
	film_partEntryStep: "Trappsteg",
	dim_panelTitle: "Din bastu",
	dim_sectionDimensions: "Mått",
	dim_sectionOpenings: "Öppningar",
	dim_sectionDeck: "Trall",
	dim_sectionRoof: "Tak",
	dim_sectionSite: "Mark & grund",
	dim_sectionThermal: "Termik",
	dim_partitionSplit: "Mellanvägg",
	dim_wallHeightLabel: "Vägghöjd",
	indoor_roomTitle: "Rummet bastun står i",
	indoor_roomSummaryFree: "Står fritt i rummet",
	indoor_roomSummaryWalls: "Mot befintlig vägg: {count}",
	indoor_existingWallsLabel: "Står mot befintlig vägg",
	indoor_existingWallsHint: "En vägg mot rummets vägg får 20 mm luftspalt och träfiberskiva i stället för ytterpanel. Fria väggar får panel direkt på reglarna.",
	indoor_houseAboveLabel: "Hus ovanför bastutaket",
	indoor_houseAboveHint: "Från bastuns innertak till husets nock. Styr hur lång skorstenen blir genom huset.",
	indoor_houseAboveUnset: "{m} m antaget",
	twoRoom_sectionLayout: "Planlösning",
	twoRoom_sectionLabel: "Tvårumsval",
	twoRoom_sectionIntro:
		"Välj en färdig layout eller öppna avancerat för exakta val.",
	twoRoom_presetGroupAria: "Välj planlösningspreset",
	twoRoom_presetClassicTitle: "Klassisk",
	twoRoom_presetClassicDescription: "Kort entré, standardfönster och relaxrum.",
	twoRoom_presetClassicAria: "Välj klassisk planlösning",
	twoRoom_presetLakesideTitle: "Sjöstuga",
	twoRoom_presetLakesideDescription:
		"Lång entré och panoramaglas med separat relaxrum.",
	twoRoom_presetLakesideAria: "Välj sjöstuga med panoramaglas",
	twoRoom_presetOpenTitle: "Öppen Panorama",
	twoRoom_presetOpenDescription:
		"En öppen bastu med lång entré och panoramaglas.",
	twoRoom_presetOpenAria: "Välj öppen panorama utan relaxrum",
	twoRoom_advancedToggle: "Avancerat",
	twoRoom_entryWallLabel: "Entry-vägg",
	twoRoom_entryWallShort: "Kort sida",
	twoRoom_entryWallLong: "Lång sida",
	twoRoom_glazingStyleLabel: "Fönsterstil",
	twoRoom_glazingStandard: "Standard",
	twoRoom_glazingPanorama: "Panorama",
	twoRoom_saunaPositionLabel: "Bastu-position",
	twoRoom_saunaPositionLeft: "Vänster",
	twoRoom_saunaPositionRight: "Höger",
	twoRoom_relaxRoomLabel: "Relax-rum",
	twoRoom_relaxToggleAria: "Slå på eller av relax-rum",
	twoRoom_relaxRoomOnSummary: "Relaxrum",
	twoRoom_relaxRoomOffSummary: "1-rum",
	dim_openingSummaryNone: "Inga öppningar tillagda",
	dim_openingDoorSingular: "dörr",
	dim_openingDoorPlural: "dörrar",
	dim_openingWindow: "fönster",
	dim_openingWindowPlural: "fönster",
	dim_heaterWood: "Vedeldad kamin",
	dim_heaterElectric: "Elaggregat",
	dim_terrainFlat: "Plan mark",

	/* ── Dimension Sliders ────────────────────────────────── */
	slider_sectionLabel: "Mått",
	units_label: "Enheter",
	units_metric: "Metriskt",
	units_imperial: "Imperial",
	units_ariaLabel: "Välj måttenhet",
	slider_reset: "Återställ",
	slider_areaLabel: "Yta (m²)",
	slider_areaAriaLabel: "Golvyta (kvadratmeter)",
	slider_unlockArea: "Lås upp yta",
	slider_lockArea: "Lås yta",
	slider_lengthLabel: "Längd",
	slider_lengthAriaLabel: "Längd: {value} millimeter",
	slider_widthLabel: "Bredd",
	slider_widthAriaLabel: "Bredd: {value} millimeter",
	slider_postalCodeLabel: "Postnummer",
	slider_postalCodePlaceholder: "t.ex. 981 34",
	slider_climateZoneLabel: "Klimatzon",
	slider_clampMax: "Max {value} — justerat till gränsen.",
	slider_clampMin: "Min {value} — justerat till gränsen.",
	slider_clampSeeRules: "Se Regler",

	/* ── Heater Calculator ────────────────────────────────── */
	heaterCalc_metaTitle:
		"Bastuaggregat kW-kalkylator – räkna ut rätt storlek 2026 | Bygg en bastu",
	heaterCalc_metaDescription:
		"Räkna ut hur många kW ditt bastuaggregat behöver. Tar hänsyn till volym, glasareal och sten. Gratis online — öppna direkt som komplett bastuplan.",
	heaterCalc_breadcrumbCalculators: "Kalkylatorer",
	heaterCalc_eyebrow: "GRATIS KALKYLATOR",
	heaterCalc_title: "Bastuaggregat kW-kalkylator",
	heaterCalc_lead:
		"Få ett rätt dimensionerat aggregat på under en minut. Justera mått, glas och stenarea — vi räknar ut effektiv volym, säkring och rekommenderad effekt enligt svensk praxis.",
	heaterCalc_formLabel: "Indata",
	heaterCalc_inputsHeading: "Mått och material",
	heaterCalc_widthLabel: "Bredd (invändigt)",
	heaterCalc_lengthLabel: "Längd (invändigt)",
	heaterCalc_glassLabel: "Glasarea",
	heaterCalc_glassHelp:
		"Summera alla glasdörrar och fönster i bastun. Glas släpper ut mycket mer värme än panel, så varje m² glas räknas som 1,2 m³ extra rumsvolym — det tillägg aggregattillverkarna anger.",
	heaterCalc_stoneLabel: "Obehandlad stenyta",
	heaterCalc_stoneHelp:
		"Innefattar bara obehandlade stenytor på väggar (t.ex. kakelvägg). Räknas inte för bastusten i aggregatet.",
	heaterCalc_heaterTypeLabel: "Typ av aggregat",
	heaterCalc_heaterElectric: "Elaggregat",
	heaterCalc_heaterWood: "Vedeldat",
	heaterCalc_resultEyebrow: "Rekommenderad effekt",
	heaterCalc_resultVolume: "Effektiv volym",
	heaterCalc_resultFuse: "Säkring",
	heaterCalc_resultElectrical: "Elkrav",
	heaterCalc_openInBuilder: "Öppna som komplett bastuplan",
	heaterCalc_ctaHint: "Vill du veta mer om dimensionering?",
	heaterCalc_readGuide: "Läs hela elaggregat-guiden",
	heaterCalc_howItWorksHeading: "Så fungerar kalkylatorn",
	heaterCalc_howItWorksBody:
		"Tillverkarna anger för varje aggregat vilken rumsvolym det är gjort för — Harvias 9 kW KIP90E till exempel 8–14 m³. Vi räknar bastuvolymen utifrån dina mått (med 2,1 m takhöjd), lägger till 1,2 m³ per m² glas eller obehandlad sten och väljer det minsta standardaggregat (4,5 / 6 / 8 / 9 / 10,5 / 12 / 15 kW) vars volymintervall täcker den.",
	heaterCalc_faqHowMuchKwQuestion: "Hur många kW behöver mitt bastuaggregat?",
	heaterCalc_faqHowMuchKwAnswer:
		"Gå efter den rumsvolym tillverkaren anger för aggregatet, inte en fast kW per m³. En 2,5 × 2,5 m bastu med 2,1 m takhöjd är cirka 13 m³, vilket ett 9 kW aggregat (för 8–14 m³) täcker. Lägg till 1,2 m³ per m² glasdörr eller obehandlad stenvägg, och räkna oisolerade timmerväggar som 1,5 gånger volymen.",
	heaterCalc_faqGlassPenaltyQuestion: "Varför ger glas extra effektbehov?",
	heaterCalc_faqGlassPenaltyAnswer:
		"Glas har U-värde runt 1,1–1,4 W/m²K, medan en isolerad bastuvägg ligger kring 0,2 W/m²K, så en glasdörr förlorar 5–7 gånger så mycket värme som samma yta trä. Aggregattillverkarna räknar därför varje m² glas som 1,2 m³ extra rumsvolym, och det gör vi också.",
	heaterCalc_faqFuseQuestion: "Vilken säkring krävs?",
	heaterCalc_faqFuseAnswer:
		"Vid 400 V trefas behöver ett aggregat på 4,5–6 kW en 10 A-säkring, 8–10,5 kW 16 A, 12 kW 20 A och 15 kW 25 A. Installationen ska alltid göras av en behörig elinstallatör.",

	/* ── Snow Zone Calculator ─────────────────────────────── */
	snowCalc_metaTitle:
		"Snözon-kalkylator – takbjälksdimension per postnummer 2026 | Bygg en bastu",
	snowCalc_metaDescription:
		"Slå upp snözon och rekommenderad takbjälksdimension (C24) per svenskt postnummer. Gratis kalkylator för utomhusbastu och bygglovsbefriade komplementbyggnader.",
	snowCalc_title: "Snözon & takbjälk-kalkylator",
	snowCalc_lead:
		"Slå upp ditt postnummers snözon enligt EKS/Boverket och få en rekommenderad C24-bjälk för bastutaket. Sortimentet är hämtat från Svenskt Träs spännviddstabeller.",
	snowCalc_inputsHeading: "Var bygger du?",
	snowCalc_postalCodeLabel: "Postnummer",
	snowCalc_postalCodePlaceholder: "t.ex. 981 34",
	snowCalc_postalCodeHelp:
		"Vi mappar de första 2–3 siffrorna mot Boverkets snözonskarta (1,0–4,5). Lämna tomt så används default-zon 2,0 (Stockholm).",
	snowCalc_spanLabel: "Takspann (m)",
	snowCalc_spanHelp:
		"Avstånd mellan bärande väggar (oftast bastuns invändiga bredd för fyrkantiga bastur).",
	snowCalc_resultEyebrow: "Snözon",
	snowCalc_resultRegion: "Region",
	snowCalc_resultRegionFallback: "—",
	snowCalc_resultJoist: "Rekommenderad bjälk",
	snowCalc_resultSpacing: "c/c-mått",
	snowCalc_readGuide: "Läs snözon-guiden",
	snowCalc_howItWorksHeading: "Så fungerar dimensioneringen",
	snowCalc_howItWorksBody:
		"Snözonen anger karaktäristisk snölast på mark (s_k) i kN/m². Den, tillsammans med takspannet och c/c-måttet, styr vilken C24-bjälk som klarar lasten enligt Svenskt Träs spännviddstabell. Vi rundar uppåt till nästa standardstorlek (45×145 / ×170 / ×195 / ×220).",
	snowCalc_faqWhatIsZoneQuestion: "Vad är en snözon?",
	snowCalc_faqWhatIsZoneAnswer:
		"Snözonen är ett geografiskt värde mellan 1,0 och 5,5 kN/m² som anger den karaktäristiska snölasten på mark. Boverket publicerar kartan i EKS 11. Söder ligger på 1,0–1,5, Stockholm cirka 2,0, fjällkedjan upp mot 4,5+.",
	snowCalc_faqJoistSizingQuestion: "Hur dimensioneras bjälken?",
	snowCalc_faqJoistSizingAnswer:
		"Vi använder Svenskt Träs spännviddstabell för C24-virke med c/c 600. Bjälkens böjmoment och nedböjning beräknas mot snözon × snöformsfaktor. Resultatet anger den minsta bjälkhöjd som klarar gällande krav.",
	snowCalc_faqDefaultZoneQuestion: "Vad händer om postnumret inte hittas?",
	snowCalc_faqDefaultZoneAnswer:
		"Då används default-zon 2,0 (Stockholm-medel). Bygger du i fjällen bör du själv ange en högre zon — och vid riktigt höga laster kan ett konstruktionsintyg behövas.",

	/* ── Running Cost Calculator ──────────────────────────── */
	runCalc_metaTitle:
		"Driftkostnad bastu – elkostnad per session & månad 2026 | Bygg en bastu",
	runCalc_metaDescription:
		"Räkna ut bastuns driftkostnad per session och månad. Gratis kalkylator: el- eller vedaggregat, uppvärmningstid, kWh per session och månadskostnad.",
	runCalc_title: "Driftkostnad-kalkylator",
	runCalc_lead:
		"Vad kostar det egentligen att basta? Justera mått, aggregattyp och elpris — så får du uppvärmningstid, kWh per session och månadskostnad direkt.",
	runCalc_inputsHeading: "Bastu & användning",
	runCalc_priceLabel: "Elpris",
	runCalc_priceHelp:
		"Inkluderar elhandel, nätavgift, energiskatt och moms. Det svenska årsgenomsnittet 2024 låg runt 1,50 kr/kWh — kolla din senaste elräkning för en exakt siffra.",
	runCalc_sessionsLabel: "Bastutillfällen per månad",
	runCalc_sessionsHelp:
		"Hur ofta använder du bastun? 8 = 2 ggr/vecka, vilket är typiskt för en hushållsbastu.",
	runCalc_perMonth: "mån",
	runCalc_resultEyebrow: "Kostnad per session",
	runCalc_resultPerMonth: "Månadskostnad",
	runCalc_resultHeatUp: "Uppvärmningstid",
	runCalc_resultKwh: "Förbrukning",
	runCalc_resultHeaterSize: "Rekommenderat aggregat",
	runCalc_howItWorksHeading: "Så beräknas kostnaden",
	runCalc_howItWorksBody:
		"För elaggregat räknar vi värmeenergin för luften (volym × ΔT × ρ × c) plus en termisk massa-faktor (~3×) för väggar, lavar och sten. Vi delar med aggregatets verkningsgrad och adderar underhållseffekten under sessionen. För vedeldat används en empirisk modell baserad på ~15 kg björkved per pass.",
	runCalc_faqHeatUpQuestion: "Hur lång tid tar det att värma upp en bastu?",
	runCalc_faqHeatUpAnswer:
		"35–60 minuter för ett rätt dimensionerat elaggregat till 80 °C. Ett underdimensionerat aggregat klarar aldrig att nå rätt temperatur, ett överdimensionerat slösar el. En vedeldad bastu tar 30–60 min beroende på storlek och dragningsförhållanden.",
	runCalc_faqElectricVsWoodQuestion:
		"Är vedeldat eller elaggregat billigare i drift?",
	runCalc_faqElectricVsWoodAnswer:
		"I kalkylatorns startrum, {size} m med ett aggregat på {kw} kW, drar ett elbad ungefär {kwh} kWh, vilket kostar {electricCost} vid {price} per kWh. Ett vedeldat bad går åt ungefär 15 kg björkved, runt {woodCost}. El är billigast så länge elpriset ligger under ungefär {breakEven} per kWh, och över det blir veden billigare. Fyll i ditt eget rum och elpris ovan för att se var du hamnar. Räkna också med vedhantering, sotning och eldstadsanmälan för vedeldat.",
	runCalc_faqInsulationQuestion: "Hur mycket spar man på bra isolering?",
	runCalc_faqInsulationAnswer:
		"En oisolerad utomhus-stockbastu drar ungefär 30 % mer energi än en isolerad konstruktion. Glasdörrar och fönster ökar förlusterna ytterligare — varje m² glas motsvarar cirka 1,2 m³ extra effektiv volym.",

	/* ── Builder Templates ────────────────────────────────── */
	templateGallery_title: "Vanliga mått att utgå från",
	templateGallery_subtitle:
		"Fyller i mått, dörr och aggregat åt dig. Allt går att dra om efteråt.",
	templateGallery_openLabel: "Vanliga mått",
	templateGallery_useTemplate: "Använd dessa mått",
	templateGallery_floorArea: "{value} m² golvyta",
	templateGallery_heaterWood: "Vedeldat aggregat",
	templateGallery_heaterElectric: "Elaggregat",

	/* ── Byggarens första-gången-intro / coach-marks ──────── */
	builderIntro_entryTitle: "Nu ställer vi in din bastu",
	builderIntro_entrySubtitle:
		"Du väljer mått och öppningar — vi räknar fram stomme, inköpslista, kapnota och pris.",
	builderIntro_entryTemplate: "Utgå från ett vanligt mått",
	builderIntro_entryTemplateHint:
		"Fyller i mått, dörr och aggregat åt dig — ett klick.",
	builderIntro_entryBlank: "Ställ in måtten själv",
	builderIntro_entryBlankHint:
		"Börja på standardmåtten och dra dem dit du vill.",
	builderIntro_entrySoloStart: "Sätt igång",
	builderIntro_skip: "Hoppa över",
	builderIntro_next: "Nästa",
	builderIntro_done: "Klart",
	builderIntro_stepLabel: "Steg {current} av {total}",
	builderIntro_canvasTitle: "Forma den i 3D",
	builderIntro_canvasBody:
		"Dra för att rotera, skrolla för att zooma, och ta tag i en dörr eller ett fönster för att flytta det direkt på modellen.",
	builderIntro_tabsTitle: "Design → inköpslista → kapnota → pris",
	builderIntro_tabsBody:
		"Designa här, gå sedan igenom flikarna för inköpslista, en optimerad kapnota och en löpande prisuppskattning.",
	template_squareBackyard_name: "Trädgårdsbastu 2,5 × 2,0",
	template_squareBackyard_description:
		"Två personer, vedeldat, fri från bygglov som komplementbyggnad. Det enklaste sättet att komma igång.",
	template_squareFamily_name: "Familjebastu 3,0 × 3,0",
	template_squareFamily_description:
		"Plats för fyra, elaggregat, glasdörr och fönster åt sidan. Liten altan på framsidan ingår.",
	template_squareCouple_name: "Parbastu 2,0 × 2,0",
	template_squareCouple_description:
		"Två personer, vedeldat, minsta möjliga fotavtryck. Får plats på den lilla tomten.",
	template_barrelClassic_name: "Klassisk bastutunna 2,0 × 2,3",
	template_barrelClassic_description:
		"Tre–fyra personer, vedeldat med liten siktruta. Stilren och snabb att bygga.",
	template_twoRoomCabin_name: "Tvårumsbastu 3,5 × 2,9",
	template_twoRoomCabin_description:
		"Bastu plus relaxavdelning med fönster åt sidan, vedeldat aggregat. Perfekt för stuga eller sjötomt.",
	template_twoRoomCompact_name: "Kompakt tvårum 2,5 × 3,0",
	template_twoRoomCompact_description:
		"Bastu plus en liten relaxhörna, vedeldat. Smalt fotavtryck för den mindre trädgården.",
	template_twoRoomLakeside_name: "Sjötomtsbastu 4,0 × 3,0",
	template_twoRoomLakeside_description:
		"Rymlig relaxavdelning med stort panoramafönster, elaggregat och altan. Gjord för utsikten.",

	/* ── Help Hints ───────────────────────────────────────── */
	helpHint_ariaLabel: "Visa hjälptext",
	helpHint_learnMore: "Läs mer",
	helpHint_areaTitle: "Golvyta",
	helpHint_areaBody:
		"Total yta inom bastuns ytterväggar. Upp till 30 m² är bastun normalt en bygglovsbefriad komplementbyggnad (50 m² utanför detaljplan) — större kräver bygglov.",
	helpHint_lengthTitle: "Längd",
	helpHint_lengthBody:
		"Stommens yttermått längs långsidan. Bredd × längd styr panelåtgång och kapnota.",
	helpHint_wallHeightTitle: "Vägghöjd",
	helpHint_wallHeightBody:
		"Lavarna följer taket, så värmen hamnar där ni sitter. En lägre vägg ger mindre luft att värma och ett mindre aggregat. En högre ger ståhöjd och plats för större fönster, men lyfter fotlaven: från 2 250 mm behövs ett fotsteg.",
	helpHint_widthTitle: "Bredd",
	helpHint_widthBody:
		"Stommens yttermått längs kortsidan, den sida takbjälkarna spänner över. Hur brett det kan bli beror på snözonen: över spännviddstabellen krävs limträbalk. Smala bastur klarar sig med en bänknivå; bredare ger två nivåer.",
	helpHint_postalCodeTitle: "Postnummer",
	helpHint_postalCodeBody:
		"Vi använder postnumret för att slå upp snözon och dimensionera takbjälkar enligt EKS/Boverket.",
	helpHint_climateZoneTitle: "Klimatzon",
	helpHint_climateZoneBody:
		"Snölastklass styr takbjälkarnas dimension och c/c-avstånd. Vid tveksamhet — välj högre klass.",

	/* ── Openings Editor ──────────────────────────────────── */
	openings_sectionLabel: "Öppningar",
	openings_intro:
		"Lägg till en dörr direkt eller placera ett fönster i 3D-vyn.",
	openings_addDoor: "Dörr",
	openings_addWindow: "Fönster",
	openings_placingWindow: "Placera fönster i 3D…",
	openings_emptyState:
		"Inga öppningar ännu. Lägg till en dörr direkt eller välj Fönster för att placera i modellen.",
	openings_typeDoor: "Dörr",
	openings_typeWindow: "Fönster",
	openings_metaDoor: "Förankrad mot golvnivå",
	openings_metaWindow: "Placeras fritt på vald vägg",
	openings_remove: "Ta bort",
	openings_wallLabel: "Vägg",
	openings_wallFront: "Front",
	openings_wallBack: "Bak",
	openings_wallLeft: "Vänster",
	openings_wallRight: "Höger",
	openings_wallDivider: "Mellanvägg",
	openings_widthLabel: "Bredd (mm)",
	openings_heightLabel: "Höjd (mm)",
	openings_sizePresetLabel: "Standardmått",
	openings_sizeCustom: "Eget mått",
	openings_doorLeafLabel: "Dörrblad",
	openings_doorLeafWood: "Trä",
	openings_doorLeafGlass: "Helglas",
	openings_hingeLabel: "Gångjärn (sett utifrån)",
	openings_hingeLeft: "Vänster",
	openings_hingeRight: "Höger",
	openings_swingLabel: "Öppnas",
	openings_swingOut: "Utåt",
	openings_swingIn: "Inåt",
	openings_swingInWarning:
		"En bastudörr ska öppnas utåt, så att den går att trycka upp om någon mår dåligt.",
	openings_error_invalidSize: "Bredd och höjd måste vara större än 0.",
	construction_roofReview: 'Takets bärsystem, förband och fuktsäkerhet behöver verifieras för platsen. Visade virkesdimensioner är preliminära; modellen är inte en verifierad takstolsritning.',
	construction_referenceOpen: "Visa takförslaget i 3D",
	construction_referenceScope: "Separat referens: 4 × 2,5 m, pulpettak 8°. Visar förstärkningarna och deras kaplista. Ändrar inte din bastu eller dess inköpslista. Förband och hela byggnaden är inte färdigprojekterade.",
	construction_referencePanels: "Visa takskivor",
	construction_referenceLoading: "Laddar konstruktionsvyn…",
	construction_referenceControls: "Dra för att rotera. Nyp eller skrolla för att zooma.",
	construction_referenceParts: "kapdelar",
	construction_referenceDownload: "Hämta referensens kaplista (CSV)",
	construction_basisTitle: "Byggunderlag för din utebastu",
	construction_planningStatus: "Detaljer återstår",
	construction_basisIntro: "Underlaget nedan visar nästa byggbeslut och källor för dem. Referensritningar gäller sina egna mått och laster; de är inte ett godkännande av den här modellen.",
	construction_structureTitle: "1. Välj ett sammanhängande taksystem",
	construction_gableSystem: "För sadeltaket behövs en dokumenterad takstol eller en bärande nockbalk med stöd ner till grunden. Två sparrar som möts i nocken räcker inte som konstruktionsbeskrivning. Behåll samtliga delar och förband i den valda ritningen. Vill du ha öppet till nock måste just den lösningen dimensioneras. En takstolstillverkare kan normalt ta fram ett underlag i samband med leverans.",
	construction_monoSystem: "För pulpettaket ska bjälkarnas verkliga spännvidd, upplag och förankring stämma med dimensioneringsunderlaget. Kontrollera snölast, vind och takets samlade vikt. Den visade virkesdimensionen är en uppskattning, inte en kontrollerad balkberäkning.",
	construction_connectionsTitle: "2. Ange hur delarna fästs",
	construction_benchMountingTitle: "Lavar: ram och väggupplag",
	construction_benchMountingDetail: "Dimensionera lavramen för vald spännvidd, träkvalitet och belastning. Väggskruven måste gå genom upplag, panel och luftspalt in i bärande regel eller kortling. Planera fasta mellanlägg bakom upplagen. Lavskruven i materiallistan är till ram och sittbrädor; vägginfästning och säkring mot förskjutning behöver väljas separat. Ändupplag och korrekt passning är inte en verifiering av bärförmågan.",
	construction_connectionDetail: "Varje bärande anslutning behöver ett bestämt beslag eller annat förband, rätt fästdon och ett monteringsmönster. Beslagets hålantal är inte en spikanvisning. Följ tabellen och montagebilden för exakt produkt, virkestjocklek och belastningsriktning. Kontrollera även väggarnas förankring till grunden och vindstabilisering.",
	construction_moistureTitle: "3. Bestäm hela takets fuktskydd",
	construction_moistureDetail: "Utgångspunkten är ett ventilerat yttertak med vindskydd mellan isolering och luftväg. Luftvägen måste ha fungerande in- och utlopp och skydd mot nederbörd och skadedjur. En tom springa räcker inte. Täta varmsidan och alla anslutningar; läckande bastuluft ska inte användas för att ventilera taket. Dagens modell saknar ännu den kompletta detaljen.",
	construction_envelopeTitle: "4. Håll ihop bastuns isolering och täta skikt",
	construction_envelopeDetail: "Modellen visar mineralull och bastufolie. Använd produkter avsedda för bastutemperatur och systemets anvisningar för tejp, skarvar och genomföringar. Kombinera inte detta med en rum-i-rummet-guide som förutsätter en annan vägguppbyggnad. Skorstenens genomföring ska följa skorstenssystemets brandavstånd och tätning.",
	construction_bracingSpaceTitle: "Väggutrymme för stabilisering",
	construction_bracingSpaceDetail: "Längsta sammanhängande väggparti utan dörr eller fönster, från golv till tak. Måtten följer dina öppningar. Skivor, kantreglar och förankringar behöver dimensioneras inom detta utrymme.",
	construction_floorTitle: "5. Anpassa golvet till användningen",
	construction_floorDetail: "Standardbastun planeras utan dusch och fasta vatteninstallationer. Golvet behöver ändå tåla spillvatten och avsedd rengöring, med skyddade anslutningar mot vägg och en vald lösning för att hantera vattnet. Trall är en gångyta, inte ett tätskikt.",
	construction_showerDetail: "Dusch ligger utanför standardutförandet. Det behövs ett sammanhängande våtrumssystem med golvbrunn, fall, tätskikt och tätade anslutningar samt frostskydd för vatteninstallationer. Ett duschval gör inte nuvarande materiallista komplett.",
	construction_connectionLocations: "Anslutningspunkter i den visade takmodellen",
	construction_connectionCountScope: "Antalen följer takets regellägen. De anger platser som behöver en infästningslösning, inte antal beslag eller skruvar.",
	construction_roofBearing: "Tak mot vägg",
	construction_ridge: "Sparrpar vid nock",
	construction_baseAnchorage: "Stomme mot grund",
	construction_notSpecified: "Beror på vald grundlösning",
	construction_procurementScope: "Beslag, bärande fästdon och takets kompletterande fuktdetaljer är inte specificerade i inköpslistan. Den befintliga infästningsposten är en budgetreserv; dessa delar har inte mängdats eller prissatts separat.",
	domain_build_constructionRoofPrereq: "Takets bärsystem, upplag och infästningar ska vara dokumenterade för byggnadens mått och laster innan taket monteras. Se byggunderlaget under Regler.",
	domain_build_constructionMoisturePrereq: "Bestäm luftväg, vindskydd och tätade anslutningar innan isoleringen byggs in. Följ en sammanhängande lösning för utebastu.",
	construction_fastenerBudget: 'Budgetpost – antal skruvar och beslag per förband återstår att specificera',
	construction_showerScope: 'Dusch: golvbrunn, tätskikt, fall och installation ingår inte i material- och prisunderlaget. En projekterad våtrumslösning krävs.',
	construction_unplannedCuts: 'Ingår inte i optimerat virkesinköp – behöver separat mängdning eller kapplan:',
	construction_openingInvalid: 'Konstruktionen har öppningar som behöver ändras. Korrigera markerade placeringar innan kapning eller beställning.',
	openings_error_framingClearance: 'Öppningarnas reglar får inte plats. Öka avståndet.',
	openings_error_headerClearance: 'Avväxling och hammarband får inte plats. Sänk öppningens överkant.',
	openings_error_partitionCollision: 'Öppningen korsar mellanväggen. Flytta öppningen eller mellanväggen.',
	openings_error_outOfBoundsStart:
		"Öppning måste starta inom väggens tillåtna område.",
	openings_error_outOfBoundsEnd:
		"Öppning går förbi väggens tillåtna område (max {wall} mm, hörnavstånd inräknat).",
	openings_error_outOfBoundsHeight:
		"Öppning går över väggens höjd ({wall} mm).",
	openings_error_overlap:
		"Öppningen överlappar en annan öppning på samma vägg.",

	/* ── Deck Editor ─────────────────────────────────────── */
	deck_sectionLabel: "Trall / altan",
	deck_intro:
		"Aktivera en trall framför bastun och justera form, djup och bärande virke direkt i designläget.",
	deck_enable: "Lägg till trall",
	deck_disabledState: "Ingen trall vald ännu.",
	deck_shape: "Form",
	deck_shape_rectangular: "Rektangulär",
	deck_shape_l_shape: "L-form",
	deck_shape_wrap_front: "Wrap front",
	deck_shape_wrap_sides: "Wrap sidor",
	deck_attachWall: "Ansluter till",
	deck_depth: "Djup",
	deck_width: "Bredd",
	deck_armDepth: "Arm djup",
	deck_armWidth: "Arm bredd",
	deck_wrapDepth: "Wrap-djup",
	deck_boardType: "Trallbräda",
	deck_joistDimension: "Regeldimension",
	deck_boardOption_28x120: "28×120 mm",
	deck_boardOption_22x95: "22×95 mm",
	deck_joistOption_45x145: "45×145 mm",
	deck_joistOption_45x170: "45×170 mm",
	deck_boards: "Trallbrädor",
	deck_joists: "Reglar",
	deck_bearers: "Bärlinor",
	deck_piers: "Plintar",
	deck_screws: "Trallskruv",
	deck_area: "Yta",
	deck_estimatedCost: "Uppskattad kostnad",

	/* ── Roof Config Editor ───────────────────────────────── */
	roof_typeLabel: "Taktyp",
	roof_pitchLabel: "Taklutning",
	roof_pitchAriaLabel: "Taklutning: {value} grader",
	roof_gableDesc:
		"Nocktaket får nock längs byggnaden och faller mot vänster/höger.",
	roof_monoDesc:
		"Pulpettaket behåller ett enkelt fall men kan justeras till tydligare lutning.",
	roof_lowSlopeWarning:
		"Lutning under 14° behandlas som låglutande tak och kräver särskilt tätskikt eller plåtsystem.",
	roof_systemLabel: "Taksystem",
	roof_highWallLabel: "Högsida",
	roof_highWallFront: "Framsidan",
	roof_highWallBack: "Baksidan",
	roof_highWallLeft: "Vänster sida",
	roof_highWallRight: "Höger sida",
	roof_systemFelt: "Ytpapp på råspont",
	roof_systemSheetMetal: "Bandtäckt/plåt på råspont",
	roof_runoffFreeDrip: "Fri droppkant",
	roof_packageHint:
		"Välj både taktyp och ytskikt så att yttertaket blir komplett.",
	roof_layerDecking: "Råspont",
	roof_layerUnderlay: "Underlagspapp",
	roof_accessoryEaveFlashing: "Takfotsplåt",
	roof_accessoryVergeFlashing: "Vindskiveplåt",
	roof_accessoryRidgeCapping: "Nockbeslag",
	roof_noteExternalOnly:
		"Statusen avser bara yttertakets kompletthet, inte hela takkonstruktionens fuktsäkerhet.",
	roof_noteLowSlope:
		"Låglutande tak kräver extra omsorg i skarvar, tätskikt och avvattning.",
	roof_manualReviewUnsupported:
		"Valt taksystem stöds inte fullt ut för den här taktypen.",

	/* ── Site Conditions Editor ───────────────────────────── */
	site_sectionLabel: "Mark & grund",
	site_reset: "Återställ",
	site_plinthLengthLabel: "Plintlängd",
	site_minBuriedLabel: "Minsta nedgrävning",
	site_minBuriedAriaLabel: "Minsta nedgrävning: {value} millimeter",
	site_terrainLabel: "Terräng",
	site_terrainFlat: "Plan mark",
	site_terrainSlope: "Lutande mark",
	site_slopeAcrossLabel: "Fall sidled",
	site_slopeAcrossAriaLabel: "Fall sidled: {value} procent",
	site_slopeAlongLabel: "Fall fram/bak",
	site_slopeAlongAriaLabel: "Fall fram och bak: {value} procent",
	site_note:
		"Bastun hålls i våg. När terrängen lutar varierar plintarnas synliga höjd och nedgrävning per punkt.",

	/* ── Thermal Inputs Editor ────────────────────────────── */
	thermal_heaterLabel: "Uppvärmning:",
	thermal_heaterWood: "Vedeldad kamin",
	thermal_heaterElectric: "Elaggregat",
	thermal_heaterModelLabel: "Modell",
	thermal_heaterModelNone: "Ingen vald – standardmått",
	thermal_heaterModelOutside: "eldas utifrån",
	thermal_heaterModelSpec: "{kw} kW · {min}–{max} m³ · {w}×{d}×{h} mm",
	thermal_heaterModelOutsideNote:
		"Eldas från andra sidan väggen som aggregatet står mot. Materiallistan får brandskiva på båda sidor om genomföringen.",
	thermal_heaterModelSource: "Mått och säkerhetsavstånd från tillverkaren",
	thermal_glassAreaLabel: "Glasyta (m²):",
	thermal_stoneAreaLabel: "Stenyta (m²):",
	thermal_logCabin: "Oisolerad timmerstuga utomhus",
	equipment_title: 'Utrustning',
	equipment_lighting: 'Belysning i bastun',
	equipment_wallLight: 'Vägglampa',
	equipment_noLight: 'Ingen belysning',
	equipment_showerShort: 'Dusch',
	equipment_shower: 'Dusch i relaxdelen',
	equipment_showerSpace: 'Duschen behöver 90 × 90 cm fri yta vid en tät vägg, utanför dörrarnas passage. Utöka relaxdelen eller flytta bänkar och öppningar.',
	equipment_showerScope: 'Duschens placering visas i 3D. Armatur, golvbrunn, tätskikt, fall och VVS-installation behöver projekteras och prissättas separat.',
	thermal_shower: "Inkludera dusch/tvättplats",
	thermal_heaterPlacementLabel: "Skorstensfack:",
	thermal_heaterPlacementFixed:
		"Bastutunna och elaggregat använder fast placering utan valbara bjälkfack.",

	/* ── Viewer 3D ────────────────────────────────────────── */
	viewer_todDaylight: "Växla till dagsljus",
	viewer_todEvening: "Växla till kvällsljus",
	viewer_todLabel: "Sol",
	viewer_todAriaLabel: "Tid på dagen",
	viewer_todMidday: "Middag",
	viewer_todGoldenHour: "Golden hour",
	viewer_todNight: "Natt",
	viewer_blueprintOn: "Visa realistisk vy",
	viewer_blueprintOff: "Visa ritningsläge",
	viewer_qualityButton: "Bildkvalitet",
	viewer_qualityLabel: "Renderingskvalitet",
	viewer_qualityAuto: "Auto (rekommenderat)",
	viewer_qualityHigh: "Hög",
	viewer_qualityBalanced: "Balanserad",
	viewer_qualityLow: "Låg",
	viewer_hintDrag: "Dra för att rotera",
	viewer_hintScroll: "Scroll för att zooma",
	viewer_hintPan: "Högerklick + dra för att panorera",
	viewer_hintClose: "Stäng tips",
	viewer_legendToggle: "Teckenförklaring",
	viewer_legendSupply: "Tilluftsventil",
	viewer_legendExhaust: "Frånluftsventil",
	viewer_legendFireboard: "Brandskyddsskiva",
	viewer_legendBeam: "Tryckimp. bärlina",
	viewer_legendPier: "Betongplint",
	viewer_loadingScene: "Bygger bastun lager för lager…",
	viewer_sceneReady: "Bastun är redo!",
	viewer_recovering: "Återställer 3D-vyn…",
	viewer_recoveryFailedTitle: "3D-vyn kunde inte återställas",
	viewer_recoveryFailedBody:
		"Försök igen med låg kvalitet eller ladda om sidan om problemet fortsätter.",
	viewer_retry: "Försök igen",
	viewer_reload: "Ladda om sidan",
	viewer_measurementWallTitle: "Yttervägg",
	viewer_measurementDoorTitle: "Dörr",
	viewer_measurementWindowTitle: "Fönster",
	viewer_measurementPartitionTitle: "Mellanvägg",
	viewer_measurementPartitionSubtitle: "Rumsdelning",
	viewer_measurementWallFront: "Frontvägg",
	viewer_measurementWallBack: "Bakvägg",
	viewer_measurementWallLeft: "Vänster vägg",
	viewer_measurementWallRight: "Höger vägg",
	viewer_measurementLength: "Längd",
	viewer_measurementWidth: "Bredd",
	viewer_measurementHeight: "Höjd",
	viewer_measurementLeftOffset: "Från vänster kant",
	viewer_measurementRightOffset: "Från höger kant",
	viewer_measurementBackOffset: "Från bakkant",
	viewer_measurementFrontOffset: "Från framkant",
	viewer_measurementFrontDistance: "Avstånd från framvägg",
	viewer_measurementBackDistance: "Avstånd från bakvägg",
	viewer_measurementSaunaDepth: "Bastudjup",
	viewer_measurementLoungeDepth: "Relaxdjup",
	viewer_measurementBenchTitle: "Lav",
	viewer_measurementHeaterTitle: "Aggregat",
	viewer_measurementDepth: "Djup",
	viewer_measurementAlongWall: "Läge längs vägg",
	viewer_measurementWallGap: "Avstånd till vägg",
	viewer_measurementBenchStartEdge: "Lavens början",
	viewer_measurementBenchEndEdge: "Lavens slut",
	viewer_interiorEditOn: "Stäng interiörredigering",
	viewer_interiorEditOff: "Redigera interiören",
	viewer_groupViews: "Vyer",
	viewer_groupDisplay: "Visning",
	viewer_sectionToggleOn: "Stäng snittvy",
	viewer_sectionToggleOff: "Visa snittvy",
	viewer_scaleFiguresOn: "Dölj skalfigurer",
	viewer_scaleFiguresOff: "Visa skalfigurer",
	viewer_scaleFiguresSeat: "≈ {count} sittplats",
	viewer_scaleFiguresSeats: "≈ {count} sittplatser",
	viewer_scaleFiguresRelaxSeats: "+ {count} i relaxdel",
	viewer_ambienceOn: "Stäng av ljudet",
	viewer_ambienceOff: "Slå på ljudet",
	viewer_rotationGroup: "Orientering",
	viewer_rotationTitle: "Vrid",
	viewer_rotationHandle: "Vrid bastun — dra runt, släpp på närmaste kvartsvarv",
	viewer_rotationLeft: "Vrid ett kvarts varv moturs",
	viewer_rotationRight: "Vrid ett kvarts varv medurs",
	viewer_rotationValue: "Bastun står vriden {deg}° mot tomten",
	viewer_rotationPausedInSection: "Vridning är pausad i snittvyn",
	site_orientationLabel: "vriden {deg}° mot tomten",
	viewer_sectionAxisLabel: "Snittriktning",
	viewer_sectionAxisWidth: "Tvärs bredd",
	viewer_sectionAxisLength: "Tvärs längd",
	viewer_sectionPositionLabel: "Snittläge",
	viewer_sectionLegendTitle: "Väggskikt i snittet",
	viewer_sectionMeasurementPaused: "Mätverktyget är pausat i snittläge.",
	viewer_sectionLayerExterior: "Fasadpanel",
	viewer_sectionLayerFraming: "Trästomme (regel)",
	viewer_sectionLayerPanel: "Innerpanel",
	viewer_sectionLayerFoundation: "Plintgrund",
	viewer_sectionLayerRoof: "Takskikt",
	viewer_sectionLayerBench: "Lave",
	viewer_sectionLayerGlass: "Glas",
	viewer_sectionLayerInsulation: "Isolering & ångspärr",
	instr_stepViewGroupFoundation: "grund",
	instr_stepViewGroupDeck: "trall",
	instr_stepViewGroupFraming: "stomme",
	instr_stepViewGroupPanel: "panel",
	instr_stepViewGroupRoof: "tak",
	instr_stepViewGroupInterior: "inre lager",
	instr_stepViewGroupExterior: "fasad",
	instr_snapshotUnavailable: "3D-ögonblicksbild saknas i denna export.",
	instr_snapshotCamera: "Kamera",
	instr_snapshotVisibleGroups: "Synliga grupper",
	instr_cameraPresetHero: "Hero",
	instr_cameraPresetInterior: "Interiör",
	instr_cameraPresetSide: "Sida",
	viewer_helpToggle: "Hjälp och teckenförklaring",
	viewer_helpOpen: "Visa hjälp",
	viewer_helpControlsTitle: "Kontroller",
	viewer_helpLegendTitle: "Teckenförklaring",
	viewer_placementWindowTitle: "Placerar fönster",
	viewer_placementHint: "Klicka på en yttervägg för att placera fönstret.",
	viewer_placementCancel: "Avbryt placering",

	/* ── Visibility Bar ───────────────────────────────────── */
	vis_exterior: "Fasad",
	vis_roof: "Tak",
	vis_interior: "Interiör",
	vis_framing: "Trästomme",
	vis_panel: "Ytskikt",
	vis_frontWall: "Frontvägg",
	vis_foundation: "Plintgrund",
	vis_deck: "Trall",
	vis_heaterClearance: "Skyddsavstånd",
	vis_ventilation: "Ventilation",
	vis_groupShell: "Skal",
	vis_groupStructure: "Struktur",
	vis_groupAnalysis: "Analys",
	vis_visible: "synlig",
	vis_hidden: "dold",
	/** Verb used as a tooltip / aria prefix on the visibility-bar buttons. */
	vis_actionShow: "Visa",
	vis_actionHide: "Dölj",

	/* ── Material Pane ────────────────────────────────────── */
	mat_statTransport: "Transport",
	mat_statBudget: "Budget",
	mat_statPhases: "Faser",
	mat_viewPhase: "Efter byggmoment",
	mat_viewAll: "Hela listan",
	mat_viewAriaLabel: "Listvisning",
	mat_jumpToPricing: "Se prisbild",
	mat_colMaterial: "Material",
	mat_colDimension: "Dimension",
	mat_colQuantity: "Åtgång (ca)",
	mat_weightCalcLabel: "Viktkalkyl & transport",
	mat_weightHeavy: "Tung last",
	mat_weightCheck: "Kontrollera",
	mat_weightBuildingNet: "Byggnad netto",
	mat_weightBuildingGross: "Byggnad brutto (+10 %)",
	mat_weightPlinths: "Plintar",
	mat_weightTransportTotal: "Transportvikt totalt",
	mat_elZoneLabel: "El-zonkalkyl (SEK Svensk Elstandard)",
	mat_elZoneHot: "Varm zon",
	mat_elZoneDangerTitle: "LIVSFARA",
	mat_elZoneDangerBody:
		"Standard PVC-kabel (EKK/FKX) och VP-rör smälter vid ~70 °C. Använd ALLTID silikonkabel (SiHF 180 °C) ovan 500 mm från kamin!",
	mat_elColComponent: "Komponent",
	mat_elColCableType: "Kabeltyp",
	mat_elColZone: "Zon",
	mat_elZoneHotLabel: "Varm (>500 mm)",
	mat_elZoneColdLabel: "Kall (≤500 mm)",

	/* ── Cut Pane ─────────────────────────────────────────── */
	cut_kingStud: "Sidoregel vid öppning",
	cut_jackStud: "Stödregel under avväxling",
	cut_crippleStud: "Kortregel vid öppning",
	cut_longSide: "långsida",
	cut_shortSide: "kortsida",
	cut_oneDirection: "ena riktningen",
	cut_squareEnd: "rakt snitt",
	cut_intro: "Välj byggmoment. Alla kapmått är i millimeter. Sågschemat hjälper dig välja brädlängder.",
	cut_siteWork: "Kapas på plats eller planeras separat",
	cut_other: "Övriga delar",
	purchase_rows: "rader",
	purchase_title: "Din inköpslista",
	purchase_intro: "Öppna ett byggmoment för material, dimensioner och mängder. Visa hela listan när du vill få en samlad överblick.",
	cut_title: "Din kapnota",
	cut_colPart: "Del",
	cut_colCount: "Antal",
	cut_colLength: "Kaplängd",
	cut_footnote:
		"* För dörröppningen på framsidan anpassas och kapas 2-3 stående reglar beroende på dörrens exakta karmmått (oftast 710x1910 mm).",

	/* ── Cut Diagram (Visual Optimizer) ──────────────────── */
	cutDiagram_title: "Sågschema",
	cutDiagram_boards: "Brädor att köpa",
	cutDiagram_waste: "Spill",
	cutDiagram_stockLength: "Handelslängd",
	cutDiagram_selectDimension: "Välj dimension",
	cutDiagram_piece: "Del",
	cutDiagram_remaining: "Kvarvarande",
	cutDiagram_boardLabel: "Bräda {n}",
	cutDiagram_noCuts: "Inga kapade delar för denna dimension",
	cutDiagram_allDimensions: "Alla dimensioner",
	cutDiagram_overrideHint: "Ändra längd om dina plankor skiljer sig",
	cutDiagram_sawKerf: "Sågsnitt",
	cutDiagram_legend: "Teckenförklaring",

	/* ── Price Pane ───────────────────────────────────────── */
	price_totalLabel: "Totalpris",
	price_liveNote: "Live-pris när det finns, annars lokal uppskattning.",
	price_localNote: "Lokal uppskattning baserad på material och regler.",
	price_driverLabel: "Prisdrivare",
	price_driverWood: "Vedeldad lösning",
	price_driverElectric: "Elaggregat",
	price_openingSingular: "öppning",
	price_openingPlural: "öppningar",
	price_chimneyIncluded: "skorsten ingår",
	price_nextStepLabel: "Nästa steg",
	price_nextStepFallback: "Byggplanen är nästa stopp",
	price_openShop: "Öppna butik",
	price_goToBuildPlan: "Gå till byggplan",
	price_estimateTitle: "Prisuppskattning",
	price_productRecommendations: "Produkter som passar ritningen",
	price_heatersMatch: "{count} aggregat matchar effektbehovet just nu.",
	price_openProduct: "Öppna produkt →",
	price_complementWith: "Komplettera med",
	price_chimneyPackage: "Skorstenspaket",
	price_chimneySystem: "System:",
	price_chimneyDiameter: "Diameter:",
	price_chimneyHeight: "Total höjd:",
	price_fetchingLive: "Hämtar live-priser...",
	price_staleData: "Prisdata är delvis inaktuell.",
	price_staleReason: "Orsak:",
	price_colProduct: "Produkt",
	price_colQuantity: "Antal",
	price_colPrice: "Pris (ca)",
	price_totalLive: "Totalt till dagens butikspriser",
	price_totalLocal: "Materialkostnad",
	price_materialMode: "Materialkostnad",
	price_diyMode: "Självbyggarbudget",
	price_marketMode: "Marknadsjämförelse",
	price_modeNoteMaterial: "Alla rader i listan nedan, summerade till katalogpris.",
	price_modeNoteDiy:
		"Material plus de steg som kräver fackman, frakt och de småsaker varje bygge gör av med.",
	price_modeNoteMarket:
		"Ungefär vad ett färdigt bastupaket kostar: din budget plus prefabricering, försäljning och samordning.",
	price_budgetsSummary: "Vad hela projektet kan kosta",
	price_diyDelta: "{amount} utöver materialet",
	price_marketDelta: "{amount} mer än att bygga själv",
	price_comparatorNote:
		"Marknadsjämförelsen är inte en offert, utan ett riktmärke för hur ett färdigt paket kan landa högre än ren materialkostnad.",
	price_colMaterial: "Material",
	price_colUsage: "Åtgång",
	price_goToShop: "Gå till inköpslista hos butik →",
	price_footnote:
		"* Priser avser uppskattning inkl. moms. Live-priser uppdateras nattligen och kan skilja mellan regioner.",
	price_currencyDisclaimer: "", // Not shown for Swedish market

	/* ── Instructions Pane ────────────────────────────────── */
	instr_title: "Bygginstruktioner: Steg-för-steg (Utebastu)",
	instr_timeEstimate: "⏱️ Tidsuppskattning",
	instr_area: "Area:",
	instr_totalTime: "Total uppskattad tid:",
	instr_weekendPlan: "Planera för:",
	instr_weekendUnit: "helger",
	instr_weekendPerStep: "Planera {label} för det här steget.",
	instr_proSteps: "Fackmannasteg:",
	instr_proStepsDesc: "{pro} av {total} steg kräver fackman",
	instr_beforeStart: "Viktigt före byggstart",
	instr_markStep: "Markera steget {title} som klart",
	instr_timeLabel: "⏱️ ca {hours} timmar",
	instr_dependsOn: "Klar före:",
	instr_prerequisites: "Förutsättningar",
	instr_checklist: "Checklista",
	instr_materialsCheck: "Material att dubbelkolla",
	instr_cutPrep: "Kapnota / förberedelser",
	instr_risks: "Risker",
	instr_controls: "Kontroller",
	instr_tools: "Verktyg",
	instr_crewSolo: "1 person",
	instr_crewDuo: "2 personer",
	instr_calloutSafety: "Säkerhetskontroll",
	instr_calloutQuality: "Kvalitetskontroll",
	instr_wrong: "Fel",
	instr_right: "Rätt",
	instr_measurements: "Mått att låsa",
	instr_allSteps: "Alla steg",
	instr_previousStep: "Föregående steg",
	instr_journeyPosition: "Steg {current} av {total}",
	instr_planning: "Planering & förberedelser",
	instr_projectBasis: "Projektunderlag",
	instr_progressLabel: "{done} av {total} steg klara",
	instr_stepDoneToast: "Steg {n} klart — {done} av {total}",
	instr_statusDone: "Klar",
	instr_statusProgress: "Pågår",
	instr_statusReady: "Redo",
	instr_nextStep: "Nästa steg",
	instr_showCompleted: "Visa {count} klara steg",
	instr_hideCompleted: "Dölj klara steg",
	instr_calendarEstimate: "Kalendertid:",
	instr_gateKindPermit: "Anmälan & tillstånd",
	instr_gateKindBooking: "Boka nu",
	instr_gateKindInspection: "Besiktning",
	instr_gateBlocksBefore: "Måste vara klar före: {title}",
	instr_gateLeadTime: "Ledtid: {label}",
	instr_dryingHours: "+{hours} h torktid",
	instr_weatherCritical: "Väderkritiskt",
	instr_mobileProgress: "Delmoment {current} av {total}",
	instr_mobileDoneCount: "{done} klara",
	instr_mobileStepIndex: "Steg {step} av {total}",
	instr_mobileSubstepIndex: "{current} av {total}",
	instr_mobileComplete: "Markera delmoment som klart",
	instr_mobilePrev: "Föregående",
	instr_mobileCrew: "Crew",
	instr_mobileCallout: "Viktigt att se upp med",
	instr_mobileCalloutWrong: "Fel:",
	instr_mobileCalloutRight: "Rätt:",
	instr_mobileView: "3D-vy / måttstöd",
	instr_mobileViewUnavailable:
		"3D-vyn är inte tillgänglig här ännu. Följ checklistan och måttstödet i text tills vidare.",
	instr_mobileDiagram: "Diagram",
	instr_mobileGateChecklist: "Gate-checklista",

	/* ── BBR Pane ─────────────────────────────────────────── */
	bbr_buildStatus: "Byggstatus",
	bbr_checkRequired: "Kontroll krävs",
	bbr_fireNotificationYes: "Eldstadsanmälan krävs i detta läge.",
	bbr_fireNotificationNo: "Ingen separat eldstadsanmälan är flaggad just nu.",
	bbr_placementLabel: "Placering",
	bbr_boundaryDistance: "{distance} m till tomtgräns",
	bbr_verifyBoundary: "Verifiera tomtgräns",
	bbr_fireDistance: "{distance} m brandavstånd till närmaste byggnad.",
	bbr_verifyDistances:
		"Kontrollera avstånd till tomtgräns och andra byggnader innan byggstart.",
	bbr_riskFirst: "Risk först",
	bbr_riskWood: "Eldstad och skorsten",
	bbr_riskElectric: "El och ventilation",
	bbr_riskWoodDesc:
		"Säkerhetsavstånd, skorsten och anmälan måste vara klara först.",
	bbr_riskElectricDesc:
		"Zonindelning, kabelval och ventilation behöver säkras före montage.",
	bbr_heaterTitle: "Rekommenderad aggregateffekt",
	bbr_effectiveVolume: "Effektiv volym:",
	bbr_recommendedHeater: "Rekommenderad {type}:",
	bbr_heaterTypeWood: "kamin",
	bbr_heaterTypeElectric: "aggregat",
	bbr_electricalReq: "{type}:",
	bbr_warning: "Varning:",
	bbr_permitTitle: "Bygglovshjälp",
	bbr_permitStatus: "Status:",
	bbr_permitArea: "Area:",
	bbr_fireNotification: "Eldstadsanmälan:",
	bbr_placementTitle: "Tomtplacering",
	bbr_boundary: "Tomtgräns:",
	bbr_fireGap: "Brandavstånd:",
	bbr_glassTitle: "Glaspenalty – Fönster & Värmeförlust",
	bbr_glassArea: "Total glasyta:",
	bbr_effectiveVolumeAdj: "Effektiv volym (justerad):",
	bbr_glassRequired: "Krav:",
	bbr_statusSufficient: "Tillräckligt",
	bbr_statusInsufficient: "Otillräckligt",
	bbr_benchTitle: "Lav-ergonomi",
	bbr_benchIntro:
		'Två modeller: Finsk (Löylyns lag, uppifrån) och Svensk (Byggbeskrivningar.se, nedifrån). Byggmax rekommenderar top-down ("lavarnas sitthöjd mäts från taket").',
	bbr_benchUpperFi: "🇫🇮 Övre lav (finsk):",
	bbr_benchLowerFi: "🇫🇮 Nedre fotlav (finsk):",
	bbr_benchUpperSe: "🇸🇪 Övre lav (svensk):",
	bbr_benchLowerSe: "🇸🇪 Nedre lav (svensk):",
	bbr_loylyStatus: "Löyly-status:",
	bbr_loylyPass: "Godkänd",
	bbr_loylyFail: "Underkänd",
	bbr_minCeiling: "Min. takhöjd:",
	bbr_roofJoistsTitle: "Takbjälkar & Snözon",
	bbr_roofAssemblyTitle: "Yttertakets kompletthet",
	bbr_roofAssemblyComplete: "Komplett",
	bbr_roofSystemLabel: "Takpaket:",
	bbr_roofAreaLabel: "Lutad takyta:",
	bbr_roofLayersLabel: "Lager:",
	bbr_roofAccessoriesLabel: "Obligatoriska beslag:",
	bbr_snowZone: "Snözon:",
	bbr_snowZoneIndoor: "Ej tillämpligt inomhus – huset tar snölasten",
	bbr_placementIndoorDesc: "Inga avstånd till tomtgräns eller andra byggnader. Bastun står i ett befintligt rum.",
	bbr_placementIndoor: "Inomhus",
	bbr_joistDimension: "Dimension:",
	bbr_joistSpacing: "c/c:",
	bbr_joistOk: "Standardvirke (C24) räcker för denna snözon och spännvidd.",
	bbr_fireTitle: "Brandskydd (Sotarens krav)",
	bbr_safetyDistance: "Säkerhetsavstånd:",
	bbr_sparkGuard: "Gnistskydd:",
	bbr_chimneyLabel: "Skorsten:",
	bbr_drainTitle: "Avlopp & Dränering",
	bbr_floorDrainRequired: "Krävs",
	bbr_floorDrainNotRequired: "Normalt inte nödvändig",
	bbr_floorSlope: "Golvlutning:",
	bbr_ventTitle: "Ventilation (Beräknad strategi)",
	bbr_ventIntake: "🔵 Tilluft (intag):",
	bbr_ventExhaust: "🔴 Frånluft (utsug):",
	bbr_ventMinArea: "Min. area per ventil:",
	bbr_ventFanRequired: "Krävs ✓",
	bbr_ventFanNotRequired: "Ej nödvändig",
	bbr_doorTitle: "Dörrsäkerhet (BBR)",
	bbr_touchGuardTitle: "Beröringsskydd",
	bbr_maxTempTitle: "Maxtemperatur",
	bbr_moistureTitle: "Fukt och Ångspärr (Utebastu)",
	bbr_elZoneTitle: "Elkablar & Zonindelning (SEK)",
	bbr_hotZone: "Varm zon (ovan {mm} mm):",
	bbr_coldZone: "Kall zon (under {mm} mm):",
	bbr_transformers: "Transformatorer:",
	bbr_ceilingLights: "Belysning i tak:",
	bbr_ceilingLightsDesc:
		"Takspottar och väggbelysning ovan bastu-lavarna kräver alltid silikonkabel och silikonbeständiga kopplingsdosor.",
	bbr_cableSpecTitle: "Elkabel-specifikation",
	bbr_cableType: "Kabel:",
	bbr_fuseLabel: "Säkring:",
	bbr_rcdLabel: "JFB:",
	bbr_sihfLength: "SiHF i varm zon:",
	bbr_totalCableLength: "Total kabellängd:",
	bbr_sectionDanger: "Fara",
	bbr_sectionWarning: "Varning",

	/* ── Rule body text (rendered in BBR pane) ────────────── */
	rule_fireSafetyDistance:
		"Ett vedeldat aggregat kräver ofta 500 mm avstånd till brännbart material. Halvera genom att montera brandskyddsskivor (minerit) med luftspalt.",
	rule_sparkGuard:
		"Plåt (eldstadsplan) under aggregatet, minst 300 mm framför kaminens lucka.",
	rule_chimney:
		"Isolera med obrännbar stenull, 100 mm säkerhetsavstånd till brännbara takbjälkar.",
	rule_ventilationIntake: "Lågt vid golvet, direkt vid/bakom aggregatet.",
	rule_ventilationExhaust: "Högt upp, diagonalt motsatt aggregatet.",
	rule_moistureBarrierOutdoor:
		"Den här modellen använder mineralull och bastufolie på varmsidan. Följ ett sammanhängande bastusystem med temperaturtåliga produkter och täta skarvar och genomföringar. Kravet är en fuktsäker konstruktion; bastufolie är inte ett universellt materialkrav för alla bastutyper. Rum-i-rummet, massivt timmer och andra isolersystem behöver sina egna detaljer. Yttertakets luftning och vindskydd ska lösas separat.",
	rule_doorSafety:
		"Bastudörren ska gå utåt och sakna lås och låsvred — en låst dörr kan stänga in någon i värmen. Använd magnettillhållare eller rullås och en dörrknopp i trä. Lämna 3–4 cm glipa under dörren för ventilation och tillräckligt spel runt karmen så att värmeutvidgning inte kan få dörren att fastna. Fönsterglaset ska vara härdat.",
	rule_maxTemperature:
		"Aggregatet ska vara så konstruerat att lufttemperaturen blir högst 110°C. Överväg termostat/tidur som extra säkerhet.",
	rule_touchGuard:
		"Kring aggregatet ska finnas ett beröringsskydd (trägaller/spjälbur) som hindrar oavsiktlig beröring av heta ytor. OBS: detta är INTE samma sak som mineritskivor (brandskydd mot väggar) — båda behövs!",
	rule_siliconeCableType: "Värmebeständig Silikonkabel (SiHF 3×1.5 mm², 180°C)",
	rule_standardCableType: "Standard Kabel (EKK 3×1.5 mm²)",
	rule_transformerWarning:
		"Placera transformatorn utanför bastun, om den inte sitter längst ner vid golvet (under 500 mm).",
	rule_mechanicalIntakeBan:
		"Mekanisk ventilation av tilluft till en fristående bastu avrådes starkt. Övertrycket kan pressa varm, fuktig luft in i väggkonstruktionen och orsaka fuktskador. Tilluft bör ske via självdrag (glipa under dörr eller ventil). Undantag: bastu i bostad med FTX-system kan ha mekanisk tilluft om systemet är korrekt dimensionerat.",

	/* ── Foundation Diagram Pane ──────────────────────────── */
	found_title: "Grundritning (Ovanifrån)",
	found_outerDimensions: "Yttermått:",
	found_pierCount: "Antal plintar:",
	found_pierUnit: "st",
	found_pierAriaLabel: "Plint {label}",
	found_beamCount: "Antal bärlinor:",
	found_piersPerBeam: "Plintar per bärlina:",
	found_plinthLength: "Vald plintlängd:",
	found_minBuried: "Min nedgrävning:",
	found_warnings: "Varningar:",
	found_digGuide: "Grävanvisning:",
	found_digInstructions:
		"Mät ut bastuns yttermått ({width} × {length} mm) på marken. Plintarnas positioner mäts från bastuns övre vänstra hörn:",
	found_pierFromLeft: "från vänsterkant",
	found_pierFromFront: "från framkant",
	found_pierVisible: "synlig plint",
	found_pierBuried: "nedgrävd del",
	found_pierRecommended: "rekommenderad plint",
	found_checkPlinth: "Kontrollera plintlängd:",
	found_specialSolution:
		"Lutningen kräver speciallösning utanför 900 mm standardplint.",
	found_chooseMinPlinth: "Välj minst {length} mm plint.",
	found_colPier: "Plint",
	found_colFromLeft: "X (från vänster)",
	found_colFromFront: "Z (från framsida)",
	found_colGroundLevel: "Marknivå",
	found_colVisibleHeight: "Synlig höjd",
	found_colBuriedPart: "Nedgrävd del",
	found_colStatus: "Status",
	found_statusOk: "OK",
	found_statusWarning: "Varning",
	found_selectPierHint: "Välj en plint i ritningen för att se specifika mått.",
	found_emptySelectionHint:
		"Grävanvisning — klicka på plintarna i skissen ovan för att se specifika instruktioner för varje plint.",

	/* ── Framing Diagram Pane ────────────────────────────── */
	framing_diagramTitle: "Väggstommar",
	framing_headerSpanWarning:
		"En öppning spänner längre än avväxlingstabellen täcker (1,5 m). Visad avväxling räcker inte — limträbalk dimensionerad av konstruktör krävs.",
	framing_frontWall: "Framvägg",
	framing_backWall: "Bakvägg",
	framing_leftWall: "Vänster vägg",
	framing_rightWall: "Höger vägg",
	framing_dividerWall: "Mellanvägg",
	framing_studCount: "Reglar",
	framing_dimensions: "Mått",

	/* ── Domain: Build Steps ───────────────────────────────── */
	domain_build_foundationTitle: "Grund & bjälklag",
	domain_build_drainageTitle: "Dränering & avlopp",
	domain_build_deckTitle: "Trall & altan",
	domain_build_framingTitle: "Väggstommar",
	domain_build_roofTitle: "Tak & väderskydd",
	domain_build_facadeTitle: "Fasad & ytterpanel",
	// ── Karaktärsval (issue 134) ──────────────────────────────
	domain_build_facadeTreatmentTitle: "Ytbehandling av fasad",
	domain_build_timeline_treatmentWeatherReason:
		"Stryk i uppehållsväder över +5 °C — regn inom torktiden tvättar av behandlingen.",
	domain_build_guide_facadeSubstepTreatment: "Stryk fasaden",
	domain_build_guide_calloutTreatmentWrong:
		"Stryker först när panelen suttit uppe en säsong och redan gråna ojämnt.",
	domain_build_guide_calloutTreatmentRight:
		"Stryk så snart panelen är monterad och torr — även ändträ och baksidan på lösa brädor.",
	domain_build_guide_facadeCheckpointTreatmentCoverage:
		"Hela fasaden struken, inklusive knutbrädor, foder och sockel.",
	domain_build_guide_facadeCheckpointTreatmentDrying:
		"Torktiden hållen innan nästa strykning eller slutbesiktning.",
	tool_facadeBrush: "Fasadpensel (bred)",
	tool_paintBucketAndStirrer: "Färghink & omrörare",
	tool_dropCloth: "Skyddspapp / täckduk",
	finish_sectionTitle: "Karaktär",
	finish_sectionIntro:
		"Träslag, panelriktning och utvändig kulör. Valen syns i 3D och räknas med i inköpslista, kapnota och pris.",
	finish_woodGroupLabel: "Träslag invändigt",
	finish_directionGroupLabel: "Panelriktning invändigt",
	finish_treatmentGroupLabel: "Utvändig kulör",
	finish_deltaIncluded: "Ingår",
	finish_wood_asp: "Asp",
	finish_wood_al: "Al",
	finish_wood_gran: "Gran",
	finish_wood_aspDescription:
		"Ljus, kvistfri och sval mot huden — klassiskt bastuträ.",
	finish_wood_alDescription:
		"Varm rödbrun ton som mörknar med åren. Mjuk yta, sval att sitta på.",
	finish_wood_granDescription:
		"Billigast och ljust gulaktig. Kan kåda i värmen — välj asp eller al till lavarna om du sitter direkt mot träet.",
	finish_direction_standing: "Stående",
	finish_direction_lying: "Liggande",
	finish_direction_standingDescription:
		"Panelen står. Ger rummet höjd och är det vanligaste i svenska bastur.",
	finish_direction_lyingDescription:
		"Panelen ligger. Får rummet att kännas bredare — glespanelen bakom vänds till stående läkt.",
	finish_treatment_untreated: "Obehandlad",
	finish_treatment_tjarvitriol: "Tjärvitriol",
	finish_treatment_jarnvitriol: "Järnvitriol",
	finish_treatment_slamfargRed: "Slamfärg röd",
	finish_treatment_slamfargBlack: "Slamfärg svart",
	finish_treatment_untreatedDescription:
		"Granpanelen får grå av sig själv. Inget att stryka, inget att underhålla.",
	finish_treatment_tjarvitriolDescription:
		"Mörk varm brun. En strykning, drygar cirka 7 m² per liter.",
	finish_treatment_jarnvitriolDescription:
		"Styr gråningen till en jämn silverton. En strykning, billigast per m².",
	finish_treatment_slamfargRedDescription:
		"Falurött med matt, kritig yta. Två strykningar.",
	finish_treatment_slamfargBlackDescription:
		"Svart med matt, kritig yta. Två strykningar.",
	term_saunaPanel: "Bastupanel",
	term_exteriorTreatmentTjarvitriol: "Tjärvitriol (fasadbehandling)",
	term_exteriorTreatmentJarnvitriol: "Järnvitriol (fasadbehandling)",
	term_exteriorTreatmentSlamfargRed: "Slamfärg röd (fasadbehandling)",
	term_exteriorTreatmentSlamfargBlack: "Slamfärg svart (fasadbehandling)",
	term_qty_litre: "liter",
	term_cut_interiorPanelLyingRuns: "Fram/bak {width} mm, sidor {length} mm",
	term_dim_treatmentCoatsSingle: "{coats} strykning, {coverage} m²/liter",
	term_dim_treatmentCoatsPlural: "{coats} strykningar, {coverage} m²/liter",
	term_cut_interiorPanelStanding: "Bastupanel stående",
	term_cut_interiorPanelLying: "Bastupanel liggande",
	domain_build_insulationTitle: "Isolering & panel",
	domain_build_benchesTitle: "Lavar & inredning",
	domain_build_systemsTitle: "Aggregat, ventilation & el",
	domain_build_chimneyTitle: "Skorsten & brandskydd",
	domain_build_handoverTitle: "Slutkontroll & besiktning",
	domain_build_framingDesc:
		"Skruva ihop väggarna plant, res dem med stöd och lämna fästen för lavar och öppningar.",
	domain_build_roofDesc:
		"Montera takbjälkar, råspont, tätskikt och färdiga vindskivor/takfotsavslut innan ytterpanelen stänger konstruktionen.",
	domain_build_facadeDesc:
		"Bygg luftspalt, vindskydd, ytterpanel och nederkantsavslut så att bastun kan torka ut efter bad utan att plintgrunden kläs in.",
	domain_build_insulationDesc:
		"Fyll vägg- och takfack, montera panel med luftning bakom och lämna rörelsefogar.",
	domain_build_benchesDesc:
		"Bygg lavar i flera nivåer med mjuka kanter och dold infästning för bättre komfort.",
	domain_build_systemsDescWood:
		"Förbered vedkaminens placering, skyddsskivor och ventilation innan skorstenen monteras separat.",
	domain_build_systemsDescElectric:
		"Förbered elaggregat, kabeldragning, jordfelsbrytare och ventilation enligt elspecifikation.",
	domain_build_foundationDescDefault:
		"Ställ ut plintar/bärlinor, montera bjälklag och säkerställ kapillärbrytande lager.",
	domain_build_drainageDescShower: "Planera duschläge tidigt.",
	domain_build_drainageDescNoShower: "Säkra markdränering innan golvet stängs.",
	domain_build_deckDesc:
		"Bygg trallen medan grunden är öppen och kontrollera regelavstånd, bärlinor och springor innan sista raden skruvas.",
	domain_build_chimneyDesc:
		"Montera skorsten, håll genomföring rätt och följ brandskyddskrav.",
	domain_build_handoverDescWood:
		"Boka sotare för provtryckning/slutbesiktning innan första eldning.",
	domain_build_handoverDescElectric:
		"Gör funktionskontroll av elaggregat, ventilation och dörrsäkerhet före första bastubadet.",
	domain_build_badgeDiy: "✅ Gör själv",
	domain_build_badgeDiyReason:
		"Detta steg är normalt lämpligt för en händig byggare.",
	domain_build_badgeElectrician: "⚠️ Anlita elektriker",
	domain_build_badgeElectricianReason:
		"Lagkrav: elaggregat ska anslutas av auktoriserad elektriker.",
	domain_build_badgeChimneySweep: "⚠️ Anlita sotare/skorstensinstallatör",
	domain_build_badgeChimneyReason:
		"Lagkrav: brandsäker skorstensinstallation och besiktning krävs vid vedeldning.",
	domain_build_badgePlumber: "⚠️ VVS-montör kan behövas",
	domain_build_badgePlumberReason:
		"Rekommendation: duschläge med golvbrunn och VA-anslutning kräver ofta VVS-stöd.",
	domain_build_badgeSystemsDiyReason:
		"Kaminplacering, ventilation och skyddsskivor kan normalt förberedas själv före skorstenssteget.",
	domain_build_toolGroupCommon: "Vanliga hem-verktyg",
	domain_build_toolGroupSpecialist: "Behöver köpa/hyra",

	/* ── Domain: Build — Tool Names ──────────────────────── */
	tool_measuringStick: "Tumstock",
	tool_chalkLine: "Snörslå",
	tool_screwdriver: "Skruvdragare",
	tool_earthAugerOrSpade: "Jordborr eller spade",
	tool_laserLevel: "Laserpass",
	tool_mitreSaw: "Kap-/gersåg",
	tool_spiritLevel: "Vattenpass",
	tool_clamps: "Tvingar",
	tool_hammer: "Hammare",
	tool_nailGunOrScrewdriver: "Spikpistol eller skruvdragare",
	tool_ladder: "Stege",
	tool_utilityKnife: "Mattkniv",
	tool_nailGun: "Spikpistol",
	tool_fallProtection: "Fallskydd vid större bastur",
	tool_carpenterSquare: "Snickarvinkel",
	tool_nailPunch: "Spikdrivare",
	tool_panelSaw: "Panelsåg",
	tool_scaffoldOrTrestles: "Ställning eller arbetsbockar",
	tool_insulationKnife: "Isolerkniv",
	tool_protectiveGloves: "Skyddshandskar",
	tool_panelClipTool: "Panelclipsverktyg",
	tool_plungeSaw: "Sänksåg",
	tool_sandingBlock: "Slipkloss",
	tool_routerRoundedEdges: "Överhandsfräs för mjuka kanter",
	tool_tapeMeasure: "Måttband",
	tool_drillPress: "Borrmaskin",
	tool_multimeter: "Multimeter",
	tool_torqueScrewdriver: "Momentmejsel",
	tool_tinSnips: "Plåtsax",
	tool_spade: "Spade",
	tool_straightedge: "Rätskiva",
	tool_groundCompactor: "Markvibrator",
	tool_pipeCutter: "Röravskärare",
	tool_rivetTool: "Nitbits",
	tool_chimneyPipeCutter: "Rörskärare för skorsten",
	tool_scaffoldOrFallProtection: "Ställning eller fallskydd",
	tool_checklist: "Checklista",
	tool_mobileCamera: "Mobilkamera",
	tool_moistureMeterOptional: "Fuktmätare (valfritt)",
	tool_spacers5mm: "Distansbrickor 5 mm",
	tool_fireboardCutter: "Skyddsskivekap",
	tool_ventDrillJig: "Borrmall för ventil",
	tool_groundFabric: "Markduk",
	tool_wheelbarrow: "Skottkärra",
	tool_stapleGun: "Häftpistol",
	tool_aluminiumTape: "Aluminiumtejp",
	tool_rubberMallet: "Gummiklubba",
	tool_bandTensioner: "Bandspännare",
	tool_glassSuctionLifter: "Glaslyft / sugkopp",

	/* ── Domain: Build — Partition Description ───────────── */
	domain_build_partitionBlocking:
		"Mellanväggen ligger mellan sidoreglarna och kräver {count} kortling i ytterväggen för korrekt infästning.",
	domain_build_partitionBlockingPlural:
		"Mellanväggen ligger mellan sidoreglarna och kräver {count} kortlingar i ytterväggarna för korrekt infästning.",
	domain_build_foundationPlintsDeeper: "{count} plintar kräver djupare hål.",
	domain_build_guide_kickoffTitle: "Byggstart",
	domain_build_guide_kickoffSummary:
		"Lås plats, grund och kritiska installationer innan du börjar med steg-för-steg-guiden.",
	domain_build_guide_kickoffHighlightFoundation: "Grund",
	domain_build_guide_kickoffHighlightFoundationValue: "{count} plintar",
	domain_build_guide_kickoffHighlightOpenings: "Öppningar",
	domain_build_guide_kickoffHighlightOpeningsValue: "{count} öppningar",
	domain_build_guide_kickoffHighlightTime: "Tid",
	domain_build_guide_kickoffHighlightTimeValue: "~{hours} timmar",
	domain_build_guide_kickoffHighlightProfessional: "Facksteg",
	domain_build_guide_kickoffHighlightProfessionalValue: "{count} facksteg",
	domain_build_guide_foundationPurpose:
		"Sätt en rak, väldränerad grund som klarar lasten innan resten av byggsatsen låses fast.",
	domain_build_guide_foundationPrereqPermitOk:
		"Bekräfta att villkoren för {permitLabel} är uppfyllda innan schakt.",
	domain_build_guide_foundationPrereqPermitRequired:
		"Bekräfta {permitLabel} och startbesked innan schakt.",
	domain_build_guide_foundationPrereqPlacement:
		"Mät ut läget på tomten och kontrollera avstånd mot tomtgräns och andra byggnader.",
	domain_build_guide_foundationCheckpointMarkPiers:
		"Markera ut {count} plintlägen enligt grundritningen.",
	domain_build_guide_foundationCheckpointMarkPiersFallback:
		"Markera ut alla plintlägen enligt grundritningen.",
	domain_build_guide_foundationCheckpointBeams:
		"Kontrollera att {count} bärlinor ligger i rätt centrumlinjer.",
	domain_build_guide_foundationCheckpointDrainLayer:
		"Förbered markduk, makadam och kapillärbrytning innan bjälklaget stängs.",
	domain_build_guide_foundationMaterialsPiers: "{count} plintar totalt.",
	domain_build_guide_foundationMaterialsBeams:
		"{count} bärlinor med cirka {length} löpmeter.",
	domain_build_guide_foundationFallbackMaterials:
		"Bekräfta grundmaterial mot inköpslistan.",
	domain_build_guide_foundationFallbackCuts:
		"Kontrollera kapnota för bärlinor och bjälklag innan kapning.",
	domain_build_guide_foundationRiskSkew:
		"Sneda plintlinjer ger följdfel i stomme, panel och dörrhängning.",
	domain_build_guide_foundationControlDiagonal:
		"Dubbelmät diagonaler innan plintar eller plattor låses.",
	domain_build_guide_deckPurpose:
		"Bygg trallen medan grunden fortfarande är fullt tillgänglig och innan stomresningen blockerar arbetsytan.",
	domain_build_guide_deckPrereq:
		"Grundlinjer och plintplacering ska vara kontrollerade innan reglar och bärlinor monteras.",
	domain_build_guide_deckCheckpointLayout:
		"Kontrollera diagonalmatning och ytterkanter innan trallbrädor skruvas.",
	domain_build_guide_deckCheckpointCc:
		"Verifiera regelavstånd c/c {cc} mm och plintspann mot deck-kalkylen.",
	domain_build_guide_deckCheckpointCcFallback:
		"Verifiera regelavstånd och plintspann mot deck-kalkylen.",
	domain_build_guide_deckCheckpointBoards:
		"Skruva {count} trallbrädor med jämn springa och infästning i varje regel.",
	domain_build_guide_deckCheckpointBoardsFallback:
		"Skruva trallbrädorna med jämn springa och infästning i varje regel.",
	domain_build_guide_deckSubstepBearers: "Bärlinor & upplag",
	domain_build_guide_deckSubstepJoists: "Reglar & c/c-avstånd",
	domain_build_guide_deckSubstepBoards: "Trallmontering",
	domain_build_guide_deckMeasurementBearers:
		"{count} bärlinor {dimension} på plintarnas upplag.",
	domain_build_guide_deckMeasurementJoists:
		"{count} reglar {dimension} med c/c {cc} mm.",
	domain_build_guide_deckBoardMaterialFallback:
		"Bekräfta trallbrädor mot inköpslistan innan du börjar skruva.",
	domain_build_guide_calloutDeckBoardWrong:
		"Trall lagd utan springa eller med bräda mot mark suger fukt och ruttnar.",
	domain_build_guide_calloutDeckBoardRight:
		"Lämna 4–6 mm springa och håll trallen fri från mark så den kan torka.",
	domain_build_guide_crewReasonDeckBearers:
		"Två personer håller bärlinorna i våg medan de riktas mot plintarnas upplag.",
	domain_build_guide_deckFallbackMaterials:
		"Bekräfta trallmaterial mot inköpslistan innan byggstart.",
	domain_build_guide_deckFallbackCuts:
		"Kontrollera kapnota för trall, reglar och bärlinor.",
	domain_build_guide_deckRiskSupport:
		"Fel c/c-avstånd eller för få stödpunkter ger svikt och förkortad livslängd i trallen.",
	domain_build_guide_deckRiskGap:
		"Utan springa mellan brädor riskerar trallen att resa sig när den fuktar upp.",
	domain_build_guide_deckControlDiagonal:
		"Dubbelmät diagonaler innan sista raden skruvas fast.",
	domain_build_guide_deckControlSpacers:
		"Använd distanser för jämn springa mellan trallbrädorna.",
	domain_build_guide_moreRows: "+ {count} till",
	domain_build_guide_foundationPlinthWarningGroundHigh:
		"{count} plint(ar): marken ligger för högt mot bärlinan — justera schakt eller plintlängd.",
	domain_build_guide_foundationPlinthWarningPlinthShort:
		"{count} plint(ar): vald plintlängd räcker inte för minsta nedgrävning — välj längre plint.",
	domain_build_guide_foundationCheckpointPlinthWarning:
		"Åtgärda {count} plintläge(n) som kalkylen flaggat innan bärlinorna monteras.",
	domain_build_guide_calloutPlinthWrong:
		"Att gjuta plintarna utan att hantera markens lutning ger sneda upplag och sättningar.",
	domain_build_guide_calloutPlinthRight:
		"Justera schakt eller plintlängd per flaggat läge så alla upplag hamnar i samma plan.",
	domain_build_guide_drainagePurpose:
		"Samordna golvets fall och eventuella rör innan interiören låser bjälklaget.",
	domain_build_guide_drainagePrereq:
		"Grund och bjälklag måste vara inmätta innan rördragning eller fall bestäms.",
	domain_build_guide_drainageCheckpointFloorDrain:
		"Bekräfta golvbrunnens läge mot golvbjälklaget.",
	domain_build_guide_drainageCheckpointGroundDrain:
		"Bekräfta att markdränering leder bort vatten från bastun.",
	domain_build_guide_drainageFallbackMaterials:
		"Dräneringsmaterial saknar separat fas, kontrollera grundinköpen manuellt.",
	domain_build_guide_drainageCutNoSeparate:
		"Ingen separat kapnota. Säkerställ i stället att genomföringar inte krockar med bjälkar.",
	domain_build_guide_drainageRiskFloorDrain:
		"Felplacerad golvbrunn tvingar ombyggnad av bjälklaget.",
	domain_build_guide_drainageControlShower:
		"Samordna golvbrunn och fall med VVS innan panel och golv monteras.",
	domain_build_guide_drainageControlGround:
		"Kontrollera att vatten leds bort från plintar och blindbotten.",
	domain_build_guide_framingPurpose:
		"Res väggarna i rätt ordning så att öppningar, laster och infästningar hamnar rätt från början.",
	domain_build_guide_framingPrereq:
		"Grunden ska vara i våg och bjälklaget fixerat innan väggarna reses.",
	domain_build_guide_framingSubstepLayout: "Res och rikta vägglinjerna",
	domain_build_guide_framingSubstepOpenings: "Lås öppningar och genomgångar",
	domain_build_guide_framingSubstepBrace: "Förankra och staga stommen",
	domain_build_guide_framingCheckpointOpenings:
		"Verifiera {count} öppningar mot ritning och kapnota.",
	domain_build_guide_framingCheckpointSquare:
		"Mät diagonaler när väggarna är resta innan de låses permanent.",
	domain_build_guide_framingCheckpointPartitionSupport:
		"Mellanväggen hamnar mellan sidoreglar och kräver {count} kortlingar i ytterväggarna innan den låses.",
	domain_build_guide_framingMaterialPartitionSupport:
		"Komplettera stomsteget med {count} kortlingar för mellanväggsanslutning.",
	domain_build_guide_framingFallbackMaterials:
		"Bekräfta reglar, syll och överstycken mot inköpslistan.",
	domain_build_guide_framingFallbackCuts:
		"Kontrollera kapnota för reglar och öppningsstycken.",
	domain_build_guide_framingRiskOpenings:
		"Felplacerade öppningar ger följdfel i panel, glas och inredning.",
	domain_build_guide_framingRiskPartition:
		"Om kortling utelämnas får mellanväggen svag sidinfästning mot ytterväggarna.",
	domain_build_guide_framingControlBrace:
		"Lås väggarna tillfälligt med stöd tills alla öppningsmått är verifierade.",
	domain_build_guide_framingControlPartition:
		"Förankra mellanväggens kantreglar i stomme eller kortling, inte bara i panelbeklädnaden.",
	domain_build_guide_crewReasonWallFrames:
		"Två personer håller vägglinjerna raka medan stommen reses och stagas.",
	domain_build_guide_crewReasonRoofFrames:
		"Takreglar och upplag blir säkrare att rikta och låsa när en person håller upp medan den andra fäster.",
	domain_build_guide_crewReasonRoofLift:
		"Skivor, tätskikt och droppkant går snabbare och säkrare när någon håller materialet i läge.",
	domain_build_guide_crewReasonBarrelBands:
		"Spännband på tunnbastu måste dras jämnt medan någon annan håller stavarna i linje.",
	domain_build_guide_crewReasonBarrelStaves:
		"Stavarna sätter sig jämnare när en person driver dem med gummiklubba och den andra håller tunnan rund.",
	domain_build_guide_crewReasonBarrelEnds:
		"Gavlar och öppningsdetaljer blir lättare att passa in när en person håller linjen och den andra fäster.",
	domain_build_guide_crewReasonGlassDoor:
		"Glasdörr och karm behöver ett extra par händer för att inte vridas eller tappas vid montage.",
	domain_build_guide_crewReasonFoil:
		"Folieskarvar blir tätare när en person sträcker folien och den andra häftar och tejpar.",
	domain_build_guide_crewReasonHeaterLift:
		"Aggregat, skyddsskivor och underlag blir säkrare att lyfta och rikta två personer.",
	domain_build_guide_barrelShellTitle: "Vaggor och stavskal",
	domain_build_guide_barrelShellPurpose:
		"Nivellera vaggorna först och bygg sedan skalet stav för stav så att tunnan håller formen från start.",
	domain_build_guide_barrelShellPrereq:
		"Grundbalkarna ska vara i nivå innan några vaggor eller stavar låses.",
	domain_build_guide_barrelShellSubstepCradles:
		"Rikta vaggor och tunnans centrumlinje",
	domain_build_guide_barrelShellSubstepStaves:
		"Driv in stavarna med gummiklubba",
	domain_build_guide_barrelShellCheckpointCradlesLevel:
		"Shimsa och nivellera varje vagga så att tunnans centrumlinje är rak från framkant till bakkant.",
	domain_build_guide_barrelShellCheckpointCradlesSpacing:
		"Lås vaggornas inbördes läge innan första staven fästs så att skalet inte börjar skruva sig senare.",
	domain_build_guide_barrelShellCheckpointStavesStarter:
		"Börja från referensstaven och kontrollera spont/spår innan stavsekvensen går vidare i tempo.",
	domain_build_guide_barrelShellCheckpointStavesSequence:
		"Sätt stavarna successivt med gummiklubba och håll tunnan rund medan varje rad sluter sig.",
	domain_build_guide_barrelShellCradleFallback:
		"Ha vaggor och stöd framlagda innan stavskalet börjar byggas.",
	domain_build_guide_barrelShellStavesFallback:
		"Räkna och sortera stavpaketet innan skalmontaget startar.",
	domain_build_guide_barrelShellCutsFallback:
		"Kontrollera kapnota för vaggprofiler och stavlängder innan skalet stängs.",
	domain_build_guide_barrelShellRiskTwist:
		"Om vaggorna inte står i nivå eller stavarna drivs ojämnt vrider sig tunnan och gavlarna blir svåra att passa in.",
	domain_build_guide_barrelShellControlReference:
		"Håll en tydlig centrumlinje och kontrollera rundheten ofta i stället för att försöka rädda formen sent.",
	domain_build_indoorCeilingTitle:
		"Innertaksbjälkar",
	domain_build_indoorOuterTitle:
		"Utsida mot rummet",
	domain_build_guide_indoorCeilingPurpose:
		"Bär bastuns innertak, isolering och folie. Huset ovanför tar snö och regn, så här behövs varken lutning, råspont eller tätskikt.",
	domain_build_guide_indoorCeilingPrereq:
		"Väggstommarna ska stå i lod och vara förankrade i golvet innan bjälkarna läggs på hammarbanden.",
	domain_build_guide_indoorCeilingSubstep:
		"Lägg innertaksbjälkar på hammarbanden",
	domain_build_guide_indoorCeilingCheckpoint:
		"Bjälkarna kapas i liv med väggarna, utan överhäng, c/c 600 mm.",
	domain_build_guide_indoorCeilingRisk:
		"Skorstenen går genom både bastutaket och husets bjälklag. Varje genomföring behöver sitt eget brandskydd.",
	domain_build_guide_indoorCeilingControl:
		"Kontrollera att innertaket är i våg innan folie och panel monteras.",
	domain_build_guide_indoorOuterPurpose:
		"Fria väggar syns från rummet och får panel och foder direkt på reglarna. Här hängs också dörren.",
	domain_build_guide_indoorOuterPrereq:
		"Stommen och innertaket ska vara klara och väggarna mot rummet ska ha sin träfiberskiva.",
	domain_build_guide_indoorFibreboardSubstep:
		"Skruva träfiberskiva på väggar mot befintlig vägg",
	domain_build_guide_indoorFibreboardWrong:
		"Resa väggen först och försöka få in skivan bakom den.",
	domain_build_guide_indoorFibreboardRight:
		"Skruva skivan på reglarna medan väggen ligger ner. Efteråt kommer du inte åt.",
	domain_build_guide_indoorFibreboardCheckpoint:
		"Minst 20 mm luftspalt mellan skivan och rummets vägg hela vägen.",
	domain_build_guide_indoorOuterPanelSubstep:
		"Panel och foder på fria väggar",
	domain_build_guide_indoorOuterPanelCheckpoint:
		"Panelen spikas direkt på reglarna. Inomhus behövs varken vindskydd eller läkt.",
	domain_build_guide_indoorOuterControl:
		"Kontrollera att foder täcker springan runt dörr och fönster.",
	domain_build_guide_indoorDrainagePrereq:
		"Mät in golvets fall och befintlig golvbrunn innan rördragning bestäms.",
	domain_build_guide_indoorDrainageControl:
		"Kontrollera att golvet under bastun är torrt och tål fukt.",
	domain_build_guide_indoorFramingPrereq:
		"Det befintliga golvet ska vara i våg och bjälklaget fixerat innan väggarna reses.",
	domain_build_guide_indoorMoisturePrereq:
		"Bestäm luftspalt, träfiberskiva och tätade anslutningar innan isoleringen byggs in. Följ en sammanhängande lösning för inomhusbastu.",
	domain_build_guide_kickoffSummaryNoFoundation:
		"Lås placering och kritiska installationer innan du börjar med steg-för-steg-guiden.",
	domain_build_guide_roofPurpose:
		"Stäng huset vädertätt tidigt så att stomme och isolering inte står öppna för nederbörd.",
	domain_build_guide_roofPrereq:
		"Väggstommar och takupplag ska vara låsta och i lod innan råspont eller tätskikt läggs.",
	domain_build_guide_roofSubstepJoists: "Montera takreglar och upplag",
	domain_build_guide_roofSubstepGables: "Bygg gavlar och utfyllnad",
	domain_build_guide_roofSubstepWeather: "Stäng taket vädertätt",
	domain_build_guide_roofCheckpointJoists:
		"Bekräfta takregel {dimension} c/c {spacing} mm.",
	domain_build_guide_roofCheckpointJoistsFallback:
		"Bekräfta takregel och centrumavstånd mot ritning.",
	domain_build_guide_roofCheckpointGableInfill:
		"Montera gaveltakstolar (2 st) på front/back hammarband och fyll gaveltriangeln med gavelfyllnadsreglar innan ytterpanel stängs.",
	domain_build_guide_roofCheckpointWeather: "Takpaket: {layers}.",
	domain_build_guide_roofCheckpointWeatherFallback:
		"Tätskikt och vindskivor ska vara monterade innan ytterpanelen stängs.",
	domain_build_guide_roofMaterialsLayers: "Yttertak: {layers}.",
	domain_build_guide_roofMaterialsAccessories: "Beslag: {accessories}.",
	domain_build_guide_roofFallbackMaterials:
		"Bekräfta råspont, läkt och tätskikt mot inköpslistan.",
	domain_build_guide_roofFallbackCuts:
		"Kontrollera kapnota för takreglar och råspont.",
	domain_build_guide_roofRiskMoisture:
		"Otät takfot eller ofärdigt tätskikt låser in fukt i vägg och isolering.",
	domain_build_guide_roofControlFinishWeather:
		"Avsluta väderskyddet innan fasad och interiör startar.",
	domain_build_guide_roofControlAccessories:
		"Verifiera att följande beslag ingår: {accessories}.",
	domain_build_guide_roofBarrelMaterialBands:
		"Spännband och beslag till tunnans stavpaket ska ligga framme före slutdragning.",
	domain_build_guide_barrelRoofTitle: "Valvets väderskydd",
	domain_build_guide_barrelRoofPurpose:
		"Skydda det krökta stavskalet med planerade taklager innan väta eller inre fukt når träpaketet.",
	domain_build_guide_barrelRoofPrereq:
		"Stavskal och gavlar ska vara låsta innan valvets täckning går på.",
	domain_build_guide_barrelRoofSubstepWeather: "Klä och täta tunnans valv",
	domain_build_guide_barrelRoofCheckpointWeather:
		"Lägg det krökta takpaketet över valvet: {layers}.",
	domain_build_guide_barrelRoofCheckpointWeatherFallback:
		"Avsluta valvets väderskydd innan tunnan lämnas öppen över natt.",
	domain_build_guide_barrelRoofFallbackMaterials:
		"Bekräfta krökt taktäckning och kanttätning mot inköpslistan.",
	domain_build_guide_barrelRoofCutsFallback:
		"Kontrollera kapnota för stavtrimning innan taktäckningen låses.",
	domain_build_guide_barrelRoofRiskWeather:
		"Ett halvfärdigt valv släpper snabbt in vatten i stavskalet och gör senare banddragning svårare.",
	domain_build_guide_barrelRoofControlWeather:
		"Avsluta ett helt väderskyddslager runt valvet i taget så att ingen del av tunnan lämnas halvöppen.",
	domain_build_guide_facadePurpose:
		"Bygg luftad fasad som tål väder och låter konstruktionen torka ut efter användning.",
	domain_build_guide_facadePrereq:
		"Taket ska vara vädertätt innan luftspalt och ytterpanel går upp.",
	domain_build_guide_facadeSubstepCladding:
		"Montera korsläkt (stående ströläkt + liggande spikläkt) och ytterpanel",
	domain_build_guide_facadeSubstepDoor: "Häng dörr och lås öppningsdetaljer",
	domain_build_guide_facadeCheckpointAirGap:
		"Lämna luftspalt och nederkantsavslut öppna så att fasaden kan torka ut.",
	domain_build_guide_facadeCheckpointOpeningsVent:
		"Kontrollera att dörr- och fönsterfoder inte blockerar ventilationen runt öppningarna.",
	domain_build_guide_facadeCheckpointDoorSafety:
		"Bekräfta att bastudörren öppnar utåt, saknar lås/regellås och har trähandtag invändigt.",
	domain_build_guide_facadeFallbackMaterials:
		"Bekräfta panel, vindskydd och läkt mot inköpslistan.",
	domain_build_guide_facadeFallbackCuts:
		"Kontrollera kapnota för panel och eventuella foder.",
	domain_build_guide_facadeRiskMoisture:
		"Stängd nederkant eller feldetaljer kring öppningar leder till fuktproblem.",
	domain_build_guide_facadeControlVentilated:
		"Låt plintgrunden vara ventilerad även när fasaden är klar.",
	domain_build_guide_barrelEndsTitle: "Gavlar och öppningar",
	domain_build_guide_barrelEndsPurpose:
		"Passa in de runda gavlarna och öppningsdetaljerna innan spännbanden får sin slutliga dragning.",
	domain_build_guide_barrelEndsPrereq:
		"Stavskalet måste hålla rund form innan fram- och bakgavel låses.",
	domain_build_guide_barrelEndsSubstepCaps: "Sätt gavlar, dörr och ventiler",
	domain_build_guide_barrelEndsCheckpointCaps:
		"Prova båda gavlarna och kontrollera att skalet är runt hela vägen runt öppningen.",
	domain_build_guide_barrelEndsCheckpointDoor:
		"Rikta dörröppning och ventiluttag innan infästningarna runt gaveln slutdras.",
	domain_build_guide_barrelEndsFallbackMaterials:
		"Bekräfta gavlar och dörrpaket innan frontöppningen stängs.",
	domain_build_guide_barrelEndsFallbackCuts:
		"Kontrollera kapnota för gavlar innan de cirkulära kanterna låses permanent.",
	domain_build_guide_barrelEndsRiskRound:
		"Tvingas gavlarna in i ett ovalt skal driver både dörrpassning och banddragning ur tolerans.",
	domain_build_guide_barrelEndsControlMeasure:
		"Mät tunnan i två riktningar medan gavlarna passas in så att rundheten hålls, inte gissas.",
	domain_build_guide_insulationPurpose:
		"Lås värme och fukt rätt i väggar och tak innan aggregat och inredning monteras.",
	domain_build_guide_insulationPrereq:
		"Ytterhöljet ska vara vädertätt innan isolering och invändig bastupanel monteras.",
	domain_build_guide_insulationSubstepInsulation: "Fyll vägg- och takfack",
	domain_build_guide_insulationSubstepFoil: "Tät bastufolien",
	domain_build_guide_insulationSubstepPanel: "Montera läkt, panel och taklist",
	domain_build_guide_insulationCheckpointFill:
		"Fyll vägg- och takfack utan glipor runt öppningar och takanslutningar.",
	domain_build_guide_insulationCheckpointFoil:
		"Montera bastufolie/aluminium i varm zon innan panelen går upp.",
	domain_build_guide_insulationCheckpointBattens:
		"Montera takgles/spikläkt under takreglarna så att innertaket får en installationsspalt mellan bastufolie och bastupanel.",
	domain_build_guide_insulationFallbackMaterials:
		"Bekräfta isolering, folie och panel mot inköpslistan.",
	domain_build_guide_insulationFallbackCuts:
		"Kapnota för väggpanel, innertakspanel och taklist saknas separat, kontrollera panelmönster och spill manuellt.",
	domain_build_guide_insulationRiskBarrier:
		"Fel fuktspärr eller otät folie ger kondens och värmeläckage.",
	domain_build_guide_insulationRiskBattens:
		"Om innertakspanelen skruvas direkt i takreglarna utan läkt saknas luftspalt och folien blir svår att hålla tät.",
	domain_build_guide_insulationControlPhoto:
		"Fotografera genomföringar och folieskarvar innan panelen täcker dem.",
	domain_build_guide_insulationControlSequence:
		"Lås ordningen isolering -> bastufolie -> takgles/spikläkt -> bastupanel/taklist i både instruktion, BOM och kapnota.",
	domain_build_guide_insulationFoilMaterialFallback:
		"Ta fram bastufolie, aluminiumtejp och genomföringstejp innan skarvar stängs.",
	domain_build_guide_insulationPanelMaterialFallback:
		"Ta fram panel, läkt och dold infästning innan innerytan stängs.",
	domain_build_guide_barrelBandsTitle: "Spännband och sättning",
	domain_build_guide_barrelBandsPurpose:
		"Dra spännbanden jämnt och planera sedan en tidig efterdragning när det uppvärmda träet har satt sig.",
	domain_build_guide_barrelBandsPrereq:
		"Skal, gavlar och valvets väderskydd ska vara på plats innan slutlig banddragning startar.",
	domain_build_guide_barrelBandsSubstepTension: "Dra spännbanden jämnt",
	domain_build_guide_barrelBandsSubstepRetighten:
		"Planera första efterdragningen",
	domain_build_guide_barrelBandsCheckpointEven:
		"Spänn alla stålband stegvis runt tunnan i stället för att låsa ett band helt åt gången.",
	domain_build_guide_barrelBandsCheckpointRetighten:
		"Efterdra banden efter cirka 2-4 veckors sättning och första uppvärmningscykler.",
	domain_build_guide_barrelBandsFallbackMaterials:
		"Ha stålband och beslagspaket framme innan slutdragningen börjar.",
	domain_build_guide_barrelBandsFallbackCuts:
		"Kontrollera kapnota för bandlängder och överlapp innan spänningen tas upp.",
	domain_build_guide_barrelBandsRiskTension:
		"Ojämn bandspänning kan platta till tunnan, lossa gavlarna eller ge läckor när träet torkar.",
	domain_build_guide_barrelBandsControlSequence:
		"Arbeta runt tunnan i små dragsteg så att skalet håller formen medan banden tar last.",
	domain_build_guide_barrelBandsControlRetighten:
		"Skriv in datum för efterdragning i överlämningen så att momentet inte glöms efter leverans.",
	domain_build_guide_partitionSubstepTitle: "Stomma och förankra mellanväggen",
	domain_build_guide_partitionFallbackMaterials:
		"Bekräfta mellanväggsreglar och kortling innan rumsdelningen stängs.",
	domain_build_guide_partitionCheckpointBlocking:
		"Montera {count} kortlingar där mellanväggen landar innan rumsdelningen fästs.",
	domain_build_guide_partitionCheckpointAnchor:
		"Förankra mellanväggens kant i stomme eller kortling på båda sidoväggarna innan panel döljer skarven.",
	domain_build_guide_partitionCheckpointDirectAnchor:
		"Förankra mellanväggen direkt i linjerade reglar på båda sidoväggarna innan panelen stänger delningen.",
	domain_build_guide_glassWallSubstepTitle: "Montera panoramaglasväggen",
	domain_build_guide_glassWallCrewReason:
		"Glaspartierna är tunga och ömtåliga — lyft och rikta dem med två personer.",
	domain_build_guide_glassWallCalloutWrong:
		"Kila fast eller skruva direkt mot glaset, eller lyft stora rutor ensam.",
	domain_build_guide_glassWallCalloutRight:
		"Sätt glaset på klossar i avväxlingen, låt det röra sig fritt och foga elastiskt runt om — bär alltid rutorna med två personer och lyftkoppar.",
	domain_build_guide_glassWallMaterialFallback:
		"Härdat säkerhetsglas, glasklossar, EPDM-list och elastisk fogmassa för panoramaväggen.",
	domain_build_guide_glassWallCheckpointOpening:
		"Kontrollera att avväxling och mittregel är i lod och våg innan glaset sätts.",
	domain_build_guide_glassWallCheckpointSafetyGlass:
		"Använd härdat säkerhetsglas på {count} vägg(ar) — glasytan når {threshold} m² eller mer.",
	domain_build_guide_glassWallCheckpointGlassSpec:
		"Bekräfta glasspecifikationen mot bygglovsunderlaget innan beställning.",
	domain_build_guide_glassWallCheckpointSeal:
		"Foga tätt runt hela glaset så vatten leds ut och inte in i stommen.",
	domain_build_guide_relaxInsulationCheckpoint:
		"Isolera och foliera endast bastudelen — relaxdelen ska inte ha bastuisolering.",
	domain_build_guide_relaxVentCheckpoint:
		"Ventilera varje rum för sig: bastudelen med till- och frånluft, relaxdelen med egen luftväxling.",
	domain_build_guide_relaxBenchCheckpoint:
		"Bygg relaxdelens bänk separat från bastulaven — den möter andra höjd- och komfortkrav.",
	domain_build_guide_benchesPurpose:
		"Bygg ergonomi och säkerhet in i bastun innan aggregat och slutkontroll tar över.",
	domain_build_guide_benchesPrereq:
		"Planera kortlingar bakom panelen för lavarnas bärreglar. Infästningen ska nå bärande väggreglar eller kortlingar; panelen ensam räcker inte.",
	domain_build_guide_benchesCheckpointHeights:
		"Överlav cirka {upper} mm och underlav cirka {lower} mm.",
	domain_build_guide_benchesCheckpointHeightsFallback:
		"Bekräfta lavhöjder och gångytor innan infästning.",
	domain_build_guide_benchesCheckpointFinish:
		"Runda av synliga kanter och kontrollera dold infästning där kroppen möter träet.",
	domain_build_guide_benchesFallbackMaterials:
		"Bekräfta lavvirke och infästningar mot inköpslistan.",
	domain_build_guide_benchesFallbackCuts:
		"Kontrollera kapnota för lavar manuellt innan du kapar ädelträ.",
	domain_build_guide_benchesRiskComfort:
		"Fel lavhöjd eller hårda kanter försämrar både säkerhet och bastukänsla.",
	domain_build_guide_benchesControlTrialFit:
		"Provmontera laven på dess upplag. För en nedre lav på ändupplag lämnar den lösa ramen 10 mm spel vid varje ändvägg; långreglarna ska vila direkt på upplagen. Säkra mot förskjutning med det valda systemets stoppklossar eller demonterbara infästning. Kontrollera spännvidd, stomme, fasta mellanlägg och väggskruvens förankring i reglar eller kortlingar.",
	domain_build_guide_benchesMaterialFallback:
		"Ta fram knastfritt lavvirke i asp, al eller abachi samt dold infästning innan montage.",
	domain_build_guide_benchesMeasurementHeights:
		"Ergonomi: överlav {upper} mm och underlav {lower} mm från golv.",
	domain_build_guide_benchesSubstepFrame: "Lavstomme & höjder",
	domain_build_guide_benchesSubstepSeat: "Sits & ytbehandling",
	domain_build_guide_benchesSubstepHatch: "Lucka & åtkomst",
	domain_build_guide_benchesCheckpointHatch:
		"Bygg lös sitslucka eller demonterbar sektion för åtkomst till aggregat och städning.",
	domain_build_guide_crewReasonBenchFrame:
		"Två personer lägger lavstommen i våg på upplagen och säkrar infästningarna.",
	domain_build_guide_systemsPurposeWood:
		"Förbered kaminläge, ventilation och skyddsavstånd innan skorstenen avslutar värmesystemet.",
	domain_build_guide_systemsPurposeElectric:
		"Samordna elaggregat, ventilation och säker elanslutning innan slutkontroll.",
	domain_build_guide_systemsPrereq:
		"Invändig panel och lavar ska vara klara så att aggregatets verkliga placering kan låsas.",
	domain_build_guide_systemsSubstepPower:
		"Lås aggregat, kabel och skyddsavstånd",
	domain_build_guide_systemsSubstepVent: "Skär in till- och frånluft",
	domain_build_guide_systemsCheckpointElectric:
		"Bekräfta jordfelsbrytare, säkring och kabeldragning med elektriker innan spänningssättning.",
	domain_build_guide_systemsCheckpointWood:
		"Bekräfta kaminläge, skyddsplåtar och friskluftsintag innan skorstenen monteras.",
	domain_build_guide_systemsCheckpointVent:
		"Ventilation: tilluft {intake} mm och frånluft {exhaust} mm.",
	domain_build_guide_systemsCheckpointVentFallback:
		"Bekräfta till- och frånluft enligt ventilationsstrategin.",
	domain_build_guide_systemsFallbackMaterials:
		"Bekräfta aggregat, kabel eller ventilationsdetaljer mot inköpslistan.",
	domain_build_guide_systemsPowerMaterialFallback:
		"Ta fram kabel, genomföringar och värmetåliga detaljer enligt elspecen innan aggregatet lyfts in.",
	domain_build_guide_systemsVentMaterialFallback:
		"Ta fram ventilgaller och kanaldetaljer med minst {minArea} cm² fri area per ventil.",
	domain_build_guide_systemsCutElectric:
		"Ingen vanlig kapnota. Samordna kabelvägar och håltagning innan elektriker kopplar in.",
	domain_build_guide_systemsCutWood:
		"Kontrollera håltagning för ventil och kaminens skyddsavstånd innan avslut.",
	domain_build_guide_systemsRiskElectric:
		"Elaggregat får inte driftsättas utan auktoriserad inkoppling.",
	domain_build_guide_systemsRiskFan:
		"Ventilationen kräver fläkt och ska provköras innan slutmontage.",
	domain_build_guide_systemsControlCableSpec:
		"Elspec: {cableType}, {fuseLabel}, {rcdLabel}.",
	domain_build_guide_systemsControlElectric:
		"Dokumentera elarbetet och lämna plats för service runt aggregatet.",
	domain_build_guide_systemsControlWood:
		"Verifiera skyddsavstånd runt kamin och väggskydd innan första eldning.",
	domain_build_guide_systemsMeasurementCable:
		"Elspec: {cableType}, {fuseLabel}, cirka {totalCableLength} m total kabellängd.",
	domain_build_guide_systemsMeasurementVent:
		"Ventilation: tilluft {intake} mm, frånluft {exhaust} mm och minst {minArea} cm² fri area per ventil.",
	domain_build_guide_systemsMeasurementHotZone:
		"{count} elkomponent(er) i hetzonen kräver 180 °C silikonkabel (SiHF) — vanlig PVC smälter.",
	domain_build_guide_systemsCheckpointHotZone:
		"Bekräfta att {count} komponent(er) i hetzonen dras med värmebeständig silikonkabel.",
	domain_build_guide_calloutHeaterRightUnavailable:
		"Skyddsavstånd beräknas inte för den här bastutypen — följ aggregatets monteringsanvisning för minsta avstånd.",
	domain_build_guide_chimneyPurpose:
		"Slutför värmesystemet med rätt genomföring, skyddsavstånd och besiktning.",
	domain_build_guide_chimneyPrereq:
		"Kaminplacering och takgenomföring måste vara låsta innan skorstenen monteras.",
	domain_build_guide_chimneyCheckpointClearance: "Följ skyddsavståndet: {rule}",
	domain_build_guide_chimneyCheckpointBay:
		"Lås skorstenen i ett fritt takfack innan håltagning. Skorstenen får inte skära genom takbjälke eller takregel.",
	domain_build_guide_chimneyCheckpointCeilingFlange:
		"Montera innertakets täckplåt mot bastupanelens färdiga innertak, inte fritt hängande i luften.",
	domain_build_guide_chimneyCheckpointRoofPenetration:
		"Montera yttertakets genomföringsplåt och tätning mot det färdiga yttertaket. Håll minst 100 mm fritt avstånd mellan skorstensröret och alla brännbara takbjälkar. Fyll mellanrummet med obrännbar stenull (klass A1).",
	domain_build_guide_chimneyCheckpointStormCollar:
		"Montera stormkrage/regnkrage runt röret ovanför takplåten för att förhindra vatteninträngning.",
	domain_build_guide_chimneyCheckpointCap:
		"Montera takhuv/regnskydd på skorstenens topp för att skydda mot regn och snö.",
	domain_build_guide_chimneyCheckpointSweeper:
		"Boka sotare/skorstensinstallatör före första eldning.",
	domain_build_guide_chimneyMaterialsSystem:
		"{system} Ø{diameter} mm, höjd {height} m.",
	domain_build_guide_chimneyCutCenter:
		"Mät både innertakets centrum och yttertakets centrum en gång till innan håltagning i panel, tätskikt eller plåt.",
	domain_build_guide_chimneyCutMargin:
		"Markera utskärning i tak med 100 mm marginal runt rörets ytterdiameter (BBR 5:42).",
	domain_build_guide_chimneyRiskBeam:
		"Om skorstenen hamnar i samma linje som en takbjälke måste aggregat/skorsten flyttas till nästa fria takfack i stället för att bjälken kapas.",
	domain_build_guide_chimneyRiskFireSeal:
		"Felaktig brandtätning vid takgenomföring kan orsaka brand. Minst 100 mm brandklassad stenull (A1) krävs runt röret genom taket (BBR 5:42).",
	domain_build_guide_chimneyRiskStormCollar:
		"Saknad stormkrage leder till vatteninträngning i takkonstruktionen.",
	domain_build_guide_chimneyControlClearance:
		"Verifiera att alla brännbara material håller minst det CE-/manualangivna skyddsavståndet från skorstensrörets yta, minst 100 mm i denna standardlösning.",
	domain_build_guide_chimneyControlAnchors:
		"Fäst innertaksplåten mot det färdiga innertaket och yttertakets genomföring mot yttertaket; de är två separata infästningspunkter.",
	domain_build_guide_chimneyControlStormCollar:
		"Kontrollera att stormkragen sitter tätt mot takplåten utan glipor.",
	domain_build_guide_chimneyControlCap:
		"Kontrollera att takhuven sitter stabilt och att regn inte kan tränga in i röret.",
	domain_build_guide_chimneyControlDocuments:
		"Dokumentera installationen och spara besiktningsunderlag från sotare.",
	domain_build_guide_chimneyMeasurementClearance:
		"Skyddsavstånd och besiktning: {rule}",
	domain_build_guide_calloutFoilWrong:
		"Vänd inte bastufolien fel, använd inte vanlig byggplast i varmzonen och lägg inte dubbla ångspärrar i samma vägg.",
	domain_build_guide_calloutFoilRight:
		"Lägg en enda bastufolie på varmsidan med blanka sidan in mot bastun och tejpa alla skarvar med aluminiumtejp.",
	domain_build_guide_calloutPanelWrong:
		"Skruva inte panel direkt mot folien, lämna inte panel nära golvet och bygg inte med gips, spån eller OSB bakom bastupanelen.",
	domain_build_guide_calloutPanelRight:
		"Lås 12–28 mm luftspalt, minst 70 mm fri höjd mot golv och dold infästning i panel/lavar där kroppen möter träet.",
	domain_build_guide_calloutDoorWrong:
		"Montera inte en dörr som öppnar inåt, kärvar av värme eller kan låsas från utsidan.",
	domain_build_guide_calloutDoorRight:
		"Låt bastudörren öppna utåt, hoppa över lås/regel och använd trähandtag på insidan.",
	domain_build_guide_calloutBenchesWrong:
		"Använd inte kvistig panel, dra inte skruvskallar uppåt genom sitsen och lämna inte springorna för snålt.",
	domain_build_guide_calloutBenchesRight:
		"Bygg i asp, al eller abachi, håll cirka 15 mm springa mellan ribborna och skruva underifrån där det går.",
	domain_build_guide_calloutVentWrong:
		"Gör inte tilluften stängbar, underskatta inte ventilarean och lägg inte både till- och frånluft högt på samma vägg.",
	domain_build_guide_calloutVentRight:
		"Ge varje ventil minst {minArea} cm² fri area, låt tilluften vara öppen vid aggregatet och lägg frånluften högt diagonalt motsatt.",
	domain_build_guide_calloutHeaterWrong:
		"Tryck inte aggregat eller kamin mot brännbart material och lägg inte dörrgången så att den korsar heta skyddszoner.",
	domain_build_guide_calloutHeaterRight:
		"Lås aggregatet med minst {side} mm sida, {front} mm framåt och {ceiling} mm mot tak enligt clearance-beräkningen, helst på samma vägg som dörren.",
	domain_build_guide_calloutHeaterRightWood:
		"Lås kamin och dörr på samma vägg när planlösningen tillåter det och följ skyddsavståndet i manualen: {rule}.",
	domain_build_guide_calloutChimneyWrong:
		"Elda inte före slutbesked och skär inte skorstenen genom brännbara delar utan fri passage och brandtätning.",
	domain_build_guide_calloutChimneyRight:
		"Håll skyddsavståndet {rule}, använd godkänd brandtätning och boka sotarens slutkontroll före första eldning.",
	domain_build_guide_handoverPurpose:
		"Avsluta projektet med säkerhetskontroll, dokumentation och första provkörning.",
	domain_build_guide_handoverPrereqWood:
		"Skorsten och skyddsavstånd måste vara godkända före första eldning.",
	domain_build_guide_handoverPrereqElectric:
		"Elaggregat måste vara inkopplat och funktionsprovat av rätt kompetens.",
	domain_build_guide_handoverCheckpointWood:
		"Spara protokoll från sotare och gör första eldning med övervakning.",
	domain_build_guide_handoverCheckpointElectric:
		"Gör funktionskontroll av aggregat, ventilation och dörr innan första bastubad.",
	domain_build_guide_handoverSubstepSelfCheck: "Egenkontroll & slutbesked",
	domain_build_guide_handoverSubstepDocumentation: "Dokumentation & intyg",
	domain_build_guide_handoverSubstepFirstBath: "Intrimning & första bad",
	domain_build_guide_handoverCheckpointDocPhotos:
		"Samla foton på dolda installationer (folie, kabeldragning, ventilation) för framtida underhåll.",
	domain_build_guide_handoverCheckpointDocElectric:
		"Arkivera elinstallationsintyg och aggregatets provningsprotokoll.",
	domain_build_guide_handoverCheckpointDocWood:
		"Arkivera sotarens besiktningsprotokoll och skorstenens dokumentation.",
	domain_build_guide_handoverCheckpointFirstCure:
		"Kör aggregatet varmt utan bad första gången för att bränna av tillverkningsrester och lukt.",
	domain_build_guide_handoverCheckpointFirstBath:
		"Häll lite lag och kontrollera drag, temperatur och att inget luktar bränt innan första riktiga badet.",
	domain_build_guide_calloutFirstBathWrong:
		"Att bada direkt innan aggregatet bränts av ger obehaglig lukt och kan missfärga panelen.",
	domain_build_guide_calloutFirstBathRight:
		"Elda torrt först, vädra ut, och ta första badet när lukten är borta.",
	domain_build_guide_handoverMaterialNone:
		"Ingen ny materialfas. Säkerställ att allt installerat material stämmer mot PDF och inköpslista.",
	domain_build_guide_handoverCutNone:
		"Ingen ny kapnota. Samla i stället slutkontroller, foton och installationsbevis.",
	domain_build_guide_handoverRiskLate:
		"Missade slutkontroller visar sig först vid drift och blir dyrare att åtgärda efteråt.",
	domain_build_gate_electricianTitle: "Elektriker-gate före isolering",
	domain_build_gate_electricianPurpose:
		"Boka och lås all fast eldragning innan väggar och bastufolie stänger konstruktionen.",
	domain_build_gate_electricianLeadTime:
		"Boka elektriker {min}–{max} veckor innan isolering och bastufolie.",
	domain_build_gate_electricianChecklistFeed:
		"Bekräfta jordkabel fram till byggnaden samt säkring/jordfelsbrytare för aggregatets effekt.",
	domain_build_gate_electricianChecklistHeaterStub:
		"Bekräfta anslutningspunkt cirka 30 cm över golv bakom aggregatet innan väggarna stängs.",
	domain_build_gate_electricianChecklistConduit:
		"Dra VP-rör mellan isolering och ytterpanel, aldrig i varmzonen bakom bastufolien.",
	domain_build_gate_plumbingTitle: "VVS-gate för dusch och golvbrunn",
	domain_build_gate_plumbingPurpose:
		"Samordna golvbrunn, fall och rördragning med VVS innan bjälklaget låses.",
	domain_build_gate_plumbingLeadTime:
		"Boka VVS {min}–{max} veckor innan dränering och golvbrunn byggs in.",
	domain_build_gate_fireplaceNotificationTitle: "Eldstadsanmälan vid byggstart",
	domain_build_gate_fireplaceNotificationPurpose:
		"Skicka eldstadsanmälan direkt så att kommunens handläggningstid kan löpa medan du bygger.",
	domain_build_gate_fireplaceNotificationLeadTime:
		"Räkna med {min}–{max} veckors handläggning för eldstadsanmälan och startbesked.",
	domain_build_gate_fireplaceNotificationChecklistSubmit:
		"Skicka in eldstadsanmälan med aggregat-, skorsten- och placeringsunderlag innan byggtakten ökar.",
	domain_build_gate_fireplaceStartTitle:
		"Vänta på startbesked före vedinstallation",
	domain_build_gate_fireplaceStartPurpose:
		"Installera inte vedaggregat eller skorsten förrän startbeskedet för eldstaden är utfärdat.",
	domain_build_gate_fireplaceStartLeadTime:
		"Installationsstart först när startbeskedet är utfärdat.",
	domain_build_gate_fireplaceStartChecklistWait:
		"Vänta in startbesked innan vedaggregat, skyddsplåtar eller skorsten monteras.",
	domain_build_gate_fireplaceStartChecklistClearanceFallback:
		"Verifiera skyddsavstånd och genomföringsdetaljer mot vald skorsten innan montage.",
	domain_build_gate_fireplaceStartChecklistDocuments:
		"Ha beslut, ritning och produktdokument tillgängliga på plats när installationen börjar.",
	domain_build_gate_fireplaceInspectionTitle: "Sotarbesiktning före handover",
	domain_build_gate_fireplaceInspectionPurpose:
		"Boka installationsbesiktning och samla protokoll innan slutöverlämning och första eldning.",
	domain_build_gate_fireplaceInspectionLeadTime:
		"Boka sotare/skorstensfejartekniker innan handover och slutkontroll.",
	domain_build_gate_fireplaceInspectionChecklistBooking:
		"Boka installationsbesiktning med sotare eller skorstensfejartekniker innan slutkontroll.",
	domain_build_gate_fireplaceInspectionChecklistProtocol:
		"Spara godkänt protokoll tillsammans med övrig byggdokumentation.",
	domain_build_gate_fireplaceInspectionChecklistNoFire:
		"Elda aldrig före slutbesked och godkänd installationsbesiktning.",
	domain_build_timeline_weekendPassSingle: "{count} helgpass",
	domain_build_timeline_weekendPassPlural: "{count} helgpass",
	domain_build_timeline_weekendRangeSingle: "{count} helg",
	domain_build_timeline_weekendRangePlural: "{count} helger",
	domain_build_timeline_weekendRangeBetween: "{min}–{max} helger",
	domain_build_timeline_leadRangeSingle: "{count} veckas väntetid",
	domain_build_timeline_leadRangePlural: "{count} veckors väntetider",
	domain_build_timeline_leadRangeBetween: "{min}–{max} veckors väntetider",
	domain_build_timeline_calendarEstimateNoLead:
		"~{hours} h arbete ≈ {weekendRange}",
	domain_build_timeline_calendarEstimateWithLead:
		"~{hours} h arbete ≈ {weekendRange} + {leadRange}",
	domain_build_timeline_weatherCriticalReason:
		"Nå hit innan regn — stommen ska inte stå öppen när vädret vänder.",

	/* ── Domain: Material Phases ─────────────────────────── */
	domain_phase_foundation: "Grund & plintar",
	domain_phase_deck: "Trall & altan",
	domain_phase_framing: "Stomme & reglar",
	domain_phase_roofExterior: "Tak & fasad",
	domain_phase_interior: "Invändigt & lavar",
	domain_phase_systems: "Aggregat & system",

	/* ── Domain: Chimney ─────────────────────────────────── */
	domain_chimney_kit:
		"Bastuskorsten 1,5 m, Ø220 (rökrör Ø115, regnhuv, regnkrage, genomföringsfläns)",
	domain_chimney_extensionLong: "Förlängning bastuskorsten 1,0 m",
	domain_chimney_extensionShort: "Förlängning bastuskorsten 0,5 m",
	domain_chimney_trimmerHeaders: "Skorstensväxling, växlingsbjälkar",
	domain_chimney_trimmerNoggins: "Skorstensväxling, kortlingar i takgles",
	domain_chimney_dimension: "Skorsten",
	domain_chimney_recommendedSystem:
		"Isolerad stålskorsten för bastuaggregat (Harvia WHP1500-systemet), Ø115 rökrör till Ø220 skorsten",
	domain_chimney_clearanceRule:
		"Minst 100 mm från skorstenens mantel och 500 mm från det oisolerade rökröret till brännbart material.",
	domain_chimney_maintenanceNote:
		"Sotas uppifrån: regnhuven ska gå att lyfta av, så planera säker åtkomst till taket.",
	domain_chimney_fireSealInsulation: "Brandtätning takgenomföring (stenull A1)",
	domain_chimney_throughHouse:
		"Går genom huset: {m} m från bastutaket till nocken, plus 1 m över nock. Varje bjälklag skorstenen passerar behöver en egen brandskyddad genomföring.",
	domain_chimney_throughHouseAssumed:
		"Husets höjd är inte angiven, så vi räknar med {m} m från bastutaket till nocken plus 1 m över nock. Ange den under Rummet bastun står i. Varje bjälklag skorstenen passerar behöver en egen brandskyddad genomföring.",
	domain_chimney_overMaxHeight:
		"Skorstenen blir {m} m från aggregatet, högre än bastuskorstenens maxhöjd på 5 m. Genom ett hus behövs en husskorsten; stäm av med sotaren innan du köper.",

	/* ── Domain: Drainage ────────────────────────────────── */
	domain_drain_slopeShower:
		"Golvlutning 1:100 mot golvbrunn eller dräneringspunkt.",
	domain_drain_slopeNoShower:
		"Säkerställ att golv och mark har lätt fall så att skvättvatten kan torka ut.",
	domain_drain_pipeShower:
		"Minst DN50 till frostfritt djup med inspektionsmöjlighet.",
	domain_drain_pipeNoShower:
		"Makadam under grunden och öppning i syll räcker normalt för ren bastu.",
	domain_drain_adviceShower1:
		"Planera makadam-bädd under grunden för säker avvattning.",
	domain_drain_adviceShower2:
		"Säkra VA-anslutning eller stenkista innan bjälklag stängs.",
	domain_drain_adviceNoShower1: "Lägg kapillärbrytande lager under bastun.",
	domain_drain_adviceNoShower2:
		"Undvik att placera bastun i en lågpunkt där vatten samlas.",
	domain_drain_instrShower:
		"Duschläge: planera golvbrunn, fall och VA-anslutning innan bjälklaget byggs.",
	domain_drain_instrNoShower:
		"Ren bastu: fokusera på markdränering och god luftning under golvet.",
	domain_drain_indoorInstrNoShower: "Inomhus: ingen markdränering, men golvet under bastun ska tåla vatten.",
	domain_drain_indoorAdviceFloor: "Bygg inte på parkett eller heltäckningsmatta. Har rummet en golvbrunn kan bastugolvet få fall mot den.",
	domain_drain_indoorPipeNoShower: "Ingen markdränering behövs inomhus.",
	domain_drain_indoorSlopeNoShower: "Bastun står på befintligt golv. Golvet ska tåla vatten, till exempel klinker eller betong.",
	domain_drain_indoorInstrShower: "Inomhus med dusch: planera golvbrunn och tätskikt i det befintliga rummet.",
	domain_drain_indoorAdviceWetRoom: "Bygg duschdelen som våtrum enligt branschregler (till exempel Säker Vatten, GVK eller BBV) med behörig plattsättare.",
	domain_drain_indoorPipeShower: "Anslut duschen till husets avlopp via en golvbrunn i våtrummet.",

	/* ── Domain: Permit ──────────────────────────────────── */
	/* Legacy tier keys nedan (friggebod/attefall/msgUnder15 m.fl.) renderas bara
	   av intl-flödet; se-marknaden använder domain_permit_se_* sedan PBL-reformen
	   1 december 2025. De svenska värdena hålls reformkorrekta som skyddsnät. */
	domain_permit_friggebod: "Bygglovsbefriad komplementbyggnad",
	domain_permit_attefall: "Bygglovsbefriad komplementbyggnad",
	domain_permit_bygglov: "Bygglov",
	domain_permit_komplementbyggnad: "Bygglovsbefriad komplementbyggnad",
	domain_permit_komplementbyggnadOutsideDetaljplan:
		"Bygglovsbefriad endast utanför detaljplan",
	domain_permit_msgUnder15:
		"Upp till 30 m² är bastun normalt en bygglovsbefriad komplementbyggnad.",
	domain_permit_msg15to30:
		"Upp till 30 m² krävs sedan 1 december 2025 varken bygglov eller anmälan för byggnaden.",
	domain_permit_msgOver30: "Över 50 m² kräver alltid bygglov.",
	domain_permit_msgBoundary:
		"Placera bastun minst 4.5 m från tomtgräns utan skriftligt grannmedgivande.",
	domain_permit_msgFireplace:
		"Vedeldad kamin kräver separat anmälan av eldstad och brandskyddskontroll.",
	domain_permit_indoorCheckStructure: "Om du ändrar bärande konstruktion, brandskydd eller ventilation i huset krävs anmälan till kommunen.",
	domain_permit_indoorMsg: "En bastu som byggs som ett rum i ett befintligt hus är ingen egen byggnad. Bygglovsbefrielsens ytgränser, 4,5 m till tomtgräns och strandskydd gäller därför inte bastun.",
	domain_permit_indoorLabel: "Ej tillämpligt – bastu i befintlig byggnad",
	domain_permit_se_msgExempt:
		"Upp till {maxDetaljplan} m² är bastun en bygglovsbefriad komplementbyggnad (PBL-reglerna från 1 december 2025) – varken bygglov, anmälan eller startbesked krävs för byggnaden.",
	domain_permit_se_msgExemptOutsideDetaljplanOnly:
		"{maxDetaljplan}–{maxOutside} m² är bygglovsbefriat endast utanför detaljplanelagt område. Inom detaljplan krävs bygglov över {maxDetaljplan} m².",
	domain_permit_se_msgOverMax:
		"Över {maxOutside} m² kräver bygglov oavsett om tomten ligger inom eller utanför detaljplan.",
	domain_permit_se_msgTotalArea:
		"Taket gäller per tomt: max {totalDetaljplan} m² sammanlagd bygglovsbefriad byggnadsarea inom detaljplan ({totalOutside} m² utanför).",
	domain_permit_se_msgStrandskydd:
		"Inom strandskyddat område krävs strandskyddsdispens även när bygglov inte behövs.",
	domain_permit_checkArea:
		"Kontrollera byggnadsarean mot 30 m² (inom detaljplan) respektive 50 m² (utanför detaljplan).",
	domain_permit_checkBoundary:
		"Verifiera 4.5 m till tomtgräns eller säkra grannmedgivande.",
	domain_permit_checkFireplace:
		"Planera in eldstadsanmälan och sotarbesiktning.",
	domain_permit_checkElectrical:
		"Verifiera att elmatningen kan anslutas enligt lokala krav.",
	domain_permit_se_checkArea:
		"Kontrollera byggnadsarean mot {maxDetaljplan} m² (inom detaljplan) respektive {maxOutside} m² (utanför detaljplan).",
	domain_permit_se_checkTotalArea:
		"Summera tomtens alla bygglovsbefriade komplementbyggnader mot {totalDetaljplan}/{totalOutside} m²-taken.",
	domain_permit_se_checkRidgeHeight:
		"Verifiera att nockhöjden är högst {maxRidge} m.",
	domain_permit_se_checkStrandskydd:
		"Kontrollera om tomten ligger inom strandskydd – då krävs dispens trots bygglovsbefrielsen.",
	domain_permit_panorama_glassPercentExceeded:
		"Panoramaglas på {wall} täcker {percent}% av väggen. Gränsen är {maxPercent}%.",
	domain_permit_panorama_safetyGlassRequired:
		"Panoramaglas på {wall} är {glassAreaSqm} m². Kontrollera säkerhetsglas och märkning.",
	domain_permit_wallFront: "framväggen",
	domain_permit_wallBack: "bakväggen",
	domain_permit_wallLeft: "vänstra väggen",
	domain_permit_wallRight: "högra väggen",

	/* ── Domain: Pricing ─────────────────────────────────── */
	domain_pricing_comparatorNote:
		"Marknadsjämförelse inkluderar paketmarginal för prefabricering, försäljning och projektkoordination utöver en komplett DIY-budget.",
	domain_pricing_allowanceDeliveryRoundingLabel:
		"Leverans, inköpsavrundning och spillmarginal",
	domain_pricing_allowanceDeliveryRoundingNote:
		"Fångar leverans, avrundning mot handelslängder och de småpåslag som normalt uppstår i ett DIY-projekt.",
	domain_pricing_allowanceHiddenSuppliesLabel:
		"Dolda förbrukningsposter och slutmontage",
	domain_pricing_allowanceHiddenSuppliesNote:
		"Täcker kompletteringar som fortfarande dyker upp trots full BOM: extra infästning, förbrukning, tätning och slutfinish.",
	domain_pricing_allowanceProfessionalServicesLabel: "Fackmannasteg",
	domain_pricing_allowanceProfessionalServicesNote:
		"Summerar de steg där modellen redan markerar behov av fackman, till exempel elektriker för elaggregat.",
	domain_pricing_allowanceMarketPackagingLabel:
		"Paketmarginal för prefabricering, sälj och samordning",
	domain_pricing_allowanceMarketPackagingNote:
		"Används bara i marknadsjämförelsen för att förklara skillnaden mot färdiga byggsatser och paketpriser.",

	/* ── Domain: Placement ───────────────────────────────── */
	domain_place_tipElectrical:
		"Placera bastun nära befintlig elmatning för att minska kabeldragning och markarbete.",
	domain_place_tipDrainageShower:
		"Välj en plats där dränering och VA-anslutning kan lösas frostfritt.",
	domain_place_tipDrainageNoShower:
		"Undvik lågpunkter där vatten kan bli stående under grunden.",
	domain_place_tipWoodAirflow:
		"Vedeldad bastu mår bäst av fri luftning kring skorsten och tydligt avstånd till bostad.",
	domain_place_checkBoundary:
		"☐ Minst 4.5 m till tomtgräns eller skriftligt grannmedgivande.",
	domain_place_checkWoodDistance:
		"☐ Minst 8 m till bostad eller verifierat brandskyddsavstånd.",
	domain_place_checkElectricDistance:
		"☐ Kontrollera avstånd till andra byggnader och välj obrännbar omgivning nära befintlig elmatning.",
	domain_place_checkDrainShower:
		"☐ Säkerställ frostfri dragning för avlopp/dränering.",
	domain_place_checkDrainNoShower:
		"☐ Säkerställ fall från bastun så att marken dränerar bort vatten.",
	domain_place_indoorCheckFloor: "☐ Kontrollera att golvet tål vatten och att rummet är högt nog för bastuns tak.",
	domain_place_indoorCheckElectric: "☐ Kontrollera att husets huvudsäkring räcker för aggregatet och låt en elinstallatör dra en egen grupp.",
	domain_place_indoorCheckWood: "☐ Vedkamin inomhus kräver skorsten genom huset och eldstadsanmälan. Prata med sotaren innan du väljer ved.",
	domain_place_indoorTipVentilation: "Välj ett rum där bastun kan ta tilluft nära aggregatet och släppa ut frånluften till rummet eller utomhus.",

	/* ── Domain: Heater ──────────────────────────────────── */
	domain_heater_elReqWood:
		"Vedeldad bastu: planera el endast för belysning, styrning och eventuell fläkt.",
	domain_heater_elReqElectric: "{voltage}, Säkring: {fuse}A",
	domain_heater_warningUpfuse:
		"Varning: Kräver ofta uppsäkring av fastighetens huvudsäkring.",
	domain_heater_warningOverLargestStep:
		"Rummet motsvarar {volume} m³, men det största effektsteget är {kw} kW. Ett sådant aggregat värmer inte rummet: dela det med en mellanvägg eller välj ett aggregat vars rumsvolym enligt tillverkaren täcker {volume} m³.",
	domain_heater_modelFit_undersized:
		"{model} räcker till {maxM3} m³, men bastun motsvarar {volumeM3} m³. Välj en starkare modell.",
	domain_heater_modelFit_oversized:
		"{model} är gjord för minst {minM3} m³, men bastun motsvarar {volumeM3} m³. Välj en mindre modell.",

	/* ── Domain: Weight ──────────────────────────────────── */
	domain_weight_adviceLight:
		"Materialet väger lite och kan köras hem på ett standard obromsat släp (B-körkort).",
	domain_weight_adviceMedium:
		"Vikten överstiger 600 kg. Du måste köra två vändor med vanligt släp, eller hyra ett tungt boggiesläp.",
	domain_weight_adviceHeavy:
		"Tung transport! Hemleverans med kranbil från bygghandeln rekommenderas.",

	/* ── Domain: Ergonomics ──────────────────────────────── */
	domain_ergo_adviceOk:
		"Optimal sitthöjd. Fötterna befinner sig i varmluften ovanför kaminens stenar.",
	domain_ergo_adviceFail:
		"Kallras-risk! Fotlaven hamnar under kaminens stenar.",
	domain_ergo_warningFail:
		"Fotlaven hamnar under kaminens stenar — badaren fryser om fötterna. Höj innertaket eller välj ett lägre aggregat.",

	/* ── Domain: Heater clearance ────────────────────────── */
	domain_heaterClearance_obstacle_wall: "vägg",
	domain_heaterClearance_obstacle_bench: "lave",
	domain_heaterClearance_obstacle_ceiling: "innertak",
	domain_heaterClearance_obstacle_partition: "mellanvägg",
	domain_heaterClearance_violation:
		"Skyddsavstånd till {obstacle}: {actualMm} mm — kräver minst {requiredMm} mm (BBR 5:4 / tillverkarens monteringsanvisning).",

	/* ── BBR: Heater clearance section ───────────────────── */
	bbr_heaterClearanceTitle: "Skyddsavstånd aggregat",
	bbr_heaterClearanceIntro:
		'Minsta avstånd från aggregatet till brännbart material (lavar, väggar, innertak). Visa zonen i 3D-vyn med lagret "Skyddsavstånd".',
	bbr_heaterClearanceSide: "Sida (min)",
	bbr_heaterClearanceFront: "Front (min)",
	bbr_heaterClearanceCeiling: "Tak (min)",
	bbr_heaterClearanceOk:
		"Inga intrång i skyddszonen. Håll zonen fri — inga handdukar, hyllor eller annat brännbart.",
	bbr_heaterClearanceShieldNote:
		"Avstånden i sid- och frontled förutsätter strålskydd (ingår i ritningen). Utan strålskydd gäller tillverkarens oskyddade avstånd, typiskt 500 mm för vedeldat.",

	/* ── Domain: Professional Guidance ───────────────────── */
	domain_prof_foundationLabel: "Grund & bjälklag",
	domain_prof_foundationReason:
		"Kan normalt utföras själv om markförhållandena är enkla.",
	domain_prof_framingLabel: "Väggstommar",
	domain_prof_framingReason: "Snickeriarbete lämpar sig väl för DIY.",
	domain_prof_systemsLabel: "Aggregat, ventilation & el",
	domain_prof_systemsElectricType: "Auktoriserad elektriker",
	domain_prof_systemsElectricReason:
		"Elaggregat ska anslutas av auktoriserad elektriker.",
	domain_prof_systemsWoodReason:
		"Ventilation, skyddsskivor och kaminplacering kan normalt förberedas själv.",
	domain_prof_chimneyLabel: "Skorsten & brandskydd",
	domain_prof_chimneyType: "Sotare / skorstensinstallatör",
	domain_prof_chimneyReason:
		"Vedeldad bastu kräver brandsäker skorstensinstallation och sotarbesiktning.",
	domain_prof_drainageLabel: "Dränering & avlopp",
	domain_prof_drainageType: "VVS-montör",
	domain_prof_drainageReason:
		"Duschläge med golvbrunn och VA-anslutning kräver normalt fackman.",

	/* ── Domain: Roof ────────────────────────────────────── */
	domain_roof_mono: "Pulpettak",
	domain_roof_indoorCeiling: "Plant innertak under husets tak",
	domain_roof_gable: "Nocktak",
	domain_roof_barrel: "Tunnformat tak",
	domain_roof_felt_roof: "Ytpapp på råspont",
	domain_roof_sheet_metal: "Bandtäckt/plåt på råspont",
	domain_roof_free_drip: "Fri droppkant",

	/* ── Domain: Ventilation ─────────────────────────────── */
	domain_vent_woodAdvice:
		"VEDELDAT: Skorstenen agerar frånluft under badet. Ventilen högt upp SKA VARA STÄNGD när ni badar, och öppnas först efteråt för att vädra ur fukten (torkventil).",
	domain_vent_woodMechWarning:
		"LIVSFARA: Mekanisk frånluftsfläkt får normalt INTE användas med en vedeldad kamin. Fläkten skapar ett undertryck som kan suga in livsfarlig kolmonoxid och rök baklänges från skorstenen in i bastun!",
	domain_vent_elNaturalAdvice:
		"EL (SJÄLVDRAG): Klassisk lösning (krav från t.ex. äldre Tylö-aggregat). Kall luft dras in under kaminen och stiger. Kräver ingen fläkt.",
	domain_vent_elNaturalWarning:
		"Risk för skiktad värme (varma öron, kalla fötter) eftersom varmluften smiter ut direkt nära taket. Bygg lavarna så högt upp mot taket som möjligt!",
	domain_vent_elMechAdvice:
		"EL (MEKANISK DOWNDRAFT): Premiumlösning för jämn värme (Rek. av Harvia)! Fläkten suger ut luften nere vid golvet och tvingar ner värmen över badarnas fötter. Kanalfläkt i frånluftsröret är ett absolut krav.",
	domain_vent_singleRoom_woodAdvice:
		"ENKELZON (VEDELDAT): Tilluft och torkventil hör till basturummet eftersom ingen separat relaxzon finns. Skorstenen driver frånluften under bad och torkventilen öppnas efteråt.",
	domain_vent_singleRoom_elNaturalAdvice:
		"ENKELZON (EL, SJÄLVDRAG): Placera tilluft under aggregatet och frånluft i samma basturum nära taket eftersom ingen relaxzon tar frånluften.",
	domain_vent_singleRoom_elMechAdvice:
		"ENKELZON (EL, MEKANISK): Mekanisk frånluft ska suga från basturummet, inte från en relaxzon. Dimensionera fläkten för hela bastuvolymen.",
	domain_heater_glassPenaltyWarning:
		"Ditt fönster läcker för mycket värme. Byt till ett {kw} kW aggregat eller gör fönstret mindre.",
	domain_vent_panorama_infiltrationWarning:
		"PANORAMAGLAS: Stor glasyta ger högre luftläckagebaslinje än en tät vägg. Kontrollera tätningar och dimensionera ventiler för marginal.",

	/* ── Domain: Foundation warnings ─────────────────────── */
	domain_found_warningGroundHigh: "Marken ligger för högt mot bärlinan.",
	domain_found_warningPlinthShort:
		"Vald plintlängd räcker inte för minsta nedgrävning.",

	/* ── PDF Export ───────────────────────────────────────── */
	pdf_heading: "Materiallista & Prisuppskattning",
	pdf_3dOverview: "3D-översikt",
	pdf_materialList: "Materiallista",
	pdf_materialListByPhase: "Materiallista per inköpsfas",
	pdf_colMaterial: "Material",
	pdf_colDimension: "Dimension",
	pdf_colQuantity: "Åtgång",
	pdf_colPrice: "Pris (ca)",
	pdf_totalCost: "Uppskattad totalkostnad (material)",
	pdf_diyBudget: "Uppskattad självbyggarbudget",
	pdf_marketPackage: "Marknadsjämförelse / byggsats",
	pdf_buildPlan: "Byggplan & Checklista",
	pdf_cutList: "Kapnota",
	pdf_cutColPart: "Del",
	pdf_cutColCount: "Antal",
	pdf_cutColLength: "Kapas till längd",
	pdf_techDetails: "Tekniska Uppgifter",
	pdf_productRecs: "Produktrekommendationer",
	pdf_generated: "Genererad:",
	pdf_openings: "Öppningar:",
	pdf_roofLabel: "Tak:",
	pdf_heatingLabel: "Uppvärmning:",
	pdf_heaterWood: "Vedeldad kamin",
	pdf_heaterElectric: "Elaggregat",
	pdf_currencyUnit: "kr",
	pdf_fileSuffix: "_materiallista",
	pdf_timeEstimate: "Tid: ca",
	pdf_timeUnit: "timmar",
	pdf_controlPrefix: "Kontroll",
	pdf_effectiveVolume: "Effektiv volym:",
	pdf_recommendedPower: "Rekommenderad effekt:",
	pdf_electricalReq: "Elkrav:",
	pdf_chimneyLabel: "Skorsten:",
	pdf_footerLine1:
		"OBS: Priserna är ungefärliga och baserade på genomsnittliga svenska detaljhandelspriser 2025/2026.",
	pdf_footerLine2:
		"Faktiska priser varierar beroende på leverantör, region och säsong. Kontrollera alltid aktuella priser.",

	/* ── Live running cost (builder) ──────────────────────── */
	runningCost_heatUpLabel: "Uppvärmning",
	runningCost_glassLabel: "Glas i bastun",
	runningCost_sessionCostLabel: "Per bad",
	runningCost_monthlyCostLabel: "Per månad",
	runningCost_minutesShort: "min",
	runningCost_kwShort: "kW",
	runningCost_woodNote: "Schablon: ca 15 kg björk per bad",
	runningCost_electricNote: "Uppskattad elkostnad",
	runningCost_ariaSummary:
		"Uppvärmning {minutes} minuter, cirka {cost} per bad.",
	runningCost_drawerHeading: "Drift",
	runningCost_thermalHeading: "Med dina val",

	/* ── Spec Pill / Summary Rail ─────────────────────────── */
	specPill_ariaLabel: "Uppskattat pris {cost}, yta {area} m².",
	specPill_ariaLabelAction: "Klicka för materialöversikt.",
	specPill_est: "Uppsk.",
	specPill_heatUp: "{time} uppvärmning",
	drawer_eyebrow: "Materialöversikt",
	drawer_closeAriaLabel: "Stäng materialöversikt",
	rail_projectStatus: "Projektstatus",
	rail_defaultProjectName: "Ny Bastu",
	rail_hide: "Dölj",
	rail_status: "Status",
	rail_panelAriaLabel: "Projektöversikt",
	rail_nextStepLabel: "Nästa steg",
	rail_nextStepFallback: "Kontrollera byggunderlaget",
	rail_planReadyTitle: "Din plan är klar",
	rail_designDetails: "Designdetaljer",
	safetyNotice_title: "{count} att granska",
	safetyNotice_review: "Öppna Regler",
	workspace_navAriaLabel: "Byggarens arbetsytor",
	rail_planReadyHint: "Ritningar, materiallista, kapnota och byggsteg i en PDF att ta med till bygghandeln.",

	/* ── Design Insights panel ────────────────────────────── */
	insights_buttonLabel: "Insikter",
	insights_title: "Designinsikter",
	insights_subtitle:
		"Allt som beräknats för din design samlat på ett ställe – sök, granska och hoppa direkt till detaljerna.",
	insights_searchPlaceholder: "Sök i specifikationer …",
	insights_close: "Stäng",
	insights_empty: "Inga insikter matchar din sökning.",
	insights_openWorkspace: "Öppna {label}",
	insights_statusOk: "Ser bra ut",
	insights_statusWarning: "Se över",
	insights_statusDanger: "Åtgärd krävs",
	insights_groupHeater: "Aggregat & värme",
	insights_groupVentilation: "Ventilation",
	insights_groupErgonomics: "Lavar & ergonomi",
	insights_groupRoof: "Tak & snölast",
	insights_groupPermit: "Bygglov & placering",
	insights_groupDrainage: "Avlopp",
	insights_groupElectrical: "El & kablage",
	insights_groupCost: "Kostnad & tidsplan",
	insights_labelHeaterPower: "Rekommenderad effekt",
	insights_labelElectrical: "El-krav",
	insights_labelVentFan: "Mekanisk fläkt",
	insights_labelLoyly: "Löyly-höjd",
	insights_labelFloorDrain: "Golvbrunn",
	insights_labelMaterialCost: "Materialkostnad",
	insights_labelProCost: "Hantverkare (uppskattat)",
	insights_labelProSteps: "Steg som kräver fackman",
	insights_weekendValue: "≈ {n} helger",

	/* ── Workspace labels ─────────────────────────────────── */
	workspace_designLabel: "Design",
	workspace_designTask: "Justera mått, öppningar och värme direkt i modellen.",
	workspace_designHint:
		"När formen sitter kan du börja planera inköpen fas för fas.",
	workspace_designNext: "Se inköpslista",
	workspace_shoppingLabel: "Inköp",
	workspace_shoppingTask:
		"Planera inköpen fas för fas och fånga transportkrav tidigt.",
	workspace_shoppingHint:
		"När materialet känns rätt går du vidare till kapnotan.",
	workspace_shoppingNext: "Se kapnota",
	workspace_cutlistLabel: "Kapnota",
	workspace_cutlistTask:
		"Bekräfta exakta kaplängder innan du börjar kapa och bygga.",
	workspace_cutlistHint:
		"När kaplistan stämmer kan du gå vidare till prisbilden.",
	workspace_cutlistNext: "Se prisbild",
	workspace_pricingLabel: "Pris",
	workspace_pricingTask: "Se totalpris, prisdrivare och rekommenderade köp.",
	workspace_pricingHint:
		"När budgeten håller kan du gå vidare till byggplanen.",
	workspace_pricingNext: "Gå till byggplan",
	workspace_buildLabel: "Bygg",
	workspace_buildTask:
		"Starta från grunden och följ byggordningen steg för steg.",
	workspace_buildHint:
		"Avsluta med att dubbelkolla regler, avstånd och installation.",
	workspace_buildNext: "Kontrollera regler",
	workspace_rulesTask:
		"Kontrollera regler, avstånd och anmälningar före byggstart.",
	workspace_rulesHint:
		"Dubbelkolla eldstad, placering och el innan du sätter igång.",

	/* ── Workspace-flik-badges + kompletthet ─────────────── */
	workspace_badgeRows_one: "{count} rad",
	workspace_badgeRows_other: "{count} rader",
	workspace_badgeRulesOk: "inga anmärkningar",
	workspace_badgeRulesFlags_one: "{count} flagga",
	workspace_badgeRulesFlags_other: "{count} flaggor",
	workspace_badgeStepsUnit: "steg",
	workspace_badgeStepsDoneOf: "av",
	completeness_label: "Design",
	completeness_complete: "allt ifyllt",
	completeness_missingOpenings: "dörr eller fönster",
	completeness_missingPostal: "postnummer",
	completeness_join: ", ",
	completeness_missingSuffix: "saknas",

	/* ── Stillsam milstolpsbekraftelse ───────────────────── */
	milestone_rulesAllClear: "Alla regelkontroller gröna",
	milestone_completenessNote: "Alla designval på plats",

	/* ── Builder summary labels ──────────────────────────── */
	summary_type: "Typ",
	summary_size: "Storlek",
	summary_roof: "Tak",
	summary_area: "Area",
	summary_openings: "Öppningar",
	summary_heating: "Värme",
	summary_heaterWood: "Vedeldad kamin",
	summary_heaterElectric: "Elaggregat",
	summary_postalPrefix: "Postnr",

	/* ── Builder misc ────────────────────────────────────── */
	build_startHere: "Starta här",
	build_progressLocalNote:
		"Dina avbockade steg sparas bara på den här enheten. Spara projektet i ditt konto för att behålla dem mellan enheter.",
	badge_autosaved: "Autosparad",
	badge_autosavedHint: "Sparad i ditt konto.",
	toolbar_draftLocal: "Sparat på den här enheten",
	toolbar_draftLocalHint: "Finns kvar i den här webbläsaren. Logga in för att spara den på ditt konto och öppna den var som helst.",
	toolbar_undoTitle: "Ångra",
	toolbar_undoLabel: "Ångra",
	toolbar_redoTitle: "Gör om",
	toolbar_redoLabel: "Gör om",
	toolbar_shareTitle: "Dela din design",
	toolbar_shareLabel: "Dela projekt",
	toolbar_shareCopied: "Länk kopierad!",

	history_buttonLabel: "Historik",
	history_buttonTitle: "Visa ändringshistorik",
	history_menuLabel: "Senaste ändringar",
	history_empty: "Inga ändringar än.",
	history_currentBadge: "Nu",
	history_currentStep: "Nuvarande steg",
	history_jumpUndo: "Ångra tillbaka hit",
	history_jumpRedo: "Gör om fram hit",
	history_fieldValue: "{label} → {value}",
	history_fieldChanged: "Ändrade {label}",
	history_toggledOn: "Slog på: {label}",
	history_toggledOff: "Slog av: {label}",
	history_layerShown: "Visar: {label}",
	history_layerHidden: "Döljer: {label}",
	history_deckAdded: "Altan tillagd",
	history_deckRemoved: "Altan borttagen",
	history_openingAdded: "Lade till {type} ({wall})",
	history_openingRemoved: "Tog bort {type} ({wall})",
	history_openingMoved: "Flyttade {type} ({wall})",
	history_openingResized: "Ändrade storlek: {type} ({wall})",
	history_openingChanged: "Ändrade {type} ({wall})",
	history_openingsChanged: "Ändrade öppningar",
	history_templateApplied: "Mall tillämpad",
	history_initialState: "Utgångsläge",
	history_change: "Ändring",
	history_labelGlassArea: "Glasyta",
	history_labelStoneArea: "Stenyta",
	history_labelHeaterPlacement: "Aggregatets placering",
	history_labelLayers: "Lager i vyn",
	history_labelLocation: "Platsval",
	history_labelRotation: "Orientering",
	history_labelBenchLayout: "Lavlayout",
	history_labelBenchAdded: "Lav tillagd",
	history_labelBenchRemoved: "Lav borttagen",
	history_labelHeaterMoved: "Aggregatplacering",
	domain_interior_variant_straight: "Rak lav",
	domain_interior_variant_twoTier: "Dubbel lav (övre + fotlav)",
	domain_interior_variant_lShape: "L-formad lav",
	domain_interior_variant_uShape: "U-formad lav",
	domain_interior_issue_heaterClearance:
		"Laven kommer för nära aggregatet: {actualMm} mm mot kravet {requiredMm} mm.",
	domain_interior_issue_doorSwing:
		"Laven står i dörrens svepyta ({swingDepthMm} mm framför dörren).",
	domain_interior_issue_doorEntry:
		"Laven står precis innanför dörren ({entryDepthMm} mm), så man kliver rakt på den.",
	domain_interior_issue_freeFloor:
		"För lite fri golvyta: {actualSqm} m² kvar mot kravet {requiredSqm} m².",
	domain_interior_issue_benchDepth:
		"Lavdjupet är {actualMm} mm — {requiredMm} mm behövs.",
	domain_interior_issue_benchOverlap: "Två lavar överlappar varandra.",
	domain_interior_issue_loylyHeight:
		"Löylyns lag: takhöjden behöver vara minst {minCeilingMm} mm, den är {actualCeilingMm} mm.",
	domain_interior_issue_benchStepHeight:
		"Fotlaven ligger {actualMm} mm över golvet. Över {maxMm} mm behövs ett fotsteg eller en tredje lav, eller en lägre vägg.",
	domain_interior_capacity_summary:
		"{seats} sittplatser, {lyingSpots} liggplatser",

	// ── Planvy (issue 132) ──
	plan_view_modeGroup: "Vyläge",
	plan_view_mode3d: "3D",
	plan_view_modePlan: "Planvy",
	plan_view_title: "Planvy — lavar, aggregat och dörr sedda uppifrån",
	plan_view_variantsLabel: "Börja från",
	plan_view_zoomGroup: "Zoom",
	plan_view_zoomIn: "Zooma in",
	plan_view_zoomOut: "Zooma ut",
	plan_view_zoomReset: "Återställ zoom",
	interior_planHint: "Välj en lav för att ändra mått. Dra för att flytta.",
	interior_edit: "Redigera",
	interior_done: "Klart",
	interior_properties: "Lavens egenskaper",
	interior_back: "Tillbaka till design",
	interior_selected: "Vald lavdel",
	interior_relaxBench: "Relaxbänk",
	interior_length: "Längd",
	interior_depth: "Djup",
	interior_start: "Från väggens början",
	interior_wallGap: "Avstånd från väggen",
	interior_manage: "Designa lavar",
	interior_add: "Lägg till lav",
	interior_duplicate: "Kopiera lav",
	interior_remove: "Ta bort lav",
	interior_noSpace: "Ingen ledig plats för denna lav. Ändra layouten eller måtten och försök igen.",
	interior_support: "Monteringssätt",
	interior_supportAuto: "Automatiskt",
	interior_supportFloor: "Golvben",
	interior_supportWall: "Väggupplag",
	interior_supportFront: "Väggupplag och främre ben",
	interior_supportEnds: "Ändupplag",
	interior_heightGroup: "Flytta höjd tillsammans",
	interior_heightGroupHint: "Välj lavdelar i samma rum. Kopplade delar behåller höjdskillnaden när du ändrar sitthöjden.",
	interior_linkHeight: "Koppla höjd",
	interior_alignHeight: "Samma sitthöjd",
	interior_unlinkHeight: "Frigör denna lav",
	interior_front: "Lavfront",
	interior_frontOpen: "Öppen",
	interior_frontSlatted: "Spjälfront på ben",
	interior_backrest: "Väggmonterat ryggstöd",
	interior_backrestLength: "Ryggstödets längd",
	interior_backrestStart: "Ryggstödets start på laven",
	interior_backrestGap: "Avstånd ovanför sits",
	interior_backrestBoards: "Antal ryggbrädor",
	interior_woodSpecies: "Träslag för lavdelen",
	interior_woodFollowRoom: "Följ rummets träslag",
	interior_slatGap: "Springa mellan sittbrädor",
	interior_slatHint: "Sittbrädorna fördelas jämnt över djupet. Inköpsmått 28×90 mm; vid egen springbredd visar kapnotan brädornas färdiga bredd efter klyvning. Trävalet gäller också lavdelens front och ryggstöd.",
	domain_interior_issue_benchSlats: "Välj en springa mellan 6 och 25 mm som lämnar minst 45 mm breda sittbrädor.",
	interior_backrestHint: "Ryggstödet följer sitthöjden och består av 28×90 mm brädor med 18 mm mellanrum. Kräver väggkontakt och infästning i väggens stomme.",
	domain_interior_issue_benchBackrest: "Ryggstödet behöver en sluten vägg, rymmas inom lavens längd och stanna under taket. Kontrollera placering och mått.",
	domain_interior_issue_benchFront: "Spjälfronten kräver golvben och tillräcklig höjd för en bräda. Välj öppen front eller ändra monteringssätt.",
	interior_supportHint: "Väggupplag kräver bärande infästning. Ändupplag kräver kontakt med båda ändväggarna. Spännvidd och infästning behöver dimensioneras.",
	domain_interior_issue_benchSupport: "Valt monteringssätt saknar väggkontakt eller träffar en öppning/glasvägg. Välj golvben eller ändra placeringen.",
	interior_section: "Sidovy",
	interior_sectionHint: "Dra höjdhandtaget uppåt/nedåt eller djuphandtaget åt sidan. Piltangenter flyttar 10 mm, Skift + pil 100 mm.",
	interior_headroom: "Till tak",
	interior_sectionHeight: "Ändra sitthöjd",
	interior_sectionDepth: "Ändra lavdjup",
	interior_empty: "Inga lavar ännu. Lägg till en lav för att börja.",
	interior_clipped: "Aggregatet begränsar byggd längd till {lengthMm} mm.",
	interior_seatHeight: "Sitthöjd från golv",
	domain_interior_issue_benchHeadroom: "Det är {actualMm} mm mellan sittytan och väggtoppen. Rekommenderat utrymme är {requiredMm} mm.",
	domain_interior_issue_benchHeight: "Sitthöjden måste vara mellan {minMm} och {maxMm} mm från golvet.",
	interior_tier: "Nivå",
	interior_apply: "Tillämpa ändringar",
	interior_applyHint: "Måtten anpassas till rummet. Material, pris och kapnota uppdateras när du tillämpar ändringen.",
	interior_selectHint: "Välj en lav i planvyn eller i interiörens redigeringsläge.",
	interior_invalidDimensions: "Ange giltiga mått för lavdelen.",
	plan_view_benchUpper: "Övre lav",
	plan_view_benchLower: "Fotlav",
	plan_view_heaterHandle: "Aggregat — dra för att flytta",
	plan_view_doorHandle: "Dörr — dra längs väggen",
	plan_view_capacityLabel: "Kapacitet",
	plan_view_capacitySeats_one: "{count} sittplats",
	plan_view_capacitySeats_other: "{count} sittplatser",
	plan_view_capacityLying_one: "{count} liggplats",
	plan_view_capacityLying_other: "{count} liggplatser",
	plan_view_capacitySummary: "{seats}, {lying}",
	plan_view_issue_openingBounds:
		"Dörren hamnar utanför väggens tillåtna område.",
	plan_view_issue_openingOverlap: "Dörren överlappar en annan öppning.",
	plan_view_unavailable: "Planvyn är inte tillgänglig för den här bastutypen.",
	plan_view_pdfTitle: "Planritning",
	plan_view_pdfScale: "Skala 1:{denominator}",
	plan_view_pdfLegendBench: "Lav",
	plan_view_pdfLegendHeater: "Aggregat",
	term_benchLedger: "Lavbärlina (upplag mot vägg)",
	term_benchFrontBoard: "Lavfront (frontbräda)",
	term_benchFrame: "Lavstomme (reglar & ben)",
	term_benchScrews: "Lavskruv (ram & sittbrädor)",
	term_benchSlatsCut: "Lavbrädor",
	term_benchLedgerCut: "Lavbärlina",
	term_benchBackRailCut: "Bakre lavregel",
	term_benchFrameCut: "Lavstomme",
	term_benchLegsCut: "Lavben",
	term_benchBackrestCut: "Ryggstöd lav",
	term_benchBackrestSpacersCut: "Ryggstöd distanser",
	term_benchSkirtCut: "Lavfront spjälor",
	term_benchEndRailsCut: "Lavstomme gavlar",
	term_benchJoistsCut: "Lavstomme tvärbalkar",
	term_bench_upper: "övre",
	term_bench_lower: "nedre",

	shareDialog_title: "Visa upp din bastu",
	shareDialog_subtitle:
		"Så här ser designen ut för den du skickar länken till.",
	shareDialog_previewAlt: "3D-vy av {project}, {size}",
	shareDialog_previewCaption: "Förhandsbild av din design.",
	shareDialog_previewUnavailable:
		"Ingen förhandsvisning just nu – 3D-vyn kunde inte fångas. Länken fungerar ändå.",
	shareDialog_summaryHeading: "Det här ser mottagaren",
	shareDialog_projectLabel: "Projekt",
	shareDialog_sizeLabel: "Yttermått",
	shareDialog_priceLabel: "Prisuppskattning",
	shareDialog_linkLabel: "Delningslänk",
	shareDialog_copyError:
		"Kunde inte kopiera – markera länken och kopiera manuellt.",
	shareDialog_nativeShare: "Dela",
	shareDialog_downloadImage: "Ladda ner bild",
	shareDialog_downloadFallbackName: "bastu",
	shareDialog_shareText: "Titta vad jag ritat: {project}",
	toolbar_saveLabel: "Spara projekt",
	toolbar_saveTitleAnon: "Logga in för att spara utkastet i ditt konto.",
	toolbar_saveTitleAuthed: "Spara till ditt konto.",
	degraded_saveTitle:
		"Det går inte att spara till kontot just nu. Din design finns kvar i den här webbläsaren, och Ladda ner PDF fungerar.",
	degraded_authTitle: "Inloggning är inte tillgänglig",
	degraded_saveLabel: "Spara projekt (inte tillgängligt)",
	degraded_authBody:
		"Kontotjänsten kunde inte anslutas, så inloggning och registrering är tillfälligt avstängda. Byggaren, guiderna och kalkylatorerna fungerar som vanligt utan konto.",
	degraded_dashboardBody:
		"Kontotjänsten kunde inte anslutas, så sparade projekt kan inte visas just nu. Byggaren fungerar ändå fullt ut.",
	toolbar_savingLabel: "Sparar…",
	toolbar_downloadPdf: "Ladda ner PDF",
	toolbar_renderPhoto: "Generera offertbild",
	toolbar_rendering: "Renderar…",
	toolbar_menu: "Meny",
	toolbar_more: "Mer",
	toolbar_shareShort: "Dela",
	toolbar_editGroup: "Ändringar",
	toolbar_projectLabel: "Projektnamn",
	toolbar_projectPlaceholder: "t.ex. Trädgårdsbastu",
	toolbar_buildHeading: "Bygg din bastu",
	toolbar_typeSquare: "Fyrkantig bastu",
	toolbar_typeIndoor: "Inomhusbastu",
	toolbar_typeBarrel: "Bastutunna",
	toolbar_typeTwoRoom: "Tvårumsbastu",
	store_loginToSave: "Logga in för att spara",
	store_cannotSave: "Kan inte spara",
	store_cannotSaveInvalidOpenings: "Kan inte spara: ogiltiga öppningar",
	store_saved: "Sparad ✓",
	store_createdAndSaved: "Skapad & sparad ✓",
	store_couldNotSave: "Kunde inte spara",
	store_autoSaved: "Auto-sparad ✓",
	store_autoSaveFailed: "Auto-save misslyckades",
	store_cannotAutoSave: "Kan inte auto-spara",
	store_cannotAutoSaveInvalidOpenings:
		"Kan inte auto-spara: ogiltiga öppningar",
	modal_close: "Stäng",
	modal_renderTitle: "Fotorealistisk rendering",
	modal_renderAlt: "Renderad bastu",
	modal_renderDownload: "Ladda ner",
	camera_side: "Sida",
	camera_interior: "Interiör",

	/* ── Footer ────────────────────────────────────────────── */
	footer_brand: "Bygg en bastu",
	footer_tagline:
		"Gratis planeringsverktyg för att designa din utomhusbastu med 3D, materiallistor och byggplan.",
	footer_colTools: "Verktyg",
	footer_colGuides: "Guider",
	footer_colCompany: "Om oss",
	footer_privacy: "Integritet",
	footer_about: "Om",
	footer_contact: "Kontakt",
	footer_press: "Press",
	footer_designer: "Bastuplaneraren",
	footer_costGuide: "Vad kostar en bastu?",
	footer_buildGuide: "Bygga bastu – Guide",
	footer_allGuides: "Alla guider",
	footer_rentalLink: "bastuhyra.se",
	footer_rentalLabel: "Hyr en bastu",
	footer_copyright: "© 2026 Bygg en bastu. Alla rättigheter förbehållna.",

	/* ── Privacy page ─────────────────────────────────────── */
	privacy_title: "Integritetspolicy",
	privacy_author: "Bygg en bastu",
	privacy_datePublished: "5 april 2026",
	privacy_intro:
		"Bygg en bastu är ett gratis planeringsverktyg för bastuprojekt. Vi respekterar din integritet och samlar bara in den data som behövs för att tjänsten ska fungera.",
	privacy_whatWeCollectTitle: "Vad vi samlar in",
	privacy_whatWeCollectBody:
		"När du använder vår bastuplanerare kan vi behandla följande kategorier av data:",
	privacy_dataAuth:
		"Kontodata — e-postadress och hashat lösenord, lagras i Supabase Auth.",
	privacy_dataProjects:
		"Projektdata — bastudesigner du sparar till ditt konto.",
	privacy_dataAnalytics:
		"Användningsstatistik — anonym sidvisnings- och interaktionsdata (se nedan).",
	privacy_analyticsTitle: "Analys",
	privacy_analyticsBody:
		"Vi använder två integritetsfokuserade analysverktyg för att förstå hur verktyget används:",
	privacy_analyticsClarityDesc:
		"Sessionsreprisering och heatmaps. Ingen persondata samlas in. Microsoft hanterar data enligt deras integritetspolicy.",
	privacy_analyticsSimpleDesc:
		"Cookiefri, integritetsvänlig sidvisningsanalys. Ingen persondata lagras.",
	privacy_cookiesTitle: "Cookies",
	privacy_cookiesBody:
		"Bygg en bastu använder enbart nödvändiga cookies för autentisering (Supabase-sessionstoken). Vi använder inga reklam- eller tredjepartsspårningscookies.",
	privacy_authTitle: "Autentisering",
	privacy_authBody:
		"Kontoinloggning hanteras av Supabase. Ditt lösenord hashas och lagras aldrig i klartext. Du kan radera din kontodata när som helst via applikationens inställningar.",
	privacy_thirdPartyTitle: "Tredjepartstjänster",
	privacy_thirdPartySupabase: "Databas, autentisering och lagring (EU-region).",
	privacy_thirdPartyClarity:
		"Anonym sessionsreprisering och värmekartläggning.",
	privacy_thirdPartySimple: "Cookiefri analys, GDPR-kompatibel.",
	privacy_yourRightsTitle: "Dina rättigheter",
	privacy_yourRightsBody:
		"Du har rätt att ta del av, korrigera eller radera dina personuppgifter när som helst. Du kan exportera dina projektdata som PDF och begära fullständig kontoradering via appen eller genom att kontakta oss.",
	privacy_contactTitle: "Frågor",
	privacy_contactBody: "För integritetsfrågor, kontakta oss på",

	/* ── About page ───────────────────────────────────────── */
	about_title: "Om Bygg en bastu",
	about_author: "Bygg en bastu",
	about_datePublished: "5 april 2026",
	about_mission:
		"Bygg en bastu hjälper dig planera, visualisera och beräkna ditt bastuprojekt — från den första skissen till en verifierad materiallista.",
	about_whatIsTitle: "Vad är Bygg en bastu?",
	about_whatIsBody:
		"Bygg en bastu är ett gratis webbaserat planeringsverktyg för bastur. Det genererar en live 3D-modell, beräknar bärande dimensioner, producerar materiallistor med kapnotor och ger BBR-baserad vägledning för bygget.",
	about_howItWorksTitle: "Så fungerar det",
	about_howStep1: "Välj bastuform — fyrkantig, tunnbastu eller tvårums.",
	about_howStep2: "Ställ in mått, uppvärmning, öppningar och markförhållanden.",
	about_howStep3:
		"Granska den automatiska materiallistan, prisuppskattningen och byggplanen.",
	about_howStep4: "Exportera en PDF eller dela din design med en länk.",
	about_whoTitle: "Vilka ligger bakom detta?",
	about_whoBody:
		"Bygg en bastu är ett självständigt projekt byggt av ett litet team som brinner för att göra bastuplanering tillgänglig. Verktyget växte ur ett personligt behov: att planera en bastu i trädgården utan dyr konsulting eller CAD-mjukvara.",
	about_disclaimerTitle: "Viktig information",
	about_disclaimerBody:
		"Vår bastuplanerare ger planeringsunderlag och referensantaganden — inte godkända bygghandlingar. Verifiera alltid konstruktion, el, brandskydd och tillståndskrav med lokala fackfolk innan bygget påbörjas.",

	/* ── Contact page ─────────────────────────────────────── */
	contact_title: "Kontakta oss",
	notFound_metaTitle: "Sidan finns inte | Bygg en bastu",
	notFound_title: "Sidan finns inte",
	notFound_body: "Adressen leder inte till någon sida här. Den kan ha flyttats, eller så har ett tecken blivit fel.",
	notFound_home: "Till startsidan",
	notFound_guides: "Se alla guider",
	contact_author: "Bygg en bastu",
	contact_datePublished: "5 april 2026",
	contact_intro:
		"Har du en fråga, hittat en bugg, eller vill föreslå en funktion? Vi vill gärna höra från dig.",
	contact_emailLabel: "Maila oss direkt",
	contact_feedbackTitle: "Funktionsönskemål & buggar",
	contact_feedbackBody:
		"Vi bearbetar aktivt feedback för att förbättra verktyget. Om du hittar ett fel i materialberäkningar, byggreglersreferenser eller annat — hör av dig så undersöker vi.",
	contact_responseTitle: "Svarstid",
	contact_responseBody:
		'Vi svarar normalt inom 2–3 arbetsdagar. Vid brådskande ärenden, skriv "brådskande" i ämnesraden.',

	/* ── Landing FAQ (GEO) ────────────────────────────────── */
	landing_faqTitle: "Vanliga frågor om att bygga utomhusbastu",
	landing_faq1Q: "Vad kostar det att bygga en egen utomhusbastu?",
	landing_faq1A:
		"Det beror mest på storlek, aggregat och glas. Vi har räknat på de två bastur som verktyget börjar med. Enrumsbastun, {oneRoomSize} m med asppanel och vedkamin, landar på ungefär {oneRoomPrice} i material. {preset}, en tvårumsbastu på {lakesideSize} m med relaxrum och panoramafönster, landar på ungefär {lakesidePrice}. I enrumsbastun står kaminen, den isolerade skorstenen och värmeskydden för {heaterBlock} av det. Granpanel, färre fönster eller ett mindre rum drar ner den. Kostnadsguiden går igenom listan rad för rad.",
	landing_faq2Q: "Behöver jag bygglov för en bastu i Sverige?",
	landing_faq2A:
		"I de flesta fall inte. Sedan 1 december 2025 får du bygga en bygglovsbefriad komplementbyggnad på upp till 30 m² inom detaljplan (50 m² utanför) utan vare sig bygglov eller anmälan, så länge den placeras minst 4,5 m från tomtgräns (eller med grannens skriftliga medgivande) och nockhöjden är högst 4,5 m. Taket per tomt är 45 m² sammanlagt inom detaljplan (65 m² utanför). En vedkamin kräver fortfarande en separat eldstadsanmälan till kommunen, och strandskyddet gäller som vanligt.",
	landing_faq3Q: "Vedeldad eller el — vad är bäst för en utomhusbastu?",
	landing_faq3A:
		"En vedkamin ger en traditionell löyly-upplevelse med mjuk strålningsvärme och fungerar utan el, men kräver certifierad skorstensinstallation och årlig sotning. Ett elaggregat är enklare att installera och reglera — ställ bara in termostaten — men kräver 3-fas (400 V) för aggregat över 4,5 kW. Välj ved för känslan, el för bekvämligheten.",
	landing_faq4Q: "Vilket trä ska jag använda till en utomhusbastu?",
	landing_faq4A:
		"Använd tryckimpregnerad gran till stommen och golvbjälkarna eftersom de ligger nära markfukt. Till invändig panel och lavar passar obehandlad asp eller al — båda håller sig svala vid beröring och tål höga temperaturer utan att vrida sig. Fasaden görs bäst i värmebehandlad furu (thermoträ) eller lärk, som klarar väder utan kemisk behandling.",
	landing_faq5Q: "Hur lång tid tar det att bygga en bastu själv?",
	landing_faq5A:
		"En händig hemmafixare kan färdigställa en fyrkantig utomhusbastu för fyra personer på 4–8 helger (ungefär 60–120 timmar). Grund och stomme tar cirka två helger, tak och fasad ytterligare två, och isolering, invändig panel, lavar och aggregatinstallation fyller resten. Fackmässiga steg — elanslutning och skorstensbesiktning — lägger till 1–2 bokade besök.",

	/* ── Landing: Popular Guides ─────────────────────────── */
	landing_guidesTitle: "Populära guider",
	landing_guidesIntro:
		"Allt du behöver veta innan spaden går i marken — bygglov, material, ventilation, aggregat och takdimension.",
	landing_guideBuildTitle: "Bygga bastu – komplett guide",
	landing_guideBuildBlurb: "Steg-för-steg från grund till slutkontroll",
	landing_guideCostTitle: "Vad kostar det?",
	landing_guideCostBlurb: "Pris-guide 2026, självbygge vs hantverkare",
	landing_guidePermitTitle: "Bygglov bastu",
	landing_guidePermitBlurb:
		"Bygglovsbefriad komplementbyggnad eller bygglov – nya regler 2025",
	landing_guidePanelTitle: "Bastupanel",
	landing_guidePanelBlurb: "Asp, al eller gran? Pris och egenskaper",
	landing_guideVentTitle: "Ventilation",
	landing_guideVentBlurb: "Tilluft, frånluft, bastufolie-montering",
	landing_guideHeaterTitle: "Elaggregat",
	landing_guideHeaterBlurb: "kW-dimensionering och säkring",
	landing_guidesAll: "Se alla guider →",

	/* ── SEO ──────────────────────────────────────────────── */
	seo_title: "Bygg en bastu – rita utomhusbastun i 3D med materiallista",
	seo_description:
		"Bygg din egen utomhusbastu med professionella beräkningar, 3D-visualisering och materiallistor enligt svenska byggregler.",

	/* ── Common / reusable ───────────────────────────────── */
	common_loading: "Laddar…",
	common_error: "Något gick fel.",
	common_retry: "Försök igen",
	errorBoundary_title: "Något gick fel",
	errorBoundary_body:
		"Vi har fått en notis och tittar på det. Försök ladda om sidan — om problemet kvarstår, kontakta oss.",
	errorBoundary_action: "Ladda om",
	common_save: "Spara",
	common_cancel: "Avbryt",
	common_close: "Stäng",
	common_yes: "Ja",
	common_no: "Nej",
	common_or: "eller",

	/* ── Builder toasts ───────────────────────────────────── */
	toast_doorAdded: "Dörr tillagd",
	toast_windowAdded: "Fönster tillagt",
	toast_doorRemoved: "Dörr borttagen",
	toast_windowRemoved: "Fönster borttaget",
	toast_heaterChanged: "Uppvärmning ändrad till {type}",

	/* ── Term: Material & Part Names (i18n for builder tables) ── */
	term_concretePier: "Betongplint",
	term_treatedBearer: "Bärlina Tryckimpregnerad",
	term_floorRoofJoists: "Golv- & Takbjälkar",
	term_wallStudsSillPlate: "Väggreglar, Syll, Hammarband",
	term_wallStudsDivision: "Väggreglar (Ytter+Delning)",
	term_mineralWoolInsulation: "Stenullsisolering",
	term_saunaFoil: "Åldersbeständig Bastufolie",
	term_furringStrips: "Spikläkt / Glespanel",
	term_saunaPanelSpruce: "Bastupanel (t.ex. Gran/Asp)",
	term_saunaPanelAspen: "Bastupanel (Bastudel)",
	term_interiorPanelLounge: "Invändig Panel (Relaxdel)",
	term_benchTimber: "Lav-virke (Kvistfritt)",
	term_moistureResistantFloor: "Fukttåligt golv / Trall",
	term_exteriorCladding: "Ytterpanel (Spontad Gran)",
	term_exteriorFurring: "Utv. Spikläkt (Liggande)",
	term_exteriorBattenSpacer: "Utv. Ströläkt (Luftspalt)",
	term_windBarrierBoard: "Vindskydd (skiva/duk)",
	term_dim_windBarrier: "Vindskyddsskiva / diffusionsöppen duk",
	term_cornerTrim: "Knutbrädor",
	term_baseTrim: "Nederkantsavslut",
	term_fasciaBoard: "Vindskivor (Fascia)",
	term_soffitBoard: "Takfotsavslut / Undertak",
	term_doorAndAccessories: "Dörr & Tillbehör",
	term_doorsAndAccessories: "Dörrar & Tillbehör",
	term_subfloor: "Undergolv / Trossbotten",
	term_subfloorLedger: "Trossbottenläkt",
	term_dim_asphaltBoard: "12 mm asfaboard",
	term_staveTimber: "Stavvirke (Värmebehandlat)",
	term_endCaps: "Gavlar (Limträlaminat)",
	term_steelBands: "Stålband",
	term_cradles: "Vaggor / Stöd",
	term_floorBoards: "Golvbrädor (inre)",
	term_benchTimberBarrel: "Bastulav-virke (Kvistfritt)",
	term_saunaDoor: "Bastudörr (Glas)",
	term_heaterUnit: "Bastuaggregat + Rökrör",
	term_vents: "Ventiler",
	term_deckBoard: "Trallbräda",
	term_joist: "Regel",
	term_bearer: "Bärlina",
	term_deckFascia: "Kantbräda",
	term_nogging: "Kortling",
	term_deckScrew: "Trallskruv",
	term_bearersCut: "Bärlinor",
	term_floorJoistsCut: "Golvbjälkar",
	term_roofJoistsCut: "Takbjälkar",
	term_roofJoistsGlulam: "Takbjälkar (limträ)",
	term_roofJoistsGlulamCut: "Takbjälkar (limträ, dimensioneras av konstruktör)",
	term_dim_glulamPlaceholder:
		"Dimensioneras av konstruktör (ritad som 45×220, riktpris limträ 56×225)",
	term_sillPlateCut: "Syll / Hammarband",
	term_sillBottomCut: "Syllbotten",
	term_topPlateCut: "Hammarband",
	term_wallStudsFrontCut: "Stående Väggreglar (Framsida)",
	term_wallStudsBackCut: "Stående Väggreglar (Baksida)",
	term_wallStudsSidesCut: "Stående Väggreglar (Sidor)",
	term_fasciaBoardsCut: "Vindskivor",
	term_fasciaFrontBackCut: "Vindskivor (Fram/Bak)",
	term_exteriorCladdingCut: "Ytterpanel (Fasad)",
	term_cornerTrimCut: "Knutbrädor",
	term_baseTrimCut: "Nederkantsavslut",
	term_soffitBoardCut: "Takfotsavslut / Undertak",
	term_stavesCut: "Stavar",
	term_endCapsCut: "Gavelskivor",
	term_steelBandsCut: "Stålband",
	term_cradlesCut: "Vaggor",
	term_floorBoardsCut: "Golvbrädor",
	term_dividerSillPlateCut: "Delningsvägg Syll/Hammarband",
	term_dividerStudsCut: "Stående Reglar (Delningsvägg)",
	term_subfloorCut: "Undergolv / Trossbotten",
	term_fasciaEndCut: "Vindskivor / Fasadavslut",
	term_deckBoardsCut: "Trallbrädor",
	term_joistsCut: "Reglar",
	term_bearersDeckCut: "Bärlinor",
	term_deckFasciaCut: "Kantbrädor",
	term_noggingsCut: "Kortlingar",
	term_purchase: "inköp",
	term_waste: "spill",

	/* ── Intl material coverage (svenska = oförändrad se-output) ── */
	term_openingHeader: "Avväxling",
	term_doorCasing: "Dörrfoder",
	term_panoramaHeader: "Panoramaavväxling",
	term_windowApron: "Fönsterbröstning",
	term_windowCasing: "Fönsterfoder",
	term_panoramaUpperSupport: "Panorama överstöd",
	term_panoramaLowerSupport: "Panorama understöd",
	term_panoramaSupport: "Panoramastöd",
	term_side_right: "höger",
	term_side_left: "vänster",
	term_wall_outer: "yttervägg",
	term_partition_junction: "mellanväggsanslutning",
	term_wall_long: "långvägg",
	term_dim_saunaFixture: "IP-klassad / värmetålig",
	term_dim_singleLayerMembrane: "1-lag tätskikt",
	term_dim_lacqueredSheet: "Lackerad plåt",
	term_dim_prefoldedSheet: "Prefalsad/plåt",
	term_cut_runningWallAngle: "Löpande mot vägg/takvinkel, cirka {count} lpm",

	/* ── Units ──────────────────────────────────────────────── */
	term_unit_pcs: "st",
	term_unit_lm: "lpm",
	term_unit_set: "sats",

	/* ── Quantity phrases ──────────────────────────────────── */
	term_qty_wall: "Vägg",
	term_qty_roofFloor: "Tak&Golv",
	term_qty_roof: "Tak",
	term_qty_floor: "Golv",
	term_qty_saunaSection: "Bastudel",
	term_qty_loungeSection: "Relaxdel",
	term_qty_incl: "Inkl.",
	term_qty_aluTape: "Alu-tejp",
	term_qty_saunaDoor: "Bastudörr",
	term_qty_exteriorDoor: "Ytterdörr",
	term_qty_interiorDoor: "Mellendörr",
	term_qty_vents: "Ventiler",
	term_qty_heaterUnit: "Aggregat",
	term_qty_screws: "Skruv",
	term_qty_window: "Fönster",
	term_qty_woodRecommended: "Vedeldad rekommenderas",
	term_qty_supplyExhaust: "Tilluft + Frånluft",
	term_qty_approx: "ca",

	/* ── Dimension phrases ─────────────────────────────────── */
	term_dim_cover: "täck",
	term_dim_board: "skiva",
	term_indoorOuterPanel: "Ytterpanel (Spontad Gran), fristående väggar",
	term_indoorFibreboard: "Träfiberskiva mot befintlig vägg",
	term_indoorOuterPanelCut: "Ytterpanel (fristående väggar)",
	term_dim_airGap: "luftspalt",
	term_dim_structuralTimber: "K-virke",
	term_ceilingPanelCut: "Innertakspanel",
	term_dim_roofUnderlay: "Takunderlag",
	term_saunaLightFixture: "Bastuarmatur",
	term_dim_ipRatedHeatResistant: "IP-klassad / värmetålig",
	term_wiringAccessories: "Kopplingsmaterial",
	term_siliconeCable: "Silikonkabel",
	term_dim_clipsBoxesConduit: "Klammer, dosor och skyddsrör",
	term_dim_hotZoneWiring: "Varmzonsel",

	/* ── Cut-length construction phrases ───────────────────── */
	term_cut_perRoofSlope: "per takfall",
	term_cut_overhang: "överhäng",
	term_cut_ceilingJoistNoOverhang: "innertaksbjälke, inget överhäng",
	term_cut_overlap: "överlapp",
	term_cut_cutOnSite: "Kapas på plats",
	term_cut_cutAt: "Kapas med",
	term_cut_panelCutOnSite: "Skivkapas på plats till",
	term_cut_gables: "gavlar",
	term_cut_gableCut: "gaveltillskärning",
	term_cut_gablePeak: "gavelspets",
	term_cut_gableSidesFlat: "gavelsidor plana",
	term_cut_angleCut: "snitt",
	term_cut_ascendingLength: "stigande längd från bak till fram",
	term_cut_ridgeRoof: "nocktak",
	term_cut_shedRoof: "pulpettak",
	term_cut_sidesTapered: "sidor trapetskapas och front byggs upp för",
	term_cut_matchRoofPitch: "mot taklutning",
	term_cut_circularSawn: "Cirkelsågad",
	term_cut_profileCut: "Profilsågad",
	term_cut_corners: "hörn",
	term_cut_door: "dörr",
	term_cut_around: "runt",
	term_cut_follows: "följer",
	term_cut_and: "och",
	term_cut_topPlate: "hammarband",
	term_cut_sillPlate: "syll",

	/* ── Electrical BOM terms ──────────────────────────────── */
	term_el_ceilingSpots: "Takspots (infälld belysning)",
	term_el_wallLightHigh: "Vägglampa (hög)",
	term_el_heaterConnection: "Bastuaggregat anslutning",
	term_el_ledStripLow: "LED-strip (låg, under lav)",
	term_el_cable: "Kabel",
	term_el_siliconeCable: "Värmebeständig Silikonkabel (SiHF 3×1.5 mm², 180°C)",
	term_el_standardCable: "Standard Kabel (EKK 3×1.5 mm²)",
	term_el_hotZoneWarning:
		"Ovanför 500 mm får standard VP-rör och PVC-kabel (t.ex. EKK/FKX) inte användas: de smälter vid cirka 70 °C.",
	term_el_transformerWarning:
		"Placera transformatorn utanför bastun, om den inte sitter längst ner vid golvet (under 500 mm).",

	/* ── Term: Additional material names (roof, foundation, systems) ── */
	term_postShoe: "Stolpsko / infästning",
	term_groundFabricMat: "Markduk",
	term_drainageGravel: "Dräneringsgrus / makadam",
	term_aluTapeMat: "Alutejp / fogtejp",
	term_stainlessScrews: "Rostfri skruv / beslagspaket",
	term_surfaceTreatment: "Ytbehandling / färg / olja",
	term_controlPanel: "Styrpanel",
	term_roofDecking: "Råspont",
	term_roofingUnderlay: "Underlagspapp",
	term_eaveFlashing: "Takfotsplåt",
	term_vergeFlashing: "Vindskiveplåt",
	term_ridgeCapping: "Nockbeslag",
	term_roofingFelt: "Ytpapp",
	term_sheetMetalRoofing: "Takplåt",
	term_standingSeamRoofing: "Bandtäckt takplåt",
	term_partitionBlocking: "Kortling för mellanväggsanslutning",

	/* ── Dimension phrases (additional) ────────────────────── */
	term_dim_foundationBracket: "Grundinfästning",
	term_dim_geotextile: "Geotextil",
	term_dim_baseLayer: "Grundlager",
	term_dim_frameInteriorFastening: "Stomme och invändig infästning",
	term_dim_facadeExposedTimber: "Fasad och utsatta träytor",
	term_dim_bandsHardwareFastening: "Band, beslag och infästning",
	term_dim_externalIntegrated: "Extern/integrerad",

	/* ── Quantity unit (additional) ─────────────────────────── */
	term_unit_pack: "paket",

	/* ── Domain: Comparison Advisor (reason keys) ────────────── */
	domain_comp_reasonPermitOk:
		"Har minst bygglovsfriktion och ligger i ett tryggare myndighetsläge.",
	domain_comp_reasonPermitLower:
		"Har lägre regelrisk än alternativen trots att kontroller fortfarande behövs.",
	domain_comp_reasonBestEconomy:
		"Ger bäst totalekonomi när materialkostnad och drift vägs ihop.",
	domain_comp_reasonEasiestBuild:
		"Är lättare att bygga med kortare planerad insats och färre tunga specialiststeg.",
	domain_comp_reasonPractical:
		"Är mer praktisk att få hem och färdigställa utan onödig logistikfriktion.",
	domain_comp_reasonNoChimney:
		"Slipper eldstadsanmälan, skorsten och det extra brandskyddssteget som vedalternativen drar med sig.",
	domain_comp_reasonNoPermitStop:
		"Behåller bättre fart i projektet eftersom du minskar risken för sena lov- eller anmälningsstopp.",
	domain_comp_reasonBestBalance:
		"Landar bäst i balans mellan budget, byggbarhet och risk just nu.",

	/* ── Domain: Comparison Advisor (caution keys) ───────────── */
	domain_comp_cautionPermitFull: "Fullt bygglov krävs innan byggstart.",
	domain_comp_cautionPermitNotice:
		"Bygglovsläget beror på detaljplan – stäm av kommunens krav tidigt.",
	domain_comp_cautionFireplace: "Vedeldad lösning kräver eldstadsanmälan.",
	domain_comp_cautionFireDistance:
		"Planera minst {distance} m brandavstånd till närmaste byggnad.",
	domain_comp_cautionShower: "Duschläge kräver dränering och VA-planering.",

	/* ── Domain: Comparison Advisor (heater label) ───────────── */
	domain_comp_heaterWood: "Vedeldad kamin",
	domain_comp_heaterElectric: "Elaggregat",
	domain_comp_permitFallback: "Kontroll krävs",

	/* ── Domain: Cable Spec (key-based labels) ───────────────── */
	domain_cable_fuse_1x10A: "1×10A enfas",
	domain_cable_fuseLightingGroup: "Separat grupp för belysning/styrning enligt elektriker",
	domain_cable_typeFeed: "{size} EKLK",
	bbr_approxLength: "ca {m} m",
	bbr_hotZoneCableRule: "Ovanför {mm} mm är varm zon: använd {silicone}, inte {standard}.",
	domain_cable_fuse_1x16A: "1×16A enfas",
	domain_cable_fuse_3x10A: "3×10A trefas",
	domain_cable_fuse_3x16A: "3×16A trefas",
	domain_cable_fuse_3x20A: "3×20A trefas",
	domain_cable_fuse_3x25A: "3×25A trefas",
	domain_cable_rcd:
		"Jordfelsbrytare 30 mA: OBLIGATORISK för bastuns elinstallation.",
	domain_cable_rcdObligatory: "Jordfelsbrytare 30 mA: OBLIGATORISK",
	domain_cable_typeWoodBell:
		"Zonstyrd belysningskabel enligt SEK, ingen kraftmatning till vedkamin.",
	domain_cable_warningWood:
		"Vedeldad kamin kräver inte kraftmatning, men belysning i varm zon ska alltid gå med SiHF-kabel.",
	domain_cable_warningLargeUnit:
		"Större aggregat kräver normalt trefas och bör verifieras mot fastighetens huvudsäkring.",

	/* ── Term: Missing material patterns from engines ────────── */
	term_heaterStones: "Aggregatsten",
	term_ceilingPanelSauna: "Bastupanel (Innertak bastudel)",
	term_ceilingPanel: "Bastupanel (Innertak)",
	term_electricHeater: "Elaggregat",
	term_window: "Fönster",
	term_ceilingPanelLounge: "Invändig panel (Innertak relaxdel)",
	term_interiorDoor: "Mellendörr",
	term_panoramaGlass: "Panoramaglas",
	term_heatShield: "Strålskydd",
	term_ceilingBattens: "Takgles / Spikläkt (Innertak)",
	term_crownMoulding: "Taklist / Bomlist",
	term_exteriorDoor: "Ytterdörr",

	/* ── Term: Missing dimension phrases ────────────────────── */
	term_dim_woodBurningStove: "Vedeldad kamin",
	term_fireBoardCalciumSilicate: "Brandskiva kalciumsilikat",
	term_feedTunnelSeal: "Brandtätning eldningstunnel",
	term_dim_fireBoardBothFaces: "1220×1000×50 mm, båda sidor om genomföringen",
	term_dim_feedTunnelSeal: "Obrännbar stenull A1 runt tunneln",
	term_dim_hardenedGlassDoor: "Härdat glas / träknopp",
	term_dim_midSegment: "Mellansegment",
	term_dim_interiorGlassDoor: "Invändig glasdörr",
	term_dim_insulatedGlassLounge: "Isolerglas relaxdel",
	term_dim_insulatedGlass: "Isolerglas",
	term_dim_temperedInsulatedGlass: "Härdat isolerglas (6H + 6H)",
	term_dim_heaterShieldPlate: "Skyddsplåt vid aggregat",
	term_dim_entranceDoor: "Entré / ytterdörr",
	term_dim_aluminium: "Aluminium",
};
